/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * PwC Intelligent Tax Analytics API
 * OpenAPI spec version: 1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
    MutationFunction,
    QueryFunction,
    QueryKey,
    UseMutationOptions,
    UseMutationResult,
    UseQueryOptions,
    UseQueryResult,
} from '@tanstack/react-query';
import { useCallback } from 'react';
import type {
    AddFolderPersonasRequest,
    AddProcessRequest,
    ApplicationVersionResponse,
    ChatWithExtractionRequest,
    ChatWithExtractionResponse,
    CompleteProcessExportRequest,
    CompleteProcessExportResponse,
    ContactPersonResponse,
    CreateApplicationContactRequest,
    CreateFillPdfResponse,
    CreateFolderRequest,
    CreateTenantContactRequest,
    CreateTenantRequest,
    CreateUserRequest,
    DeactivateDocumentTypeRequest,
    DeactivateExtractionTemplateRequest,
    DeleteDocumentsRequest,
    DeleteUploadedDocumentRequestModel,
    DocumentType,
    DocumentTypeFieldsWithValidationResponse,
    DocumentTypeRequest,
    DocumentTypeResponse,
    DownloadDocumentsRequest,
    DownloadDocumentsResponse,
    DownloadExampleExportTemplateRequest,
    DownloadExampleExportTemplateResponse,
    DownloadExportTemplateResponse,
    EditContactPersonRequest,
    EditFolderRequest,
    EditPolicyRequest,
    EditProcessRequest,
    EditTenantRequest,
    EditUserRequest,
    ExtractionExportRequest,
    ExtractionExportResponse,
    FillOnlineFormUploadResponse,
    FillPdfUploadResponse,
    FolderHierarchyResponse,
    FolderResponse,
    GenerateExcelTemplateRequest,
    GenerateExcelTemplateResponse,
    GenerateUploadTemplateRequest,
    GenerateUploadTemplateResponse,
    GetClassificationResponse,
    GetExtractedFieldsResponse,
    GetExtractionTemplatesRequest,
    GetExtractionTemplatesResponse,
    GetOnlineFormFieldsResponse,
    GetProcessExportHistoryResponse,
    GetV1BusinessMetricsSuperAdminUserLoginsParams,
    GetV1DocumentClassificationGetClassificationParams,
    GetV1DocumentClassificationGetExtractedFieldsParams,
    GetV1DocumentClassificationGetSasUrlOnlyParams,
    GetV1DocumentTypeDocumentTypeIdDocumentTypeFieldsParams,
    GetV1FillOnlineFormGetOnlineFormFieldsParams,
    GetV1FolderFolderIdPotentialUsersParams,
    GetV1FolderFolderIdUsersParams,
    GetV1FolderParams,
    GetV1ProcessGetDocumentsProcessingInProcessProcessIdParams,
    GetV1ProcessGetOnlineFormsInProcessProcessIdParams,
    GetV1ProcessGetProcessesInFolderFolderIdParams,
    GetV1ProcessGetRecentlyAccessedProcessesParams,
    GetV1ProcessGetUploadedDocumentsInProcessProcessIdParams,
    GetV1TemplatesDownloadExportTemplateParams,
    GetV1TenantSuperAdminParams,
    GetV1UserAdminParams,
    GetValidationConfigRequest,
    GetValidationConfigResponse,
    ModifyFolderPersonasRequest,
    PaginatedFolderResponse,
    PaginatedFolderUsersResponse,
    PaginatedOnlineFormsResponse,
    PaginatedPotentialFolderUserResponse,
    PaginatedProcessResponse,
    PaginatedProcessUploadedDocumentsResponse,
    PaginatedProcessingDocumentsResponse,
    PaginatedRecentProcessAccessResponse,
    PaginatedTenantResponse,
    PaginatedUserLoginsResponse,
    PaginatedUserResponse,
    PolicyResponse,
    PolicyVersionResponse,
    PostV1FillOnlineFormUploadExcelBody,
    PostV1FillPdfCreateBody,
    PostV1FillPdfUploadExcelBody,
    PostV1TemplatesUploadExportTemplateBody,
    ProcessHierarchyResponse,
    ProcessResponse,
    ProcessTypeResponse,
    PutV1FolderFolderIdDeletePersonaParams,
    PutV1TenantSuperAdminRestoreTenantIdParams,
    RoleResponse,
    SightlineFilterRequest,
    SightlineFilterResponse,
    TenantResponse,
    ToggleValidationEnabledRequest,
    UpdateClassificationDTO,
    UpdateDocumentReadyForSubmissionRequest,
    UpdateDocumentTypeFieldsRequest,
    UpdateExtractedFieldsDTO,
    UpdateValidationConfigRequest,
    UploadDocumentsRequestModel,
    UploadDocumentsResponseModel,
    UploadRequestCompleteModel,
    UserInfoResponse,
    UserLoginsSummaryResponse,
    UserPreferencesRequest,
    UserPreferencesResponse,
    UserResponse,
} from './models';
import { useCustomAxios } from '../mutator/custom-instance';
import type { ErrorType } from '../mutator/custom-instance';

export const usePostV1AdminUpdateDocumentTypeFieldsHook = () => {
    const postV1AdminUpdateDocumentTypeFields = useCustomAxios<void>();

    return useCallback(
        (updateDocumentTypeFieldsRequest: UpdateDocumentTypeFieldsRequest) => {
            return postV1AdminUpdateDocumentTypeFields({
                url: `/v1/Admin/UpdateDocumentTypeFields`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: updateDocumentTypeFieldsRequest,
            });
        },
        [postV1AdminUpdateDocumentTypeFields]
    );
};

export const usePostV1AdminUpdateDocumentTypeFieldsMutationOptions = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<
            ReturnType<
                ReturnType<typeof usePostV1AdminUpdateDocumentTypeFieldsHook>
            >
        >,
        TError,
        { data: UpdateDocumentTypeFieldsRequest },
        TContext
    >;
}): UseMutationOptions<
    Awaited<
        ReturnType<
            ReturnType<typeof usePostV1AdminUpdateDocumentTypeFieldsHook>
        >
    >,
    TError,
    { data: UpdateDocumentTypeFieldsRequest },
    TContext
> => {
    const { mutation: mutationOptions } = options ?? {};

    const postV1AdminUpdateDocumentTypeFields =
        usePostV1AdminUpdateDocumentTypeFieldsHook();

    const mutationFn: MutationFunction<
        Awaited<
            ReturnType<
                ReturnType<typeof usePostV1AdminUpdateDocumentTypeFieldsHook>
            >
        >,
        { data: UpdateDocumentTypeFieldsRequest }
    > = (props) => {
        const { data } = props ?? {};

        return postV1AdminUpdateDocumentTypeFields(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type PostV1AdminUpdateDocumentTypeFieldsMutationResult = NonNullable<
    Awaited<
        ReturnType<
            ReturnType<typeof usePostV1AdminUpdateDocumentTypeFieldsHook>
        >
    >
>;
export type PostV1AdminUpdateDocumentTypeFieldsMutationBody =
    UpdateDocumentTypeFieldsRequest;
export type PostV1AdminUpdateDocumentTypeFieldsMutationError = ErrorType<void>;

export const usePostV1AdminUpdateDocumentTypeFields = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<
            ReturnType<
                ReturnType<typeof usePostV1AdminUpdateDocumentTypeFieldsHook>
            >
        >,
        TError,
        { data: UpdateDocumentTypeFieldsRequest },
        TContext
    >;
}): UseMutationResult<
    Awaited<
        ReturnType<
            ReturnType<typeof usePostV1AdminUpdateDocumentTypeFieldsHook>
        >
    >,
    TError,
    { data: UpdateDocumentTypeFieldsRequest },
    TContext
> => {
    const mutationOptions =
        usePostV1AdminUpdateDocumentTypeFieldsMutationOptions(options);

    return useMutation(mutationOptions);
};

export const usePostV1AdminGetValidationConfigHook = () => {
    const postV1AdminGetValidationConfig =
        useCustomAxios<GetValidationConfigResponse>();

    return useCallback(
        (getValidationConfigRequest: GetValidationConfigRequest) => {
            return postV1AdminGetValidationConfig({
                url: `/v1/Admin/GetValidationConfig`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: getValidationConfigRequest,
            });
        },
        [postV1AdminGetValidationConfig]
    );
};

export const usePostV1AdminGetValidationConfigMutationOptions = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<
            ReturnType<ReturnType<typeof usePostV1AdminGetValidationConfigHook>>
        >,
        TError,
        { data: GetValidationConfigRequest },
        TContext
    >;
}): UseMutationOptions<
    Awaited<
        ReturnType<ReturnType<typeof usePostV1AdminGetValidationConfigHook>>
    >,
    TError,
    { data: GetValidationConfigRequest },
    TContext
> => {
    const { mutation: mutationOptions } = options ?? {};

    const postV1AdminGetValidationConfig =
        usePostV1AdminGetValidationConfigHook();

    const mutationFn: MutationFunction<
        Awaited<
            ReturnType<ReturnType<typeof usePostV1AdminGetValidationConfigHook>>
        >,
        { data: GetValidationConfigRequest }
    > = (props) => {
        const { data } = props ?? {};

        return postV1AdminGetValidationConfig(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type PostV1AdminGetValidationConfigMutationResult = NonNullable<
    Awaited<
        ReturnType<ReturnType<typeof usePostV1AdminGetValidationConfigHook>>
    >
>;
export type PostV1AdminGetValidationConfigMutationBody =
    GetValidationConfigRequest;
export type PostV1AdminGetValidationConfigMutationError = ErrorType<void>;

export const usePostV1AdminGetValidationConfig = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<
            ReturnType<ReturnType<typeof usePostV1AdminGetValidationConfigHook>>
        >,
        TError,
        { data: GetValidationConfigRequest },
        TContext
    >;
}): UseMutationResult<
    Awaited<
        ReturnType<ReturnType<typeof usePostV1AdminGetValidationConfigHook>>
    >,
    TError,
    { data: GetValidationConfigRequest },
    TContext
> => {
    const mutationOptions =
        usePostV1AdminGetValidationConfigMutationOptions(options);

    return useMutation(mutationOptions);
};

export const usePostV1AdminUpdateValidationConfigHook = () => {
    const postV1AdminUpdateValidationConfig = useCustomAxios<void>();

    return useCallback(
        (updateValidationConfigRequest: UpdateValidationConfigRequest) => {
            return postV1AdminUpdateValidationConfig({
                url: `/v1/Admin/UpdateValidationConfig`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: updateValidationConfigRequest,
            });
        },
        [postV1AdminUpdateValidationConfig]
    );
};

export const usePostV1AdminUpdateValidationConfigMutationOptions = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<
            ReturnType<
                ReturnType<typeof usePostV1AdminUpdateValidationConfigHook>
            >
        >,
        TError,
        { data: UpdateValidationConfigRequest },
        TContext
    >;
}): UseMutationOptions<
    Awaited<
        ReturnType<ReturnType<typeof usePostV1AdminUpdateValidationConfigHook>>
    >,
    TError,
    { data: UpdateValidationConfigRequest },
    TContext
> => {
    const { mutation: mutationOptions } = options ?? {};

    const postV1AdminUpdateValidationConfig =
        usePostV1AdminUpdateValidationConfigHook();

    const mutationFn: MutationFunction<
        Awaited<
            ReturnType<
                ReturnType<typeof usePostV1AdminUpdateValidationConfigHook>
            >
        >,
        { data: UpdateValidationConfigRequest }
    > = (props) => {
        const { data } = props ?? {};

        return postV1AdminUpdateValidationConfig(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type PostV1AdminUpdateValidationConfigMutationResult = NonNullable<
    Awaited<
        ReturnType<ReturnType<typeof usePostV1AdminUpdateValidationConfigHook>>
    >
>;
export type PostV1AdminUpdateValidationConfigMutationBody =
    UpdateValidationConfigRequest;
export type PostV1AdminUpdateValidationConfigMutationError = ErrorType<void>;

export const usePostV1AdminUpdateValidationConfig = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<
            ReturnType<
                ReturnType<typeof usePostV1AdminUpdateValidationConfigHook>
            >
        >,
        TError,
        { data: UpdateValidationConfigRequest },
        TContext
    >;
}): UseMutationResult<
    Awaited<
        ReturnType<ReturnType<typeof usePostV1AdminUpdateValidationConfigHook>>
    >,
    TError,
    { data: UpdateValidationConfigRequest },
    TContext
> => {
    const mutationOptions =
        usePostV1AdminUpdateValidationConfigMutationOptions(options);

    return useMutation(mutationOptions);
};

export const usePostV1AdminToggleValidationEnabledHook = () => {
    const postV1AdminToggleValidationEnabled = useCustomAxios<void>();

    return useCallback(
        (toggleValidationEnabledRequest: ToggleValidationEnabledRequest) => {
            return postV1AdminToggleValidationEnabled({
                url: `/v1/Admin/ToggleValidationEnabled`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: toggleValidationEnabledRequest,
            });
        },
        [postV1AdminToggleValidationEnabled]
    );
};

export const usePostV1AdminToggleValidationEnabledMutationOptions = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<
            ReturnType<
                ReturnType<typeof usePostV1AdminToggleValidationEnabledHook>
            >
        >,
        TError,
        { data: ToggleValidationEnabledRequest },
        TContext
    >;
}): UseMutationOptions<
    Awaited<
        ReturnType<ReturnType<typeof usePostV1AdminToggleValidationEnabledHook>>
    >,
    TError,
    { data: ToggleValidationEnabledRequest },
    TContext
> => {
    const { mutation: mutationOptions } = options ?? {};

    const postV1AdminToggleValidationEnabled =
        usePostV1AdminToggleValidationEnabledHook();

    const mutationFn: MutationFunction<
        Awaited<
            ReturnType<
                ReturnType<typeof usePostV1AdminToggleValidationEnabledHook>
            >
        >,
        { data: ToggleValidationEnabledRequest }
    > = (props) => {
        const { data } = props ?? {};

        return postV1AdminToggleValidationEnabled(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type PostV1AdminToggleValidationEnabledMutationResult = NonNullable<
    Awaited<
        ReturnType<ReturnType<typeof usePostV1AdminToggleValidationEnabledHook>>
    >
>;
export type PostV1AdminToggleValidationEnabledMutationBody =
    ToggleValidationEnabledRequest;
export type PostV1AdminToggleValidationEnabledMutationError = ErrorType<void>;

export const usePostV1AdminToggleValidationEnabled = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<
            ReturnType<
                ReturnType<typeof usePostV1AdminToggleValidationEnabledHook>
            >
        >,
        TError,
        { data: ToggleValidationEnabledRequest },
        TContext
    >;
}): UseMutationResult<
    Awaited<
        ReturnType<ReturnType<typeof usePostV1AdminToggleValidationEnabledHook>>
    >,
    TError,
    { data: ToggleValidationEnabledRequest },
    TContext
> => {
    const mutationOptions =
        usePostV1AdminToggleValidationEnabledMutationOptions(options);

    return useMutation(mutationOptions);
};

/**
 * @summary Create a new tenant contact person
 */
export const usePostV1ContactPersonAdminTenantHook = () => {
    const postV1ContactPersonAdminTenant =
        useCustomAxios<ContactPersonResponse>();

    return useCallback(
        (createTenantContactRequest: CreateTenantContactRequest) => {
            return postV1ContactPersonAdminTenant({
                url: `/v1/ContactPerson/Admin/Tenant`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: createTenantContactRequest,
            });
        },
        [postV1ContactPersonAdminTenant]
    );
};

export const usePostV1ContactPersonAdminTenantMutationOptions = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<
            ReturnType<ReturnType<typeof usePostV1ContactPersonAdminTenantHook>>
        >,
        TError,
        { data: CreateTenantContactRequest },
        TContext
    >;
}): UseMutationOptions<
    Awaited<
        ReturnType<ReturnType<typeof usePostV1ContactPersonAdminTenantHook>>
    >,
    TError,
    { data: CreateTenantContactRequest },
    TContext
> => {
    const { mutation: mutationOptions } = options ?? {};

    const postV1ContactPersonAdminTenant =
        usePostV1ContactPersonAdminTenantHook();

    const mutationFn: MutationFunction<
        Awaited<
            ReturnType<ReturnType<typeof usePostV1ContactPersonAdminTenantHook>>
        >,
        { data: CreateTenantContactRequest }
    > = (props) => {
        const { data } = props ?? {};

        return postV1ContactPersonAdminTenant(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type PostV1ContactPersonAdminTenantMutationResult = NonNullable<
    Awaited<
        ReturnType<ReturnType<typeof usePostV1ContactPersonAdminTenantHook>>
    >
>;
export type PostV1ContactPersonAdminTenantMutationBody =
    CreateTenantContactRequest;
export type PostV1ContactPersonAdminTenantMutationError = ErrorType<void>;

/**
 * @summary Create a new tenant contact person
 */
export const usePostV1ContactPersonAdminTenant = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<
            ReturnType<ReturnType<typeof usePostV1ContactPersonAdminTenantHook>>
        >,
        TError,
        { data: CreateTenantContactRequest },
        TContext
    >;
}): UseMutationResult<
    Awaited<
        ReturnType<ReturnType<typeof usePostV1ContactPersonAdminTenantHook>>
    >,
    TError,
    { data: CreateTenantContactRequest },
    TContext
> => {
    const mutationOptions =
        usePostV1ContactPersonAdminTenantMutationOptions(options);

    return useMutation(mutationOptions);
};

export const usePutV1ContactPersonAdminContactPersonIdHook = () => {
    const putV1ContactPersonAdminContactPersonId = useCustomAxios<void>();

    return useCallback(
        (
            contactPersonId: number,
            editContactPersonRequest: EditContactPersonRequest
        ) => {
            return putV1ContactPersonAdminContactPersonId({
                url: `/v1/ContactPerson/Admin/${contactPersonId}`,
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                data: editContactPersonRequest,
            });
        },
        [putV1ContactPersonAdminContactPersonId]
    );
};

export const usePutV1ContactPersonAdminContactPersonIdMutationOptions = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<
            ReturnType<
                ReturnType<typeof usePutV1ContactPersonAdminContactPersonIdHook>
            >
        >,
        TError,
        { contactPersonId: number; data: EditContactPersonRequest },
        TContext
    >;
}): UseMutationOptions<
    Awaited<
        ReturnType<
            ReturnType<typeof usePutV1ContactPersonAdminContactPersonIdHook>
        >
    >,
    TError,
    { contactPersonId: number; data: EditContactPersonRequest },
    TContext
> => {
    const { mutation: mutationOptions } = options ?? {};

    const putV1ContactPersonAdminContactPersonId =
        usePutV1ContactPersonAdminContactPersonIdHook();

    const mutationFn: MutationFunction<
        Awaited<
            ReturnType<
                ReturnType<typeof usePutV1ContactPersonAdminContactPersonIdHook>
            >
        >,
        { contactPersonId: number; data: EditContactPersonRequest }
    > = (props) => {
        const { contactPersonId, data } = props ?? {};

        return putV1ContactPersonAdminContactPersonId(contactPersonId, data);
    };

    return { mutationFn, ...mutationOptions };
};

export type PutV1ContactPersonAdminContactPersonIdMutationResult = NonNullable<
    Awaited<
        ReturnType<
            ReturnType<typeof usePutV1ContactPersonAdminContactPersonIdHook>
        >
    >
>;
export type PutV1ContactPersonAdminContactPersonIdMutationBody =
    EditContactPersonRequest;
export type PutV1ContactPersonAdminContactPersonIdMutationError =
    ErrorType<void>;

export const usePutV1ContactPersonAdminContactPersonId = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<
            ReturnType<
                ReturnType<typeof usePutV1ContactPersonAdminContactPersonIdHook>
            >
        >,
        TError,
        { contactPersonId: number; data: EditContactPersonRequest },
        TContext
    >;
}): UseMutationResult<
    Awaited<
        ReturnType<
            ReturnType<typeof usePutV1ContactPersonAdminContactPersonIdHook>
        >
    >,
    TError,
    { contactPersonId: number; data: EditContactPersonRequest },
    TContext
> => {
    const mutationOptions =
        usePutV1ContactPersonAdminContactPersonIdMutationOptions(options);

    return useMutation(mutationOptions);
};

export const useDeleteV1ContactPersonAdminContactPersonIdHook = () => {
    const deleteV1ContactPersonAdminContactPersonId = useCustomAxios<void>();

    return useCallback(
        (contactPersonId: number) => {
            return deleteV1ContactPersonAdminContactPersonId({
                url: `/v1/ContactPerson/Admin/${contactPersonId}`,
                method: 'DELETE',
            });
        },
        [deleteV1ContactPersonAdminContactPersonId]
    );
};

export const useDeleteV1ContactPersonAdminContactPersonIdMutationOptions = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<
            ReturnType<
                ReturnType<
                    typeof useDeleteV1ContactPersonAdminContactPersonIdHook
                >
            >
        >,
        TError,
        { contactPersonId: number },
        TContext
    >;
}): UseMutationOptions<
    Awaited<
        ReturnType<
            ReturnType<typeof useDeleteV1ContactPersonAdminContactPersonIdHook>
        >
    >,
    TError,
    { contactPersonId: number },
    TContext
> => {
    const { mutation: mutationOptions } = options ?? {};

    const deleteV1ContactPersonAdminContactPersonId =
        useDeleteV1ContactPersonAdminContactPersonIdHook();

    const mutationFn: MutationFunction<
        Awaited<
            ReturnType<
                ReturnType<
                    typeof useDeleteV1ContactPersonAdminContactPersonIdHook
                >
            >
        >,
        { contactPersonId: number }
    > = (props) => {
        const { contactPersonId } = props ?? {};

        return deleteV1ContactPersonAdminContactPersonId(contactPersonId);
    };

    return { mutationFn, ...mutationOptions };
};

export type DeleteV1ContactPersonAdminContactPersonIdMutationResult =
    NonNullable<
        Awaited<
            ReturnType<
                ReturnType<
                    typeof useDeleteV1ContactPersonAdminContactPersonIdHook
                >
            >
        >
    >;

export type DeleteV1ContactPersonAdminContactPersonIdMutationError =
    ErrorType<void>;

export const useDeleteV1ContactPersonAdminContactPersonId = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<
            ReturnType<
                ReturnType<
                    typeof useDeleteV1ContactPersonAdminContactPersonIdHook
                >
            >
        >,
        TError,
        { contactPersonId: number },
        TContext
    >;
}): UseMutationResult<
    Awaited<
        ReturnType<
            ReturnType<typeof useDeleteV1ContactPersonAdminContactPersonIdHook>
        >
    >,
    TError,
    { contactPersonId: number },
    TContext
> => {
    const mutationOptions =
        useDeleteV1ContactPersonAdminContactPersonIdMutationOptions(options);

    return useMutation(mutationOptions);
};

export const usePostV1AuthLogoutHook = () => {
    const postV1AuthLogout = useCustomAxios<void>();

    return useCallback(() => {
        return postV1AuthLogout({ url: `/v1/Auth/Logout`, method: 'POST' });
    }, [postV1AuthLogout]);
};

export const usePostV1AuthLogoutMutationOptions = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof usePostV1AuthLogoutHook>>>,
        TError,
        void,
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof usePostV1AuthLogoutHook>>>,
    TError,
    void,
    TContext
> => {
    const { mutation: mutationOptions } = options ?? {};

    const postV1AuthLogout = usePostV1AuthLogoutHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof usePostV1AuthLogoutHook>>>,
        void
    > = () => {
        return postV1AuthLogout();
    };

    return { mutationFn, ...mutationOptions };
};

export type PostV1AuthLogoutMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof usePostV1AuthLogoutHook>>>
>;

export type PostV1AuthLogoutMutationError = ErrorType<void>;

export const usePostV1AuthLogout = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof usePostV1AuthLogoutHook>>>,
        TError,
        void,
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof usePostV1AuthLogoutHook>>>,
    TError,
    void,
    TContext
> => {
    const mutationOptions = usePostV1AuthLogoutMutationOptions(options);

    return useMutation(mutationOptions);
};

export const useGetV1ContactPersonTenantTenantIdHook = () => {
    const getV1ContactPersonTenantTenantId =
        useCustomAxios<ContactPersonResponse[]>();

    return useCallback(
        (tenantId: number) => {
            return getV1ContactPersonTenantTenantId({
                url: `/v1/ContactPerson/Tenant/${tenantId}`,
                method: 'GET',
            });
        },
        [getV1ContactPersonTenantTenantId]
    );
};

export const getGetV1ContactPersonTenantTenantIdQueryKey = (
    tenantId: number
) => {
    return [`/v1/ContactPerson/Tenant/${tenantId}`] as const;
};

export const useGetV1ContactPersonTenantTenantIdQueryOptions = <
    TData = Awaited<
        ReturnType<ReturnType<typeof useGetV1ContactPersonTenantTenantIdHook>>
    >,
    TError = ErrorType<void>
>(
    tenantId: number,
    options?: {
        query?: UseQueryOptions<
            Awaited<
                ReturnType<
                    ReturnType<typeof useGetV1ContactPersonTenantTenantIdHook>
                >
            >,
            TError,
            TData
        >;
    }
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getGetV1ContactPersonTenantTenantIdQueryKey(tenantId);

    const getV1ContactPersonTenantTenantId =
        useGetV1ContactPersonTenantTenantIdHook();

    const queryFn: QueryFunction<
        Awaited<
            ReturnType<
                ReturnType<typeof useGetV1ContactPersonTenantTenantIdHook>
            >
        >
    > = () => getV1ContactPersonTenantTenantId(tenantId);

    return {
        queryKey,
        queryFn,
        enabled: !!tenantId,
        ...queryOptions,
    } as UseQueryOptions<
        Awaited<
            ReturnType<
                ReturnType<typeof useGetV1ContactPersonTenantTenantIdHook>
            >
        >,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetV1ContactPersonTenantTenantIdQueryResult = NonNullable<
    Awaited<
        ReturnType<ReturnType<typeof useGetV1ContactPersonTenantTenantIdHook>>
    >
>;
export type GetV1ContactPersonTenantTenantIdQueryError = ErrorType<void>;

export const useGetV1ContactPersonTenantTenantId = <
    TData = Awaited<
        ReturnType<ReturnType<typeof useGetV1ContactPersonTenantTenantIdHook>>
    >,
    TError = ErrorType<void>
>(
    tenantId: number,
    options?: {
        query?: UseQueryOptions<
            Awaited<
                ReturnType<
                    ReturnType<typeof useGetV1ContactPersonTenantTenantIdHook>
                >
            >,
            TError,
            TData
        >;
    }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
    const queryOptions = useGetV1ContactPersonTenantTenantIdQueryOptions(
        tenantId,
        options
    );

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
        queryKey: QueryKey;
    };

    query.queryKey = queryOptions.queryKey;

    return query;
};

export const useGetV1ContactPersonApplicationHook = () => {
    const getV1ContactPersonApplication =
        useCustomAxios<ContactPersonResponse[]>();

    return useCallback(() => {
        return getV1ContactPersonApplication({
            url: `/v1/ContactPerson/Application`,
            method: 'GET',
        });
    }, [getV1ContactPersonApplication]);
};

export const getGetV1ContactPersonApplicationQueryKey = () => {
    return [`/v1/ContactPerson/Application`] as const;
};

export const useGetV1ContactPersonApplicationQueryOptions = <
    TData = Awaited<
        ReturnType<ReturnType<typeof useGetV1ContactPersonApplicationHook>>
    >,
    TError = ErrorType<unknown>
>(options?: {
    query?: UseQueryOptions<
        Awaited<
            ReturnType<ReturnType<typeof useGetV1ContactPersonApplicationHook>>
        >,
        TError,
        TData
    >;
}) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ?? getGetV1ContactPersonApplicationQueryKey();

    const getV1ContactPersonApplication =
        useGetV1ContactPersonApplicationHook();

    const queryFn: QueryFunction<
        Awaited<
            ReturnType<ReturnType<typeof useGetV1ContactPersonApplicationHook>>
        >
    > = () => getV1ContactPersonApplication();

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<
            ReturnType<ReturnType<typeof useGetV1ContactPersonApplicationHook>>
        >,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetV1ContactPersonApplicationQueryResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useGetV1ContactPersonApplicationHook>>>
>;
export type GetV1ContactPersonApplicationQueryError = ErrorType<unknown>;

export const useGetV1ContactPersonApplication = <
    TData = Awaited<
        ReturnType<ReturnType<typeof useGetV1ContactPersonApplicationHook>>
    >,
    TError = ErrorType<unknown>
>(options?: {
    query?: UseQueryOptions<
        Awaited<
            ReturnType<ReturnType<typeof useGetV1ContactPersonApplicationHook>>
        >,
        TError,
        TData
    >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
    const queryOptions = useGetV1ContactPersonApplicationQueryOptions(options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
        queryKey: QueryKey;
    };

    query.queryKey = queryOptions.queryKey;

    return query;
};

export const usePostV1DocumentsDownloadDocumentsHook = () => {
    const postV1DocumentsDownloadDocuments =
        useCustomAxios<DownloadDocumentsResponse>();

    return useCallback(
        (downloadDocumentsRequest: DownloadDocumentsRequest) => {
            return postV1DocumentsDownloadDocuments({
                url: `/v1/Documents/DownloadDocuments`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: downloadDocumentsRequest,
            });
        },
        [postV1DocumentsDownloadDocuments]
    );
};

export const usePostV1DocumentsDownloadDocumentsMutationOptions = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<
            ReturnType<
                ReturnType<typeof usePostV1DocumentsDownloadDocumentsHook>
            >
        >,
        TError,
        { data: DownloadDocumentsRequest },
        TContext
    >;
}): UseMutationOptions<
    Awaited<
        ReturnType<ReturnType<typeof usePostV1DocumentsDownloadDocumentsHook>>
    >,
    TError,
    { data: DownloadDocumentsRequest },
    TContext
> => {
    const { mutation: mutationOptions } = options ?? {};

    const postV1DocumentsDownloadDocuments =
        usePostV1DocumentsDownloadDocumentsHook();

    const mutationFn: MutationFunction<
        Awaited<
            ReturnType<
                ReturnType<typeof usePostV1DocumentsDownloadDocumentsHook>
            >
        >,
        { data: DownloadDocumentsRequest }
    > = (props) => {
        const { data } = props ?? {};

        return postV1DocumentsDownloadDocuments(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type PostV1DocumentsDownloadDocumentsMutationResult = NonNullable<
    Awaited<
        ReturnType<ReturnType<typeof usePostV1DocumentsDownloadDocumentsHook>>
    >
>;
export type PostV1DocumentsDownloadDocumentsMutationBody =
    DownloadDocumentsRequest;
export type PostV1DocumentsDownloadDocumentsMutationError = ErrorType<void>;

export const usePostV1DocumentsDownloadDocuments = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<
            ReturnType<
                ReturnType<typeof usePostV1DocumentsDownloadDocumentsHook>
            >
        >,
        TError,
        { data: DownloadDocumentsRequest },
        TContext
    >;
}): UseMutationResult<
    Awaited<
        ReturnType<ReturnType<typeof usePostV1DocumentsDownloadDocumentsHook>>
    >,
    TError,
    { data: DownloadDocumentsRequest },
    TContext
> => {
    const mutationOptions =
        usePostV1DocumentsDownloadDocumentsMutationOptions(options);

    return useMutation(mutationOptions);
};

export const usePostV1DocumentsDeleteDocumentHook = () => {
    const postV1DocumentsDeleteDocument = useCustomAxios<void>();

    return useCallback(
        (deleteDocumentsRequest: DeleteDocumentsRequest) => {
            return postV1DocumentsDeleteDocument({
                url: `/v1/Documents/DeleteDocument`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: deleteDocumentsRequest,
            });
        },
        [postV1DocumentsDeleteDocument]
    );
};

export const usePostV1DocumentsDeleteDocumentMutationOptions = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<
            ReturnType<ReturnType<typeof usePostV1DocumentsDeleteDocumentHook>>
        >,
        TError,
        { data: DeleteDocumentsRequest },
        TContext
    >;
}): UseMutationOptions<
    Awaited<
        ReturnType<ReturnType<typeof usePostV1DocumentsDeleteDocumentHook>>
    >,
    TError,
    { data: DeleteDocumentsRequest },
    TContext
> => {
    const { mutation: mutationOptions } = options ?? {};

    const postV1DocumentsDeleteDocument =
        usePostV1DocumentsDeleteDocumentHook();

    const mutationFn: MutationFunction<
        Awaited<
            ReturnType<ReturnType<typeof usePostV1DocumentsDeleteDocumentHook>>
        >,
        { data: DeleteDocumentsRequest }
    > = (props) => {
        const { data } = props ?? {};

        return postV1DocumentsDeleteDocument(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type PostV1DocumentsDeleteDocumentMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof usePostV1DocumentsDeleteDocumentHook>>>
>;
export type PostV1DocumentsDeleteDocumentMutationBody = DeleteDocumentsRequest;
export type PostV1DocumentsDeleteDocumentMutationError = ErrorType<void>;

export const usePostV1DocumentsDeleteDocument = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<
            ReturnType<ReturnType<typeof usePostV1DocumentsDeleteDocumentHook>>
        >,
        TError,
        { data: DeleteDocumentsRequest },
        TContext
    >;
}): UseMutationResult<
    Awaited<
        ReturnType<ReturnType<typeof usePostV1DocumentsDeleteDocumentHook>>
    >,
    TError,
    { data: DeleteDocumentsRequest },
    TContext
> => {
    const mutationOptions =
        usePostV1DocumentsDeleteDocumentMutationOptions(options);

    return useMutation(mutationOptions);
};

export const usePutV1DocumentsUpdateReadyForSubmissionHook = () => {
    const putV1DocumentsUpdateReadyForSubmission = useCustomAxios<void>();

    return useCallback(
        (
            updateDocumentReadyForSubmissionRequest: UpdateDocumentReadyForSubmissionRequest
        ) => {
            return putV1DocumentsUpdateReadyForSubmission({
                url: `/v1/Documents/UpdateReadyForSubmission`,
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                data: updateDocumentReadyForSubmissionRequest,
            });
        },
        [putV1DocumentsUpdateReadyForSubmission]
    );
};

export const usePutV1DocumentsUpdateReadyForSubmissionMutationOptions = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<
            ReturnType<
                ReturnType<typeof usePutV1DocumentsUpdateReadyForSubmissionHook>
            >
        >,
        TError,
        { data: UpdateDocumentReadyForSubmissionRequest },
        TContext
    >;
}): UseMutationOptions<
    Awaited<
        ReturnType<
            ReturnType<typeof usePutV1DocumentsUpdateReadyForSubmissionHook>
        >
    >,
    TError,
    { data: UpdateDocumentReadyForSubmissionRequest },
    TContext
> => {
    const { mutation: mutationOptions } = options ?? {};

    const putV1DocumentsUpdateReadyForSubmission =
        usePutV1DocumentsUpdateReadyForSubmissionHook();

    const mutationFn: MutationFunction<
        Awaited<
            ReturnType<
                ReturnType<typeof usePutV1DocumentsUpdateReadyForSubmissionHook>
            >
        >,
        { data: UpdateDocumentReadyForSubmissionRequest }
    > = (props) => {
        const { data } = props ?? {};

        return putV1DocumentsUpdateReadyForSubmission(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type PutV1DocumentsUpdateReadyForSubmissionMutationResult = NonNullable<
    Awaited<
        ReturnType<
            ReturnType<typeof usePutV1DocumentsUpdateReadyForSubmissionHook>
        >
    >
>;
export type PutV1DocumentsUpdateReadyForSubmissionMutationBody =
    UpdateDocumentReadyForSubmissionRequest;
export type PutV1DocumentsUpdateReadyForSubmissionMutationError =
    ErrorType<void>;

export const usePutV1DocumentsUpdateReadyForSubmission = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<
            ReturnType<
                ReturnType<typeof usePutV1DocumentsUpdateReadyForSubmissionHook>
            >
        >,
        TError,
        { data: UpdateDocumentReadyForSubmissionRequest },
        TContext
    >;
}): UseMutationResult<
    Awaited<
        ReturnType<
            ReturnType<typeof usePutV1DocumentsUpdateReadyForSubmissionHook>
        >
    >,
    TError,
    { data: UpdateDocumentReadyForSubmissionRequest },
    TContext
> => {
    const mutationOptions =
        usePutV1DocumentsUpdateReadyForSubmissionMutationOptions(options);

    return useMutation(mutationOptions);
};

/**
 * @summary Get a classification in a given process.
 */
export const useGetV1DocumentClassificationGetClassificationHook = () => {
    const getV1DocumentClassificationGetClassification =
        useCustomAxios<GetClassificationResponse>();

    return useCallback(
        (params?: GetV1DocumentClassificationGetClassificationParams) => {
            return getV1DocumentClassificationGetClassification({
                url: `/v1/DocumentClassification/GetClassification`,
                method: 'GET',
                params,
            });
        },
        [getV1DocumentClassificationGetClassification]
    );
};

export const getGetV1DocumentClassificationGetClassificationQueryKey = (
    params?: GetV1DocumentClassificationGetClassificationParams
) => {
    return [
        `/v1/DocumentClassification/GetClassification`,
        ...(params ? [params] : []),
    ] as const;
};

export const useGetV1DocumentClassificationGetClassificationQueryOptions = <
    TData = Awaited<
        ReturnType<
            ReturnType<
                typeof useGetV1DocumentClassificationGetClassificationHook
            >
        >
    >,
    TError = ErrorType<void>
>(
    params?: GetV1DocumentClassificationGetClassificationParams,
    options?: {
        query?: UseQueryOptions<
            Awaited<
                ReturnType<
                    ReturnType<
                        typeof useGetV1DocumentClassificationGetClassificationHook
                    >
                >
            >,
            TError,
            TData
        >;
    }
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getGetV1DocumentClassificationGetClassificationQueryKey(params);

    const getV1DocumentClassificationGetClassification =
        useGetV1DocumentClassificationGetClassificationHook();

    const queryFn: QueryFunction<
        Awaited<
            ReturnType<
                ReturnType<
                    typeof useGetV1DocumentClassificationGetClassificationHook
                >
            >
        >
    > = () => getV1DocumentClassificationGetClassification(params);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<
            ReturnType<
                ReturnType<
                    typeof useGetV1DocumentClassificationGetClassificationHook
                >
            >
        >,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetV1DocumentClassificationGetClassificationQueryResult =
    NonNullable<
        Awaited<
            ReturnType<
                ReturnType<
                    typeof useGetV1DocumentClassificationGetClassificationHook
                >
            >
        >
    >;
export type GetV1DocumentClassificationGetClassificationQueryError =
    ErrorType<void>;

/**
 * @summary Get a classification in a given process.
 */
export const useGetV1DocumentClassificationGetClassification = <
    TData = Awaited<
        ReturnType<
            ReturnType<
                typeof useGetV1DocumentClassificationGetClassificationHook
            >
        >
    >,
    TError = ErrorType<void>
>(
    params?: GetV1DocumentClassificationGetClassificationParams,
    options?: {
        query?: UseQueryOptions<
            Awaited<
                ReturnType<
                    ReturnType<
                        typeof useGetV1DocumentClassificationGetClassificationHook
                    >
                >
            >,
            TError,
            TData
        >;
    }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
    const queryOptions =
        useGetV1DocumentClassificationGetClassificationQueryOptions(
            params,
            options
        );

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
        queryKey: QueryKey;
    };

    query.queryKey = queryOptions.queryKey;

    return query;
};

/**
 * @summary Updates classifications for a document.
 */
export const usePostV1DocumentClassificationUpdateClassificationHook = () => {
    const postV1DocumentClassificationUpdateClassification =
        useCustomAxios<void>();

    return useCallback(
        (updateClassificationDTO: UpdateClassificationDTO) => {
            return postV1DocumentClassificationUpdateClassification({
                url: `/v1/DocumentClassification/UpdateClassification`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: updateClassificationDTO,
            });
        },
        [postV1DocumentClassificationUpdateClassification]
    );
};

export const usePostV1DocumentClassificationUpdateClassificationMutationOptions =
    <TError = ErrorType<void>, TContext = unknown>(options?: {
        mutation?: UseMutationOptions<
            Awaited<
                ReturnType<
                    ReturnType<
                        typeof usePostV1DocumentClassificationUpdateClassificationHook
                    >
                >
            >,
            TError,
            { data: UpdateClassificationDTO },
            TContext
        >;
    }): UseMutationOptions<
        Awaited<
            ReturnType<
                ReturnType<
                    typeof usePostV1DocumentClassificationUpdateClassificationHook
                >
            >
        >,
        TError,
        { data: UpdateClassificationDTO },
        TContext
    > => {
        const { mutation: mutationOptions } = options ?? {};

        const postV1DocumentClassificationUpdateClassification =
            usePostV1DocumentClassificationUpdateClassificationHook();

        const mutationFn: MutationFunction<
            Awaited<
                ReturnType<
                    ReturnType<
                        typeof usePostV1DocumentClassificationUpdateClassificationHook
                    >
                >
            >,
            { data: UpdateClassificationDTO }
        > = (props) => {
            const { data } = props ?? {};

            return postV1DocumentClassificationUpdateClassification(data);
        };

        return { mutationFn, ...mutationOptions };
    };

export type PostV1DocumentClassificationUpdateClassificationMutationResult =
    NonNullable<
        Awaited<
            ReturnType<
                ReturnType<
                    typeof usePostV1DocumentClassificationUpdateClassificationHook
                >
            >
        >
    >;
export type PostV1DocumentClassificationUpdateClassificationMutationBody =
    UpdateClassificationDTO;
export type PostV1DocumentClassificationUpdateClassificationMutationError =
    ErrorType<void>;

/**
 * @summary Updates classifications for a document.
 */
export const usePostV1DocumentClassificationUpdateClassification = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<
            ReturnType<
                ReturnType<
                    typeof usePostV1DocumentClassificationUpdateClassificationHook
                >
            >
        >,
        TError,
        { data: UpdateClassificationDTO },
        TContext
    >;
}): UseMutationResult<
    Awaited<
        ReturnType<
            ReturnType<
                typeof usePostV1DocumentClassificationUpdateClassificationHook
            >
        >
    >,
    TError,
    { data: UpdateClassificationDTO },
    TContext
> => {
    const mutationOptions =
        usePostV1DocumentClassificationUpdateClassificationMutationOptions(
            options
        );

    return useMutation(mutationOptions);
};

/**
 * @summary Get extracted fields in a given document.
 */
export const useGetV1DocumentClassificationGetExtractedFieldsHook = () => {
    const getV1DocumentClassificationGetExtractedFields =
        useCustomAxios<GetExtractedFieldsResponse>();

    return useCallback(
        (params?: GetV1DocumentClassificationGetExtractedFieldsParams) => {
            return getV1DocumentClassificationGetExtractedFields({
                url: `/v1/DocumentClassification/GetExtractedFields`,
                method: 'GET',
                params,
            });
        },
        [getV1DocumentClassificationGetExtractedFields]
    );
};

export const getGetV1DocumentClassificationGetExtractedFieldsQueryKey = (
    params?: GetV1DocumentClassificationGetExtractedFieldsParams
) => {
    return [
        `/v1/DocumentClassification/GetExtractedFields`,
        ...(params ? [params] : []),
    ] as const;
};

export const useGetV1DocumentClassificationGetExtractedFieldsQueryOptions = <
    TData = Awaited<
        ReturnType<
            ReturnType<
                typeof useGetV1DocumentClassificationGetExtractedFieldsHook
            >
        >
    >,
    TError = ErrorType<void>
>(
    params?: GetV1DocumentClassificationGetExtractedFieldsParams,
    options?: {
        query?: UseQueryOptions<
            Awaited<
                ReturnType<
                    ReturnType<
                        typeof useGetV1DocumentClassificationGetExtractedFieldsHook
                    >
                >
            >,
            TError,
            TData
        >;
    }
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getGetV1DocumentClassificationGetExtractedFieldsQueryKey(params);

    const getV1DocumentClassificationGetExtractedFields =
        useGetV1DocumentClassificationGetExtractedFieldsHook();

    const queryFn: QueryFunction<
        Awaited<
            ReturnType<
                ReturnType<
                    typeof useGetV1DocumentClassificationGetExtractedFieldsHook
                >
            >
        >
    > = () => getV1DocumentClassificationGetExtractedFields(params);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<
            ReturnType<
                ReturnType<
                    typeof useGetV1DocumentClassificationGetExtractedFieldsHook
                >
            >
        >,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetV1DocumentClassificationGetExtractedFieldsQueryResult =
    NonNullable<
        Awaited<
            ReturnType<
                ReturnType<
                    typeof useGetV1DocumentClassificationGetExtractedFieldsHook
                >
            >
        >
    >;
export type GetV1DocumentClassificationGetExtractedFieldsQueryError =
    ErrorType<void>;

/**
 * @summary Get extracted fields in a given document.
 */
export const useGetV1DocumentClassificationGetExtractedFields = <
    TData = Awaited<
        ReturnType<
            ReturnType<
                typeof useGetV1DocumentClassificationGetExtractedFieldsHook
            >
        >
    >,
    TError = ErrorType<void>
>(
    params?: GetV1DocumentClassificationGetExtractedFieldsParams,
    options?: {
        query?: UseQueryOptions<
            Awaited<
                ReturnType<
                    ReturnType<
                        typeof useGetV1DocumentClassificationGetExtractedFieldsHook
                    >
                >
            >,
            TError,
            TData
        >;
    }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
    const queryOptions =
        useGetV1DocumentClassificationGetExtractedFieldsQueryOptions(
            params,
            options
        );

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
        queryKey: QueryKey;
    };

    query.queryKey = queryOptions.queryKey;

    return query;
};

/**
 * @summary Get only the SAS URL for a document.
 */
export const useGetV1DocumentClassificationGetSasUrlOnlyHook = () => {
    const getV1DocumentClassificationGetSasUrlOnly = useCustomAxios<string>();

    return useCallback(
        (params?: GetV1DocumentClassificationGetSasUrlOnlyParams) => {
            return getV1DocumentClassificationGetSasUrlOnly({
                url: `/v1/DocumentClassification/GetSasUrlOnly`,
                method: 'GET',
                params,
            });
        },
        [getV1DocumentClassificationGetSasUrlOnly]
    );
};

export const getGetV1DocumentClassificationGetSasUrlOnlyQueryKey = (
    params?: GetV1DocumentClassificationGetSasUrlOnlyParams
) => {
    return [
        `/v1/DocumentClassification/GetSasUrlOnly`,
        ...(params ? [params] : []),
    ] as const;
};

export const useGetV1DocumentClassificationGetSasUrlOnlyQueryOptions = <
    TData = Awaited<
        ReturnType<
            ReturnType<typeof useGetV1DocumentClassificationGetSasUrlOnlyHook>
        >
    >,
    TError = ErrorType<void>
>(
    params?: GetV1DocumentClassificationGetSasUrlOnlyParams,
    options?: {
        query?: UseQueryOptions<
            Awaited<
                ReturnType<
                    ReturnType<
                        typeof useGetV1DocumentClassificationGetSasUrlOnlyHook
                    >
                >
            >,
            TError,
            TData
        >;
    }
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getGetV1DocumentClassificationGetSasUrlOnlyQueryKey(params);

    const getV1DocumentClassificationGetSasUrlOnly =
        useGetV1DocumentClassificationGetSasUrlOnlyHook();

    const queryFn: QueryFunction<
        Awaited<
            ReturnType<
                ReturnType<
                    typeof useGetV1DocumentClassificationGetSasUrlOnlyHook
                >
            >
        >
    > = () => getV1DocumentClassificationGetSasUrlOnly(params);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<
            ReturnType<
                ReturnType<
                    typeof useGetV1DocumentClassificationGetSasUrlOnlyHook
                >
            >
        >,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetV1DocumentClassificationGetSasUrlOnlyQueryResult = NonNullable<
    Awaited<
        ReturnType<
            ReturnType<typeof useGetV1DocumentClassificationGetSasUrlOnlyHook>
        >
    >
>;
export type GetV1DocumentClassificationGetSasUrlOnlyQueryError =
    ErrorType<void>;

/**
 * @summary Get only the SAS URL for a document.
 */
export const useGetV1DocumentClassificationGetSasUrlOnly = <
    TData = Awaited<
        ReturnType<
            ReturnType<typeof useGetV1DocumentClassificationGetSasUrlOnlyHook>
        >
    >,
    TError = ErrorType<void>
>(
    params?: GetV1DocumentClassificationGetSasUrlOnlyParams,
    options?: {
        query?: UseQueryOptions<
            Awaited<
                ReturnType<
                    ReturnType<
                        typeof useGetV1DocumentClassificationGetSasUrlOnlyHook
                    >
                >
            >,
            TError,
            TData
        >;
    }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
    const queryOptions =
        useGetV1DocumentClassificationGetSasUrlOnlyQueryOptions(
            params,
            options
        );

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
        queryKey: QueryKey;
    };

    query.queryKey = queryOptions.queryKey;

    return query;
};

/**
 * @summary Updates extracted fields for a document.
 */
export const usePostV1DocumentClassificationUpdateExtractedFieldsHook = () => {
    const postV1DocumentClassificationUpdateExtractedFields =
        useCustomAxios<void>();

    return useCallback(
        (updateExtractedFieldsDTO: UpdateExtractedFieldsDTO) => {
            return postV1DocumentClassificationUpdateExtractedFields({
                url: `/v1/DocumentClassification/UpdateExtractedFields`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: updateExtractedFieldsDTO,
            });
        },
        [postV1DocumentClassificationUpdateExtractedFields]
    );
};

export const usePostV1DocumentClassificationUpdateExtractedFieldsMutationOptions =
    <TError = ErrorType<void>, TContext = unknown>(options?: {
        mutation?: UseMutationOptions<
            Awaited<
                ReturnType<
                    ReturnType<
                        typeof usePostV1DocumentClassificationUpdateExtractedFieldsHook
                    >
                >
            >,
            TError,
            { data: UpdateExtractedFieldsDTO },
            TContext
        >;
    }): UseMutationOptions<
        Awaited<
            ReturnType<
                ReturnType<
                    typeof usePostV1DocumentClassificationUpdateExtractedFieldsHook
                >
            >
        >,
        TError,
        { data: UpdateExtractedFieldsDTO },
        TContext
    > => {
        const { mutation: mutationOptions } = options ?? {};

        const postV1DocumentClassificationUpdateExtractedFields =
            usePostV1DocumentClassificationUpdateExtractedFieldsHook();

        const mutationFn: MutationFunction<
            Awaited<
                ReturnType<
                    ReturnType<
                        typeof usePostV1DocumentClassificationUpdateExtractedFieldsHook
                    >
                >
            >,
            { data: UpdateExtractedFieldsDTO }
        > = (props) => {
            const { data } = props ?? {};

            return postV1DocumentClassificationUpdateExtractedFields(data);
        };

        return { mutationFn, ...mutationOptions };
    };

export type PostV1DocumentClassificationUpdateExtractedFieldsMutationResult =
    NonNullable<
        Awaited<
            ReturnType<
                ReturnType<
                    typeof usePostV1DocumentClassificationUpdateExtractedFieldsHook
                >
            >
        >
    >;
export type PostV1DocumentClassificationUpdateExtractedFieldsMutationBody =
    UpdateExtractedFieldsDTO;
export type PostV1DocumentClassificationUpdateExtractedFieldsMutationError =
    ErrorType<void>;

/**
 * @summary Updates extracted fields for a document.
 */
export const usePostV1DocumentClassificationUpdateExtractedFields = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<
            ReturnType<
                ReturnType<
                    typeof usePostV1DocumentClassificationUpdateExtractedFieldsHook
                >
            >
        >,
        TError,
        { data: UpdateExtractedFieldsDTO },
        TContext
    >;
}): UseMutationResult<
    Awaited<
        ReturnType<
            ReturnType<
                typeof usePostV1DocumentClassificationUpdateExtractedFieldsHook
            >
        >
    >,
    TError,
    { data: UpdateExtractedFieldsDTO },
    TContext
> => {
    const mutationOptions =
        usePostV1DocumentClassificationUpdateExtractedFieldsMutationOptions(
            options
        );

    return useMutation(mutationOptions);
};

/**
 * Returns a list of active document types (ID and Name) associated with the specified ProcessType for the caller's tenant.
 * @summary Retrieve active document types for a given process type.
 */
export const useGetV1DocumentTypeByProcessTypeProcessTypeIdHook = () => {
    const getV1DocumentTypeByProcessTypeProcessTypeId =
        useCustomAxios<DocumentTypeResponse[]>();

    return useCallback(
        (processTypeId: number) => {
            return getV1DocumentTypeByProcessTypeProcessTypeId({
                url: `/v1/DocumentType/ByProcessType/${processTypeId}`,
                method: 'GET',
            });
        },
        [getV1DocumentTypeByProcessTypeProcessTypeId]
    );
};

export const getGetV1DocumentTypeByProcessTypeProcessTypeIdQueryKey = (
    processTypeId: number
) => {
    return [`/v1/DocumentType/ByProcessType/${processTypeId}`] as const;
};

export const useGetV1DocumentTypeByProcessTypeProcessTypeIdQueryOptions = <
    TData = Awaited<
        ReturnType<
            ReturnType<
                typeof useGetV1DocumentTypeByProcessTypeProcessTypeIdHook
            >
        >
    >,
    TError = ErrorType<void>
>(
    processTypeId: number,
    options?: {
        query?: UseQueryOptions<
            Awaited<
                ReturnType<
                    ReturnType<
                        typeof useGetV1DocumentTypeByProcessTypeProcessTypeIdHook
                    >
                >
            >,
            TError,
            TData
        >;
    }
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getGetV1DocumentTypeByProcessTypeProcessTypeIdQueryKey(processTypeId);

    const getV1DocumentTypeByProcessTypeProcessTypeId =
        useGetV1DocumentTypeByProcessTypeProcessTypeIdHook();

    const queryFn: QueryFunction<
        Awaited<
            ReturnType<
                ReturnType<
                    typeof useGetV1DocumentTypeByProcessTypeProcessTypeIdHook
                >
            >
        >
    > = () => getV1DocumentTypeByProcessTypeProcessTypeId(processTypeId);

    return {
        queryKey,
        queryFn,
        enabled: !!processTypeId,
        ...queryOptions,
    } as UseQueryOptions<
        Awaited<
            ReturnType<
                ReturnType<
                    typeof useGetV1DocumentTypeByProcessTypeProcessTypeIdHook
                >
            >
        >,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetV1DocumentTypeByProcessTypeProcessTypeIdQueryResult =
    NonNullable<
        Awaited<
            ReturnType<
                ReturnType<
                    typeof useGetV1DocumentTypeByProcessTypeProcessTypeIdHook
                >
            >
        >
    >;
export type GetV1DocumentTypeByProcessTypeProcessTypeIdQueryError =
    ErrorType<void>;

/**
 * @summary Retrieve active document types for a given process type.
 */
export const useGetV1DocumentTypeByProcessTypeProcessTypeId = <
    TData = Awaited<
        ReturnType<
            ReturnType<
                typeof useGetV1DocumentTypeByProcessTypeProcessTypeIdHook
            >
        >
    >,
    TError = ErrorType<void>
>(
    processTypeId: number,
    options?: {
        query?: UseQueryOptions<
            Awaited<
                ReturnType<
                    ReturnType<
                        typeof useGetV1DocumentTypeByProcessTypeProcessTypeIdHook
                    >
                >
            >,
            TError,
            TData
        >;
    }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
    const queryOptions =
        useGetV1DocumentTypeByProcessTypeProcessTypeIdQueryOptions(
            processTypeId,
            options
        );

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
        queryKey: QueryKey;
    };

    query.queryKey = queryOptions.queryKey;

    return query;
};

export const usePostV1DocumentTypeAddHook = () => {
    const postV1DocumentTypeAdd = useCustomAxios<void>();

    return useCallback(
        (documentTypeRequest: DocumentTypeRequest) => {
            return postV1DocumentTypeAdd({
                url: `/v1/DocumentType/Add`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: documentTypeRequest,
            });
        },
        [postV1DocumentTypeAdd]
    );
};

export const usePostV1DocumentTypeAddMutationOptions = <
    TError = ErrorType<unknown>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof usePostV1DocumentTypeAddHook>>>,
        TError,
        { data: DocumentTypeRequest },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof usePostV1DocumentTypeAddHook>>>,
    TError,
    { data: DocumentTypeRequest },
    TContext
> => {
    const { mutation: mutationOptions } = options ?? {};

    const postV1DocumentTypeAdd = usePostV1DocumentTypeAddHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof usePostV1DocumentTypeAddHook>>>,
        { data: DocumentTypeRequest }
    > = (props) => {
        const { data } = props ?? {};

        return postV1DocumentTypeAdd(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type PostV1DocumentTypeAddMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof usePostV1DocumentTypeAddHook>>>
>;
export type PostV1DocumentTypeAddMutationBody = DocumentTypeRequest;
export type PostV1DocumentTypeAddMutationError = ErrorType<unknown>;

export const usePostV1DocumentTypeAdd = <
    TError = ErrorType<unknown>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof usePostV1DocumentTypeAddHook>>>,
        TError,
        { data: DocumentTypeRequest },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof usePostV1DocumentTypeAddHook>>>,
    TError,
    { data: DocumentTypeRequest },
    TContext
> => {
    const mutationOptions = usePostV1DocumentTypeAddMutationOptions(options);

    return useMutation(mutationOptions);
};

export const usePostV1DocumentTypeDeactivateHook = () => {
    const postV1DocumentTypeDeactivate = useCustomAxios<void>();

    return useCallback(
        (deactivateDocumentTypeRequest: DeactivateDocumentTypeRequest) => {
            return postV1DocumentTypeDeactivate({
                url: `/v1/DocumentType/Deactivate`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: deactivateDocumentTypeRequest,
            });
        },
        [postV1DocumentTypeDeactivate]
    );
};

export const usePostV1DocumentTypeDeactivateMutationOptions = <
    TError = ErrorType<unknown>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<
            ReturnType<ReturnType<typeof usePostV1DocumentTypeDeactivateHook>>
        >,
        TError,
        { data: DeactivateDocumentTypeRequest },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof usePostV1DocumentTypeDeactivateHook>>>,
    TError,
    { data: DeactivateDocumentTypeRequest },
    TContext
> => {
    const { mutation: mutationOptions } = options ?? {};

    const postV1DocumentTypeDeactivate = usePostV1DocumentTypeDeactivateHook();

    const mutationFn: MutationFunction<
        Awaited<
            ReturnType<ReturnType<typeof usePostV1DocumentTypeDeactivateHook>>
        >,
        { data: DeactivateDocumentTypeRequest }
    > = (props) => {
        const { data } = props ?? {};

        return postV1DocumentTypeDeactivate(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type PostV1DocumentTypeDeactivateMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof usePostV1DocumentTypeDeactivateHook>>>
>;
export type PostV1DocumentTypeDeactivateMutationBody =
    DeactivateDocumentTypeRequest;
export type PostV1DocumentTypeDeactivateMutationError = ErrorType<unknown>;

export const usePostV1DocumentTypeDeactivate = <
    TError = ErrorType<unknown>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<
            ReturnType<ReturnType<typeof usePostV1DocumentTypeDeactivateHook>>
        >,
        TError,
        { data: DeactivateDocumentTypeRequest },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof usePostV1DocumentTypeDeactivateHook>>>,
    TError,
    { data: DeactivateDocumentTypeRequest },
    TContext
> => {
    const mutationOptions =
        usePostV1DocumentTypeDeactivateMutationOptions(options);

    return useMutation(mutationOptions);
};

/**
 * Returns a list of document type fields associated with the specified document type ID. Admin access required.
 * @summary Retrieve document type fields for a specific document type.
 */
export const useGetV1DocumentTypeDocumentTypeIdDocumentTypeFieldsHook = () => {
    const getV1DocumentTypeDocumentTypeIdDocumentTypeFields =
        useCustomAxios<DocumentTypeFieldsWithValidationResponse>();

    return useCallback(
        (
            documentTypeId: number,
            params?: GetV1DocumentTypeDocumentTypeIdDocumentTypeFieldsParams
        ) => {
            return getV1DocumentTypeDocumentTypeIdDocumentTypeFields({
                url: `/v1/DocumentType/${documentTypeId}/DocumentTypeFields`,
                method: 'GET',
                params,
            });
        },
        [getV1DocumentTypeDocumentTypeIdDocumentTypeFields]
    );
};

export const getGetV1DocumentTypeDocumentTypeIdDocumentTypeFieldsQueryKey = (
    documentTypeId: number,
    params?: GetV1DocumentTypeDocumentTypeIdDocumentTypeFieldsParams
) => {
    return [
        `/v1/DocumentType/${documentTypeId}/DocumentTypeFields`,
        ...(params ? [params] : []),
    ] as const;
};

export const useGetV1DocumentTypeDocumentTypeIdDocumentTypeFieldsQueryOptions =
    <
        TData = Awaited<
            ReturnType<
                ReturnType<
                    typeof useGetV1DocumentTypeDocumentTypeIdDocumentTypeFieldsHook
                >
            >
        >,
        TError = ErrorType<void>
    >(
        documentTypeId: number,
        params?: GetV1DocumentTypeDocumentTypeIdDocumentTypeFieldsParams,
        options?: {
            query?: UseQueryOptions<
                Awaited<
                    ReturnType<
                        ReturnType<
                            typeof useGetV1DocumentTypeDocumentTypeIdDocumentTypeFieldsHook
                        >
                    >
                >,
                TError,
                TData
            >;
        }
    ) => {
        const { query: queryOptions } = options ?? {};

        const queryKey =
            queryOptions?.queryKey ??
            getGetV1DocumentTypeDocumentTypeIdDocumentTypeFieldsQueryKey(
                documentTypeId,
                params
            );

        const getV1DocumentTypeDocumentTypeIdDocumentTypeFields =
            useGetV1DocumentTypeDocumentTypeIdDocumentTypeFieldsHook();

        const queryFn: QueryFunction<
            Awaited<
                ReturnType<
                    ReturnType<
                        typeof useGetV1DocumentTypeDocumentTypeIdDocumentTypeFieldsHook
                    >
                >
            >
        > = () =>
            getV1DocumentTypeDocumentTypeIdDocumentTypeFields(
                documentTypeId,
                params
            );

        return {
            queryKey,
            queryFn,
            enabled: !!documentTypeId,
            ...queryOptions,
        } as UseQueryOptions<
            Awaited<
                ReturnType<
                    ReturnType<
                        typeof useGetV1DocumentTypeDocumentTypeIdDocumentTypeFieldsHook
                    >
                >
            >,
            TError,
            TData
        > & { queryKey: QueryKey };
    };

export type GetV1DocumentTypeDocumentTypeIdDocumentTypeFieldsQueryResult =
    NonNullable<
        Awaited<
            ReturnType<
                ReturnType<
                    typeof useGetV1DocumentTypeDocumentTypeIdDocumentTypeFieldsHook
                >
            >
        >
    >;
export type GetV1DocumentTypeDocumentTypeIdDocumentTypeFieldsQueryError =
    ErrorType<void>;

/**
 * @summary Retrieve document type fields for a specific document type.
 */
export const useGetV1DocumentTypeDocumentTypeIdDocumentTypeFields = <
    TData = Awaited<
        ReturnType<
            ReturnType<
                typeof useGetV1DocumentTypeDocumentTypeIdDocumentTypeFieldsHook
            >
        >
    >,
    TError = ErrorType<void>
>(
    documentTypeId: number,
    params?: GetV1DocumentTypeDocumentTypeIdDocumentTypeFieldsParams,
    options?: {
        query?: UseQueryOptions<
            Awaited<
                ReturnType<
                    ReturnType<
                        typeof useGetV1DocumentTypeDocumentTypeIdDocumentTypeFieldsHook
                    >
                >
            >,
            TError,
            TData
        >;
    }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
    const queryOptions =
        useGetV1DocumentTypeDocumentTypeIdDocumentTypeFieldsQueryOptions(
            documentTypeId,
            params,
            options
        );

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
        queryKey: QueryKey;
    };

    query.queryKey = queryOptions.queryKey;

    return query;
};

/**
 * Returns Min Classification number, Max Classification number, fuzzy keywords, anti-fuzzy keywords.
 * @summary Retrieve document type details.
 */
export const useGetV1DocumentTypeDocumentTypeIdHook = () => {
    const getV1DocumentTypeDocumentTypeId = useCustomAxios<DocumentType>();

    return useCallback(
        (documentTypeId: number) => {
            return getV1DocumentTypeDocumentTypeId({
                url: `/v1/DocumentType/${documentTypeId}`,
                method: 'GET',
            });
        },
        [getV1DocumentTypeDocumentTypeId]
    );
};

export const getGetV1DocumentTypeDocumentTypeIdQueryKey = (
    documentTypeId: number
) => {
    return [`/v1/DocumentType/${documentTypeId}`] as const;
};

export const useGetV1DocumentTypeDocumentTypeIdQueryOptions = <
    TData = Awaited<
        ReturnType<ReturnType<typeof useGetV1DocumentTypeDocumentTypeIdHook>>
    >,
    TError = ErrorType<void>
>(
    documentTypeId: number,
    options?: {
        query?: UseQueryOptions<
            Awaited<
                ReturnType<
                    ReturnType<typeof useGetV1DocumentTypeDocumentTypeIdHook>
                >
            >,
            TError,
            TData
        >;
    }
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getGetV1DocumentTypeDocumentTypeIdQueryKey(documentTypeId);

    const getV1DocumentTypeDocumentTypeId =
        useGetV1DocumentTypeDocumentTypeIdHook();

    const queryFn: QueryFunction<
        Awaited<
            ReturnType<
                ReturnType<typeof useGetV1DocumentTypeDocumentTypeIdHook>
            >
        >
    > = () => getV1DocumentTypeDocumentTypeId(documentTypeId);

    return {
        queryKey,
        queryFn,
        enabled: !!documentTypeId,
        ...queryOptions,
    } as UseQueryOptions<
        Awaited<
            ReturnType<
                ReturnType<typeof useGetV1DocumentTypeDocumentTypeIdHook>
            >
        >,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetV1DocumentTypeDocumentTypeIdQueryResult = NonNullable<
    Awaited<
        ReturnType<ReturnType<typeof useGetV1DocumentTypeDocumentTypeIdHook>>
    >
>;
export type GetV1DocumentTypeDocumentTypeIdQueryError = ErrorType<void>;

/**
 * @summary Retrieve document type details.
 */
export const useGetV1DocumentTypeDocumentTypeId = <
    TData = Awaited<
        ReturnType<ReturnType<typeof useGetV1DocumentTypeDocumentTypeIdHook>>
    >,
    TError = ErrorType<void>
>(
    documentTypeId: number,
    options?: {
        query?: UseQueryOptions<
            Awaited<
                ReturnType<
                    ReturnType<typeof useGetV1DocumentTypeDocumentTypeIdHook>
                >
            >,
            TError,
            TData
        >;
    }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
    const queryOptions = useGetV1DocumentTypeDocumentTypeIdQueryOptions(
        documentTypeId,
        options
    );

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
        queryKey: QueryKey;
    };

    query.queryKey = queryOptions.queryKey;

    return query;
};

/**
 * Update Min Classification number, Max Classification number, fuzzy keywords, anti-fuzzy keywords.
 * @summary Update document type details.
 */
export const usePatchV1DocumentTypeDocumentTypeIdHook = () => {
    const patchV1DocumentTypeDocumentTypeId = useCustomAxios<DocumentType>();

    return useCallback(
        (documentTypeId: number, documentType: DocumentType) => {
            return patchV1DocumentTypeDocumentTypeId({
                url: `/v1/DocumentType/${documentTypeId}`,
                method: 'PATCH',
                headers: { 'Content-Type': 'application/json' },
                data: documentType,
            });
        },
        [patchV1DocumentTypeDocumentTypeId]
    );
};

export const usePatchV1DocumentTypeDocumentTypeIdMutationOptions = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<
            ReturnType<
                ReturnType<typeof usePatchV1DocumentTypeDocumentTypeIdHook>
            >
        >,
        TError,
        { documentTypeId: number; data: DocumentType },
        TContext
    >;
}): UseMutationOptions<
    Awaited<
        ReturnType<ReturnType<typeof usePatchV1DocumentTypeDocumentTypeIdHook>>
    >,
    TError,
    { documentTypeId: number; data: DocumentType },
    TContext
> => {
    const { mutation: mutationOptions } = options ?? {};

    const patchV1DocumentTypeDocumentTypeId =
        usePatchV1DocumentTypeDocumentTypeIdHook();

    const mutationFn: MutationFunction<
        Awaited<
            ReturnType<
                ReturnType<typeof usePatchV1DocumentTypeDocumentTypeIdHook>
            >
        >,
        { documentTypeId: number; data: DocumentType }
    > = (props) => {
        const { documentTypeId, data } = props ?? {};

        return patchV1DocumentTypeDocumentTypeId(documentTypeId, data);
    };

    return { mutationFn, ...mutationOptions };
};

export type PatchV1DocumentTypeDocumentTypeIdMutationResult = NonNullable<
    Awaited<
        ReturnType<ReturnType<typeof usePatchV1DocumentTypeDocumentTypeIdHook>>
    >
>;
export type PatchV1DocumentTypeDocumentTypeIdMutationBody = DocumentType;
export type PatchV1DocumentTypeDocumentTypeIdMutationError = ErrorType<void>;

/**
 * @summary Update document type details.
 */
export const usePatchV1DocumentTypeDocumentTypeId = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<
            ReturnType<
                ReturnType<typeof usePatchV1DocumentTypeDocumentTypeIdHook>
            >
        >,
        TError,
        { documentTypeId: number; data: DocumentType },
        TContext
    >;
}): UseMutationResult<
    Awaited<
        ReturnType<ReturnType<typeof usePatchV1DocumentTypeDocumentTypeIdHook>>
    >,
    TError,
    { documentTypeId: number; data: DocumentType },
    TContext
> => {
    const mutationOptions =
        usePatchV1DocumentTypeDocumentTypeIdMutationOptions(options);

    return useMutation(mutationOptions);
};

export const usePostV1FillOnlineFormGenerateUploadExcelTemplateHook = () => {
    const postV1FillOnlineFormGenerateUploadExcelTemplate =
        useCustomAxios<GenerateExcelTemplateResponse>();

    return useCallback(
        (generateExcelTemplateRequest: GenerateExcelTemplateRequest) => {
            return postV1FillOnlineFormGenerateUploadExcelTemplate({
                url: `/v1/FillOnlineForm/GenerateUploadExcelTemplate`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: generateExcelTemplateRequest,
            });
        },
        [postV1FillOnlineFormGenerateUploadExcelTemplate]
    );
};

export const usePostV1FillOnlineFormGenerateUploadExcelTemplateMutationOptions =
    <TError = ErrorType<void>, TContext = unknown>(options?: {
        mutation?: UseMutationOptions<
            Awaited<
                ReturnType<
                    ReturnType<
                        typeof usePostV1FillOnlineFormGenerateUploadExcelTemplateHook
                    >
                >
            >,
            TError,
            { data: GenerateExcelTemplateRequest },
            TContext
        >;
    }): UseMutationOptions<
        Awaited<
            ReturnType<
                ReturnType<
                    typeof usePostV1FillOnlineFormGenerateUploadExcelTemplateHook
                >
            >
        >,
        TError,
        { data: GenerateExcelTemplateRequest },
        TContext
    > => {
        const { mutation: mutationOptions } = options ?? {};

        const postV1FillOnlineFormGenerateUploadExcelTemplate =
            usePostV1FillOnlineFormGenerateUploadExcelTemplateHook();

        const mutationFn: MutationFunction<
            Awaited<
                ReturnType<
                    ReturnType<
                        typeof usePostV1FillOnlineFormGenerateUploadExcelTemplateHook
                    >
                >
            >,
            { data: GenerateExcelTemplateRequest }
        > = (props) => {
            const { data } = props ?? {};

            return postV1FillOnlineFormGenerateUploadExcelTemplate(data);
        };

        return { mutationFn, ...mutationOptions };
    };

export type PostV1FillOnlineFormGenerateUploadExcelTemplateMutationResult =
    NonNullable<
        Awaited<
            ReturnType<
                ReturnType<
                    typeof usePostV1FillOnlineFormGenerateUploadExcelTemplateHook
                >
            >
        >
    >;
export type PostV1FillOnlineFormGenerateUploadExcelTemplateMutationBody =
    GenerateExcelTemplateRequest;
export type PostV1FillOnlineFormGenerateUploadExcelTemplateMutationError =
    ErrorType<void>;

export const usePostV1FillOnlineFormGenerateUploadExcelTemplate = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<
            ReturnType<
                ReturnType<
                    typeof usePostV1FillOnlineFormGenerateUploadExcelTemplateHook
                >
            >
        >,
        TError,
        { data: GenerateExcelTemplateRequest },
        TContext
    >;
}): UseMutationResult<
    Awaited<
        ReturnType<
            ReturnType<
                typeof usePostV1FillOnlineFormGenerateUploadExcelTemplateHook
            >
        >
    >,
    TError,
    { data: GenerateExcelTemplateRequest },
    TContext
> => {
    const mutationOptions =
        usePostV1FillOnlineFormGenerateUploadExcelTemplateMutationOptions(
            options
        );

    return useMutation(mutationOptions);
};

export const usePostV1FillOnlineFormUploadExcelHook = () => {
    const postV1FillOnlineFormUploadExcel =
        useCustomAxios<FillOnlineFormUploadResponse>();

    return useCallback(
        (
            postV1FillOnlineFormUploadExcelBody: PostV1FillOnlineFormUploadExcelBody
        ) => {
            const formData = new FormData();
            formData.append(
                'ProcessId',
                postV1FillOnlineFormUploadExcelBody.ProcessId.toString()
            );
            formData.append('File', postV1FillOnlineFormUploadExcelBody.File);
            if (
                postV1FillOnlineFormUploadExcelBody.ValidateUnnecessaryFields !==
                undefined
            ) {
                formData.append(
                    'ValidateUnnecessaryFields',
                    postV1FillOnlineFormUploadExcelBody.ValidateUnnecessaryFields.toString()
                );
            }

            return postV1FillOnlineFormUploadExcel({
                url: `/v1/FillOnlineForm/UploadExcel`,
                method: 'POST',
                headers: { 'Content-Type': 'multipart/form-data' },
                data: formData,
            });
        },
        [postV1FillOnlineFormUploadExcel]
    );
};

export const usePostV1FillOnlineFormUploadExcelMutationOptions = <
    TError = ErrorType<string[]>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<
            ReturnType<
                ReturnType<typeof usePostV1FillOnlineFormUploadExcelHook>
            >
        >,
        TError,
        { data: PostV1FillOnlineFormUploadExcelBody },
        TContext
    >;
}): UseMutationOptions<
    Awaited<
        ReturnType<ReturnType<typeof usePostV1FillOnlineFormUploadExcelHook>>
    >,
    TError,
    { data: PostV1FillOnlineFormUploadExcelBody },
    TContext
> => {
    const { mutation: mutationOptions } = options ?? {};

    const postV1FillOnlineFormUploadExcel =
        usePostV1FillOnlineFormUploadExcelHook();

    const mutationFn: MutationFunction<
        Awaited<
            ReturnType<
                ReturnType<typeof usePostV1FillOnlineFormUploadExcelHook>
            >
        >,
        { data: PostV1FillOnlineFormUploadExcelBody }
    > = (props) => {
        const { data } = props ?? {};

        return postV1FillOnlineFormUploadExcel(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type PostV1FillOnlineFormUploadExcelMutationResult = NonNullable<
    Awaited<
        ReturnType<ReturnType<typeof usePostV1FillOnlineFormUploadExcelHook>>
    >
>;
export type PostV1FillOnlineFormUploadExcelMutationBody =
    PostV1FillOnlineFormUploadExcelBody;
export type PostV1FillOnlineFormUploadExcelMutationError = ErrorType<string[]>;

export const usePostV1FillOnlineFormUploadExcel = <
    TError = ErrorType<string[]>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<
            ReturnType<
                ReturnType<typeof usePostV1FillOnlineFormUploadExcelHook>
            >
        >,
        TError,
        { data: PostV1FillOnlineFormUploadExcelBody },
        TContext
    >;
}): UseMutationResult<
    Awaited<
        ReturnType<ReturnType<typeof usePostV1FillOnlineFormUploadExcelHook>>
    >,
    TError,
    { data: PostV1FillOnlineFormUploadExcelBody },
    TContext
> => {
    const mutationOptions =
        usePostV1FillOnlineFormUploadExcelMutationOptions(options);

    return useMutation(mutationOptions);
};

/**
 * @summary Get fields in a given online form.
 */
export const useGetV1FillOnlineFormGetOnlineFormFieldsHook = () => {
    const getV1FillOnlineFormGetOnlineFormFields =
        useCustomAxios<GetOnlineFormFieldsResponse>();

    return useCallback(
        (params: GetV1FillOnlineFormGetOnlineFormFieldsParams) => {
            return getV1FillOnlineFormGetOnlineFormFields({
                url: `/v1/FillOnlineForm/GetOnlineFormFields`,
                method: 'GET',
                params,
            });
        },
        [getV1FillOnlineFormGetOnlineFormFields]
    );
};

export const getGetV1FillOnlineFormGetOnlineFormFieldsQueryKey = (
    params: GetV1FillOnlineFormGetOnlineFormFieldsParams
) => {
    return [
        `/v1/FillOnlineForm/GetOnlineFormFields`,
        ...(params ? [params] : []),
    ] as const;
};

export const useGetV1FillOnlineFormGetOnlineFormFieldsQueryOptions = <
    TData = Awaited<
        ReturnType<
            ReturnType<typeof useGetV1FillOnlineFormGetOnlineFormFieldsHook>
        >
    >,
    TError = ErrorType<void>
>(
    params: GetV1FillOnlineFormGetOnlineFormFieldsParams,
    options?: {
        query?: UseQueryOptions<
            Awaited<
                ReturnType<
                    ReturnType<
                        typeof useGetV1FillOnlineFormGetOnlineFormFieldsHook
                    >
                >
            >,
            TError,
            TData
        >;
    }
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getGetV1FillOnlineFormGetOnlineFormFieldsQueryKey(params);

    const getV1FillOnlineFormGetOnlineFormFields =
        useGetV1FillOnlineFormGetOnlineFormFieldsHook();

    const queryFn: QueryFunction<
        Awaited<
            ReturnType<
                ReturnType<typeof useGetV1FillOnlineFormGetOnlineFormFieldsHook>
            >
        >
    > = () => getV1FillOnlineFormGetOnlineFormFields(params);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<
            ReturnType<
                ReturnType<typeof useGetV1FillOnlineFormGetOnlineFormFieldsHook>
            >
        >,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetV1FillOnlineFormGetOnlineFormFieldsQueryResult = NonNullable<
    Awaited<
        ReturnType<
            ReturnType<typeof useGetV1FillOnlineFormGetOnlineFormFieldsHook>
        >
    >
>;
export type GetV1FillOnlineFormGetOnlineFormFieldsQueryError = ErrorType<void>;

/**
 * @summary Get fields in a given online form.
 */
export const useGetV1FillOnlineFormGetOnlineFormFields = <
    TData = Awaited<
        ReturnType<
            ReturnType<typeof useGetV1FillOnlineFormGetOnlineFormFieldsHook>
        >
    >,
    TError = ErrorType<void>
>(
    params: GetV1FillOnlineFormGetOnlineFormFieldsParams,
    options?: {
        query?: UseQueryOptions<
            Awaited<
                ReturnType<
                    ReturnType<
                        typeof useGetV1FillOnlineFormGetOnlineFormFieldsHook
                    >
                >
            >,
            TError,
            TData
        >;
    }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
    const queryOptions = useGetV1FillOnlineFormGetOnlineFormFieldsQueryOptions(
        params,
        options
    );

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
        queryKey: QueryKey;
    };

    query.queryKey = queryOptions.queryKey;

    return query;
};

/**
 * @summary Updates fields for an online form.
 */
export const usePostV1FillOnlineFormUpdateOnlineFormFieldsHook = () => {
    const postV1FillOnlineFormUpdateOnlineFormFields = useCustomAxios<void>();

    return useCallback(
        (updateExtractedFieldsDTO: UpdateExtractedFieldsDTO) => {
            return postV1FillOnlineFormUpdateOnlineFormFields({
                url: `/v1/FillOnlineForm/UpdateOnlineFormFields`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: updateExtractedFieldsDTO,
            });
        },
        [postV1FillOnlineFormUpdateOnlineFormFields]
    );
};

export const usePostV1FillOnlineFormUpdateOnlineFormFieldsMutationOptions = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<
            ReturnType<
                ReturnType<
                    typeof usePostV1FillOnlineFormUpdateOnlineFormFieldsHook
                >
            >
        >,
        TError,
        { data: UpdateExtractedFieldsDTO },
        TContext
    >;
}): UseMutationOptions<
    Awaited<
        ReturnType<
            ReturnType<typeof usePostV1FillOnlineFormUpdateOnlineFormFieldsHook>
        >
    >,
    TError,
    { data: UpdateExtractedFieldsDTO },
    TContext
> => {
    const { mutation: mutationOptions } = options ?? {};

    const postV1FillOnlineFormUpdateOnlineFormFields =
        usePostV1FillOnlineFormUpdateOnlineFormFieldsHook();

    const mutationFn: MutationFunction<
        Awaited<
            ReturnType<
                ReturnType<
                    typeof usePostV1FillOnlineFormUpdateOnlineFormFieldsHook
                >
            >
        >,
        { data: UpdateExtractedFieldsDTO }
    > = (props) => {
        const { data } = props ?? {};

        return postV1FillOnlineFormUpdateOnlineFormFields(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type PostV1FillOnlineFormUpdateOnlineFormFieldsMutationResult =
    NonNullable<
        Awaited<
            ReturnType<
                ReturnType<
                    typeof usePostV1FillOnlineFormUpdateOnlineFormFieldsHook
                >
            >
        >
    >;
export type PostV1FillOnlineFormUpdateOnlineFormFieldsMutationBody =
    UpdateExtractedFieldsDTO;
export type PostV1FillOnlineFormUpdateOnlineFormFieldsMutationError =
    ErrorType<void>;

/**
 * @summary Updates fields for an online form.
 */
export const usePostV1FillOnlineFormUpdateOnlineFormFields = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<
            ReturnType<
                ReturnType<
                    typeof usePostV1FillOnlineFormUpdateOnlineFormFieldsHook
                >
            >
        >,
        TError,
        { data: UpdateExtractedFieldsDTO },
        TContext
    >;
}): UseMutationResult<
    Awaited<
        ReturnType<
            ReturnType<typeof usePostV1FillOnlineFormUpdateOnlineFormFieldsHook>
        >
    >,
    TError,
    { data: UpdateExtractedFieldsDTO },
    TContext
> => {
    const mutationOptions =
        usePostV1FillOnlineFormUpdateOnlineFormFieldsMutationOptions(options);

    return useMutation(mutationOptions);
};

export const usePostV1FillPdfCreateHook = () => {
    const postV1FillPdfCreate = useCustomAxios<CreateFillPdfResponse>();

    return useCallback(
        (postV1FillPdfCreateBody: PostV1FillPdfCreateBody) => {
            const formData = new FormData();
            if (postV1FillPdfCreateBody.DocumentTypeName !== undefined) {
                formData.append(
                    'DocumentTypeName',
                    postV1FillPdfCreateBody.DocumentTypeName
                );
            }
            if (postV1FillPdfCreateBody.File !== undefined) {
                formData.append('File', postV1FillPdfCreateBody.File);
            }

            return postV1FillPdfCreate({
                url: `/v1/FillPdf/Create`,
                method: 'POST',
                headers: { 'Content-Type': 'multipart/form-data' },
                data: formData,
            });
        },
        [postV1FillPdfCreate]
    );
};

export const usePostV1FillPdfCreateMutationOptions = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof usePostV1FillPdfCreateHook>>>,
        TError,
        { data: PostV1FillPdfCreateBody },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof usePostV1FillPdfCreateHook>>>,
    TError,
    { data: PostV1FillPdfCreateBody },
    TContext
> => {
    const { mutation: mutationOptions } = options ?? {};

    const postV1FillPdfCreate = usePostV1FillPdfCreateHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof usePostV1FillPdfCreateHook>>>,
        { data: PostV1FillPdfCreateBody }
    > = (props) => {
        const { data } = props ?? {};

        return postV1FillPdfCreate(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type PostV1FillPdfCreateMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof usePostV1FillPdfCreateHook>>>
>;
export type PostV1FillPdfCreateMutationBody = PostV1FillPdfCreateBody;
export type PostV1FillPdfCreateMutationError = ErrorType<void>;

export const usePostV1FillPdfCreate = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof usePostV1FillPdfCreateHook>>>,
        TError,
        { data: PostV1FillPdfCreateBody },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof usePostV1FillPdfCreateHook>>>,
    TError,
    { data: PostV1FillPdfCreateBody },
    TContext
> => {
    const mutationOptions = usePostV1FillPdfCreateMutationOptions(options);

    return useMutation(mutationOptions);
};

export const usePostV1FillPdfGenerateUploadExcelTemplateHook = () => {
    const postV1FillPdfGenerateUploadExcelTemplate =
        useCustomAxios<GenerateUploadTemplateResponse>();

    return useCallback(
        (generateUploadTemplateRequest: GenerateUploadTemplateRequest) => {
            return postV1FillPdfGenerateUploadExcelTemplate({
                url: `/v1/FillPdf/GenerateUploadExcelTemplate`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: generateUploadTemplateRequest,
            });
        },
        [postV1FillPdfGenerateUploadExcelTemplate]
    );
};

export const usePostV1FillPdfGenerateUploadExcelTemplateMutationOptions = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<
            ReturnType<
                ReturnType<
                    typeof usePostV1FillPdfGenerateUploadExcelTemplateHook
                >
            >
        >,
        TError,
        { data: GenerateUploadTemplateRequest },
        TContext
    >;
}): UseMutationOptions<
    Awaited<
        ReturnType<
            ReturnType<typeof usePostV1FillPdfGenerateUploadExcelTemplateHook>
        >
    >,
    TError,
    { data: GenerateUploadTemplateRequest },
    TContext
> => {
    const { mutation: mutationOptions } = options ?? {};

    const postV1FillPdfGenerateUploadExcelTemplate =
        usePostV1FillPdfGenerateUploadExcelTemplateHook();

    const mutationFn: MutationFunction<
        Awaited<
            ReturnType<
                ReturnType<
                    typeof usePostV1FillPdfGenerateUploadExcelTemplateHook
                >
            >
        >,
        { data: GenerateUploadTemplateRequest }
    > = (props) => {
        const { data } = props ?? {};

        return postV1FillPdfGenerateUploadExcelTemplate(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type PostV1FillPdfGenerateUploadExcelTemplateMutationResult =
    NonNullable<
        Awaited<
            ReturnType<
                ReturnType<
                    typeof usePostV1FillPdfGenerateUploadExcelTemplateHook
                >
            >
        >
    >;
export type PostV1FillPdfGenerateUploadExcelTemplateMutationBody =
    GenerateUploadTemplateRequest;
export type PostV1FillPdfGenerateUploadExcelTemplateMutationError =
    ErrorType<void>;

export const usePostV1FillPdfGenerateUploadExcelTemplate = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<
            ReturnType<
                ReturnType<
                    typeof usePostV1FillPdfGenerateUploadExcelTemplateHook
                >
            >
        >,
        TError,
        { data: GenerateUploadTemplateRequest },
        TContext
    >;
}): UseMutationResult<
    Awaited<
        ReturnType<
            ReturnType<typeof usePostV1FillPdfGenerateUploadExcelTemplateHook>
        >
    >,
    TError,
    { data: GenerateUploadTemplateRequest },
    TContext
> => {
    const mutationOptions =
        usePostV1FillPdfGenerateUploadExcelTemplateMutationOptions(options);

    return useMutation(mutationOptions);
};

export const usePostV1FillPdfUploadExcelHook = () => {
    const postV1FillPdfUploadExcel = useCustomAxios<FillPdfUploadResponse>();

    return useCallback(
        (postV1FillPdfUploadExcelBody: PostV1FillPdfUploadExcelBody) => {
            const formData = new FormData();
            formData.append(
                'ProcessId',
                postV1FillPdfUploadExcelBody.ProcessId.toString()
            );
            formData.append('File', postV1FillPdfUploadExcelBody.File);

            return postV1FillPdfUploadExcel({
                url: `/v1/FillPdf/UploadExcel`,
                method: 'POST',
                headers: { 'Content-Type': 'multipart/form-data' },
                data: formData,
            });
        },
        [postV1FillPdfUploadExcel]
    );
};

export const usePostV1FillPdfUploadExcelMutationOptions = <
    TError = ErrorType<string[]>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof usePostV1FillPdfUploadExcelHook>>>,
        TError,
        { data: PostV1FillPdfUploadExcelBody },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof usePostV1FillPdfUploadExcelHook>>>,
    TError,
    { data: PostV1FillPdfUploadExcelBody },
    TContext
> => {
    const { mutation: mutationOptions } = options ?? {};

    const postV1FillPdfUploadExcel = usePostV1FillPdfUploadExcelHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof usePostV1FillPdfUploadExcelHook>>>,
        { data: PostV1FillPdfUploadExcelBody }
    > = (props) => {
        const { data } = props ?? {};

        return postV1FillPdfUploadExcel(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type PostV1FillPdfUploadExcelMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof usePostV1FillPdfUploadExcelHook>>>
>;
export type PostV1FillPdfUploadExcelMutationBody = PostV1FillPdfUploadExcelBody;
export type PostV1FillPdfUploadExcelMutationError = ErrorType<string[]>;

export const usePostV1FillPdfUploadExcel = <
    TError = ErrorType<string[]>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof usePostV1FillPdfUploadExcelHook>>>,
        TError,
        { data: PostV1FillPdfUploadExcelBody },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof usePostV1FillPdfUploadExcelHook>>>,
    TError,
    { data: PostV1FillPdfUploadExcelBody },
    TContext
> => {
    const mutationOptions = usePostV1FillPdfUploadExcelMutationOptions(options);

    return useMutation(mutationOptions);
};

/**
 * @summary Returns a list of all folders for the requesting folder's tenant
Super Admins are able to specify a TenantId from which the folders are retrieved
 */
export const useGetV1FolderHook = () => {
    const getV1Folder = useCustomAxios<PaginatedFolderResponse>();

    return useCallback(
        (params?: GetV1FolderParams) => {
            return getV1Folder({ url: `/v1/Folder`, method: 'GET', params });
        },
        [getV1Folder]
    );
};

export const getGetV1FolderQueryKey = (params?: GetV1FolderParams) => {
    return [`/v1/Folder`, ...(params ? [params] : [])] as const;
};

export const useGetV1FolderQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetV1FolderHook>>>,
    TError = ErrorType<void>
>(
    params?: GetV1FolderParams,
    options?: {
        query?: UseQueryOptions<
            Awaited<ReturnType<ReturnType<typeof useGetV1FolderHook>>>,
            TError,
            TData
        >;
    }
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetV1FolderQueryKey(params);

    const getV1Folder = useGetV1FolderHook();

    const queryFn: QueryFunction<
        Awaited<ReturnType<ReturnType<typeof useGetV1FolderHook>>>
    > = () => getV1Folder(params);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetV1FolderHook>>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetV1FolderQueryResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useGetV1FolderHook>>>
>;
export type GetV1FolderQueryError = ErrorType<void>;

/**
 * @summary Returns a list of all folders for the requesting folder's tenant
Super Admins are able to specify a TenantId from which the folders are retrieved
 */
export const useGetV1Folder = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetV1FolderHook>>>,
    TError = ErrorType<void>
>(
    params?: GetV1FolderParams,
    options?: {
        query?: UseQueryOptions<
            Awaited<ReturnType<ReturnType<typeof useGetV1FolderHook>>>,
            TError,
            TData
        >;
    }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
    const queryOptions = useGetV1FolderQueryOptions(params, options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
        queryKey: QueryKey;
    };

    query.queryKey = queryOptions.queryKey;

    return query;
};

export const usePostV1FolderHook = () => {
    const postV1Folder = useCustomAxios<FolderResponse>();

    return useCallback(
        (createFolderRequest: CreateFolderRequest) => {
            return postV1Folder({
                url: `/v1/Folder`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: createFolderRequest,
            });
        },
        [postV1Folder]
    );
};

export const usePostV1FolderMutationOptions = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof usePostV1FolderHook>>>,
        TError,
        { data: CreateFolderRequest },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof usePostV1FolderHook>>>,
    TError,
    { data: CreateFolderRequest },
    TContext
> => {
    const { mutation: mutationOptions } = options ?? {};

    const postV1Folder = usePostV1FolderHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof usePostV1FolderHook>>>,
        { data: CreateFolderRequest }
    > = (props) => {
        const { data } = props ?? {};

        return postV1Folder(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type PostV1FolderMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof usePostV1FolderHook>>>
>;
export type PostV1FolderMutationBody = CreateFolderRequest;
export type PostV1FolderMutationError = ErrorType<void>;

export const usePostV1Folder = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof usePostV1FolderHook>>>,
        TError,
        { data: CreateFolderRequest },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof usePostV1FolderHook>>>,
    TError,
    { data: CreateFolderRequest },
    TContext
> => {
    const mutationOptions = usePostV1FolderMutationOptions(options);

    return useMutation(mutationOptions);
};

/**
 * @summary Returns a list of all users for a specific folder
 */
export const useGetV1FolderFolderIdUsersHook = () => {
    const getV1FolderFolderIdUsers =
        useCustomAxios<PaginatedFolderUsersResponse>();

    return useCallback(
        (folderId: number, params?: GetV1FolderFolderIdUsersParams) => {
            return getV1FolderFolderIdUsers({
                url: `/v1/Folder/${folderId}/Users`,
                method: 'GET',
                params,
            });
        },
        [getV1FolderFolderIdUsers]
    );
};

export const getGetV1FolderFolderIdUsersQueryKey = (
    folderId: number,
    params?: GetV1FolderFolderIdUsersParams
) => {
    return [
        `/v1/Folder/${folderId}/Users`,
        ...(params ? [params] : []),
    ] as const;
};

export const useGetV1FolderFolderIdUsersQueryOptions = <
    TData = Awaited<
        ReturnType<ReturnType<typeof useGetV1FolderFolderIdUsersHook>>
    >,
    TError = ErrorType<void>
>(
    folderId: number,
    params?: GetV1FolderFolderIdUsersParams,
    options?: {
        query?: UseQueryOptions<
            Awaited<
                ReturnType<ReturnType<typeof useGetV1FolderFolderIdUsersHook>>
            >,
            TError,
            TData
        >;
    }
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getGetV1FolderFolderIdUsersQueryKey(folderId, params);

    const getV1FolderFolderIdUsers = useGetV1FolderFolderIdUsersHook();

    const queryFn: QueryFunction<
        Awaited<ReturnType<ReturnType<typeof useGetV1FolderFolderIdUsersHook>>>
    > = () => getV1FolderFolderIdUsers(folderId, params);

    return {
        queryKey,
        queryFn,
        enabled: !!folderId,
        ...queryOptions,
    } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetV1FolderFolderIdUsersHook>>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetV1FolderFolderIdUsersQueryResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useGetV1FolderFolderIdUsersHook>>>
>;
export type GetV1FolderFolderIdUsersQueryError = ErrorType<void>;

/**
 * @summary Returns a list of all users for a specific folder
 */
export const useGetV1FolderFolderIdUsers = <
    TData = Awaited<
        ReturnType<ReturnType<typeof useGetV1FolderFolderIdUsersHook>>
    >,
    TError = ErrorType<void>
>(
    folderId: number,
    params?: GetV1FolderFolderIdUsersParams,
    options?: {
        query?: UseQueryOptions<
            Awaited<
                ReturnType<ReturnType<typeof useGetV1FolderFolderIdUsersHook>>
            >,
            TError,
            TData
        >;
    }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
    const queryOptions = useGetV1FolderFolderIdUsersQueryOptions(
        folderId,
        params,
        options
    );

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
        queryKey: QueryKey;
    };

    query.queryKey = queryOptions.queryKey;

    return query;
};

export const usePutV1FolderFolderIdHook = () => {
    const putV1FolderFolderId = useCustomAxios<FolderResponse>();

    return useCallback(
        (folderId: number, editFolderRequest: EditFolderRequest) => {
            return putV1FolderFolderId({
                url: `/v1/Folder/${folderId}`,
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                data: editFolderRequest,
            });
        },
        [putV1FolderFolderId]
    );
};

export const usePutV1FolderFolderIdMutationOptions = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof usePutV1FolderFolderIdHook>>>,
        TError,
        { folderId: number; data: EditFolderRequest },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof usePutV1FolderFolderIdHook>>>,
    TError,
    { folderId: number; data: EditFolderRequest },
    TContext
> => {
    const { mutation: mutationOptions } = options ?? {};

    const putV1FolderFolderId = usePutV1FolderFolderIdHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof usePutV1FolderFolderIdHook>>>,
        { folderId: number; data: EditFolderRequest }
    > = (props) => {
        const { folderId, data } = props ?? {};

        return putV1FolderFolderId(folderId, data);
    };

    return { mutationFn, ...mutationOptions };
};

export type PutV1FolderFolderIdMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof usePutV1FolderFolderIdHook>>>
>;
export type PutV1FolderFolderIdMutationBody = EditFolderRequest;
export type PutV1FolderFolderIdMutationError = ErrorType<void>;

export const usePutV1FolderFolderId = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof usePutV1FolderFolderIdHook>>>,
        TError,
        { folderId: number; data: EditFolderRequest },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof usePutV1FolderFolderIdHook>>>,
    TError,
    { folderId: number; data: EditFolderRequest },
    TContext
> => {
    const mutationOptions = usePutV1FolderFolderIdMutationOptions(options);

    return useMutation(mutationOptions);
};

export const usePutV1FolderFolderIdArchiveHook = () => {
    const putV1FolderFolderIdArchive = useCustomAxios<void>();

    return useCallback(
        (folderId: number) => {
            return putV1FolderFolderIdArchive({
                url: `/v1/Folder/${folderId}/Archive`,
                method: 'PUT',
            });
        },
        [putV1FolderFolderIdArchive]
    );
};

export const usePutV1FolderFolderIdArchiveMutationOptions = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<
            ReturnType<ReturnType<typeof usePutV1FolderFolderIdArchiveHook>>
        >,
        TError,
        { folderId: number },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof usePutV1FolderFolderIdArchiveHook>>>,
    TError,
    { folderId: number },
    TContext
> => {
    const { mutation: mutationOptions } = options ?? {};

    const putV1FolderFolderIdArchive = usePutV1FolderFolderIdArchiveHook();

    const mutationFn: MutationFunction<
        Awaited<
            ReturnType<ReturnType<typeof usePutV1FolderFolderIdArchiveHook>>
        >,
        { folderId: number }
    > = (props) => {
        const { folderId } = props ?? {};

        return putV1FolderFolderIdArchive(folderId);
    };

    return { mutationFn, ...mutationOptions };
};

export type PutV1FolderFolderIdArchiveMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof usePutV1FolderFolderIdArchiveHook>>>
>;

export type PutV1FolderFolderIdArchiveMutationError = ErrorType<void>;

export const usePutV1FolderFolderIdArchive = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<
            ReturnType<ReturnType<typeof usePutV1FolderFolderIdArchiveHook>>
        >,
        TError,
        { folderId: number },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof usePutV1FolderFolderIdArchiveHook>>>,
    TError,
    { folderId: number },
    TContext
> => {
    const mutationOptions =
        usePutV1FolderFolderIdArchiveMutationOptions(options);

    return useMutation(mutationOptions);
};

export const usePostV1FolderFolderIdAddFolderPersonasHook = () => {
    const postV1FolderFolderIdAddFolderPersonas = useCustomAxios<void>();

    return useCallback(
        (
            folderId: number,
            addFolderPersonasRequest: AddFolderPersonasRequest
        ) => {
            return postV1FolderFolderIdAddFolderPersonas({
                url: `/v1/Folder/${folderId}/AddFolderPersonas`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: addFolderPersonasRequest,
            });
        },
        [postV1FolderFolderIdAddFolderPersonas]
    );
};

export const usePostV1FolderFolderIdAddFolderPersonasMutationOptions = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<
            ReturnType<
                ReturnType<typeof usePostV1FolderFolderIdAddFolderPersonasHook>
            >
        >,
        TError,
        { folderId: number; data: AddFolderPersonasRequest },
        TContext
    >;
}): UseMutationOptions<
    Awaited<
        ReturnType<
            ReturnType<typeof usePostV1FolderFolderIdAddFolderPersonasHook>
        >
    >,
    TError,
    { folderId: number; data: AddFolderPersonasRequest },
    TContext
> => {
    const { mutation: mutationOptions } = options ?? {};

    const postV1FolderFolderIdAddFolderPersonas =
        usePostV1FolderFolderIdAddFolderPersonasHook();

    const mutationFn: MutationFunction<
        Awaited<
            ReturnType<
                ReturnType<typeof usePostV1FolderFolderIdAddFolderPersonasHook>
            >
        >,
        { folderId: number; data: AddFolderPersonasRequest }
    > = (props) => {
        const { folderId, data } = props ?? {};

        return postV1FolderFolderIdAddFolderPersonas(folderId, data);
    };

    return { mutationFn, ...mutationOptions };
};

export type PostV1FolderFolderIdAddFolderPersonasMutationResult = NonNullable<
    Awaited<
        ReturnType<
            ReturnType<typeof usePostV1FolderFolderIdAddFolderPersonasHook>
        >
    >
>;
export type PostV1FolderFolderIdAddFolderPersonasMutationBody =
    AddFolderPersonasRequest;
export type PostV1FolderFolderIdAddFolderPersonasMutationError =
    ErrorType<void>;

export const usePostV1FolderFolderIdAddFolderPersonas = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<
            ReturnType<
                ReturnType<typeof usePostV1FolderFolderIdAddFolderPersonasHook>
            >
        >,
        TError,
        { folderId: number; data: AddFolderPersonasRequest },
        TContext
    >;
}): UseMutationResult<
    Awaited<
        ReturnType<
            ReturnType<typeof usePostV1FolderFolderIdAddFolderPersonasHook>
        >
    >,
    TError,
    { folderId: number; data: AddFolderPersonasRequest },
    TContext
> => {
    const mutationOptions =
        usePostV1FolderFolderIdAddFolderPersonasMutationOptions(options);

    return useMutation(mutationOptions);
};

export const usePutV1FolderFolderIdModifyFolderPersonasHook = () => {
    const putV1FolderFolderIdModifyFolderPersonas = useCustomAxios<void>();

    return useCallback(
        (
            folderId: number,
            modifyFolderPersonasRequest: ModifyFolderPersonasRequest
        ) => {
            return putV1FolderFolderIdModifyFolderPersonas({
                url: `/v1/Folder/${folderId}/ModifyFolderPersonas`,
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                data: modifyFolderPersonasRequest,
            });
        },
        [putV1FolderFolderIdModifyFolderPersonas]
    );
};

export const usePutV1FolderFolderIdModifyFolderPersonasMutationOptions = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<
            ReturnType<
                ReturnType<
                    typeof usePutV1FolderFolderIdModifyFolderPersonasHook
                >
            >
        >,
        TError,
        { folderId: number; data: ModifyFolderPersonasRequest },
        TContext
    >;
}): UseMutationOptions<
    Awaited<
        ReturnType<
            ReturnType<typeof usePutV1FolderFolderIdModifyFolderPersonasHook>
        >
    >,
    TError,
    { folderId: number; data: ModifyFolderPersonasRequest },
    TContext
> => {
    const { mutation: mutationOptions } = options ?? {};

    const putV1FolderFolderIdModifyFolderPersonas =
        usePutV1FolderFolderIdModifyFolderPersonasHook();

    const mutationFn: MutationFunction<
        Awaited<
            ReturnType<
                ReturnType<
                    typeof usePutV1FolderFolderIdModifyFolderPersonasHook
                >
            >
        >,
        { folderId: number; data: ModifyFolderPersonasRequest }
    > = (props) => {
        const { folderId, data } = props ?? {};

        return putV1FolderFolderIdModifyFolderPersonas(folderId, data);
    };

    return { mutationFn, ...mutationOptions };
};

export type PutV1FolderFolderIdModifyFolderPersonasMutationResult = NonNullable<
    Awaited<
        ReturnType<
            ReturnType<typeof usePutV1FolderFolderIdModifyFolderPersonasHook>
        >
    >
>;
export type PutV1FolderFolderIdModifyFolderPersonasMutationBody =
    ModifyFolderPersonasRequest;
export type PutV1FolderFolderIdModifyFolderPersonasMutationError =
    ErrorType<void>;

export const usePutV1FolderFolderIdModifyFolderPersonas = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<
            ReturnType<
                ReturnType<
                    typeof usePutV1FolderFolderIdModifyFolderPersonasHook
                >
            >
        >,
        TError,
        { folderId: number; data: ModifyFolderPersonasRequest },
        TContext
    >;
}): UseMutationResult<
    Awaited<
        ReturnType<
            ReturnType<typeof usePutV1FolderFolderIdModifyFolderPersonasHook>
        >
    >,
    TError,
    { folderId: number; data: ModifyFolderPersonasRequest },
    TContext
> => {
    const mutationOptions =
        usePutV1FolderFolderIdModifyFolderPersonasMutationOptions(options);

    return useMutation(mutationOptions);
};

export const usePutV1FolderFolderIdDeletePersonaHook = () => {
    const putV1FolderFolderIdDeletePersona = useCustomAxios<void>();

    return useCallback(
        (folderId: number, params?: PutV1FolderFolderIdDeletePersonaParams) => {
            return putV1FolderFolderIdDeletePersona({
                url: `/v1/Folder/${folderId}/DeletePersona`,
                method: 'PUT',
                params,
            });
        },
        [putV1FolderFolderIdDeletePersona]
    );
};

export const usePutV1FolderFolderIdDeletePersonaMutationOptions = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<
            ReturnType<
                ReturnType<typeof usePutV1FolderFolderIdDeletePersonaHook>
            >
        >,
        TError,
        { folderId: number; params?: PutV1FolderFolderIdDeletePersonaParams },
        TContext
    >;
}): UseMutationOptions<
    Awaited<
        ReturnType<ReturnType<typeof usePutV1FolderFolderIdDeletePersonaHook>>
    >,
    TError,
    { folderId: number; params?: PutV1FolderFolderIdDeletePersonaParams },
    TContext
> => {
    const { mutation: mutationOptions } = options ?? {};

    const putV1FolderFolderIdDeletePersona =
        usePutV1FolderFolderIdDeletePersonaHook();

    const mutationFn: MutationFunction<
        Awaited<
            ReturnType<
                ReturnType<typeof usePutV1FolderFolderIdDeletePersonaHook>
            >
        >,
        { folderId: number; params?: PutV1FolderFolderIdDeletePersonaParams }
    > = (props) => {
        const { folderId, params } = props ?? {};

        return putV1FolderFolderIdDeletePersona(folderId, params);
    };

    return { mutationFn, ...mutationOptions };
};

export type PutV1FolderFolderIdDeletePersonaMutationResult = NonNullable<
    Awaited<
        ReturnType<ReturnType<typeof usePutV1FolderFolderIdDeletePersonaHook>>
    >
>;

export type PutV1FolderFolderIdDeletePersonaMutationError = ErrorType<void>;

export const usePutV1FolderFolderIdDeletePersona = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<
            ReturnType<
                ReturnType<typeof usePutV1FolderFolderIdDeletePersonaHook>
            >
        >,
        TError,
        { folderId: number; params?: PutV1FolderFolderIdDeletePersonaParams },
        TContext
    >;
}): UseMutationResult<
    Awaited<
        ReturnType<ReturnType<typeof usePutV1FolderFolderIdDeletePersonaHook>>
    >,
    TError,
    { folderId: number; params?: PutV1FolderFolderIdDeletePersonaParams },
    TContext
> => {
    const mutationOptions =
        usePutV1FolderFolderIdDeletePersonaMutationOptions(options);

    return useMutation(mutationOptions);
};

export const useGetV1FolderFolderIdPotentialUsersHook = () => {
    const getV1FolderFolderIdPotentialUsers =
        useCustomAxios<PaginatedPotentialFolderUserResponse>();

    return useCallback(
        (
            folderId: number,
            params?: GetV1FolderFolderIdPotentialUsersParams
        ) => {
            return getV1FolderFolderIdPotentialUsers({
                url: `/v1/Folder/${folderId}/PotentialUsers`,
                method: 'GET',
                params,
            });
        },
        [getV1FolderFolderIdPotentialUsers]
    );
};

export const getGetV1FolderFolderIdPotentialUsersQueryKey = (
    folderId: number,
    params?: GetV1FolderFolderIdPotentialUsersParams
) => {
    return [
        `/v1/Folder/${folderId}/PotentialUsers`,
        ...(params ? [params] : []),
    ] as const;
};

export const useGetV1FolderFolderIdPotentialUsersQueryOptions = <
    TData = Awaited<
        ReturnType<ReturnType<typeof useGetV1FolderFolderIdPotentialUsersHook>>
    >,
    TError = ErrorType<void>
>(
    folderId: number,
    params?: GetV1FolderFolderIdPotentialUsersParams,
    options?: {
        query?: UseQueryOptions<
            Awaited<
                ReturnType<
                    ReturnType<typeof useGetV1FolderFolderIdPotentialUsersHook>
                >
            >,
            TError,
            TData
        >;
    }
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getGetV1FolderFolderIdPotentialUsersQueryKey(folderId, params);

    const getV1FolderFolderIdPotentialUsers =
        useGetV1FolderFolderIdPotentialUsersHook();

    const queryFn: QueryFunction<
        Awaited<
            ReturnType<
                ReturnType<typeof useGetV1FolderFolderIdPotentialUsersHook>
            >
        >
    > = () => getV1FolderFolderIdPotentialUsers(folderId, params);

    return {
        queryKey,
        queryFn,
        enabled: !!folderId,
        ...queryOptions,
    } as UseQueryOptions<
        Awaited<
            ReturnType<
                ReturnType<typeof useGetV1FolderFolderIdPotentialUsersHook>
            >
        >,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetV1FolderFolderIdPotentialUsersQueryResult = NonNullable<
    Awaited<
        ReturnType<ReturnType<typeof useGetV1FolderFolderIdPotentialUsersHook>>
    >
>;
export type GetV1FolderFolderIdPotentialUsersQueryError = ErrorType<void>;

export const useGetV1FolderFolderIdPotentialUsers = <
    TData = Awaited<
        ReturnType<ReturnType<typeof useGetV1FolderFolderIdPotentialUsersHook>>
    >,
    TError = ErrorType<void>
>(
    folderId: number,
    params?: GetV1FolderFolderIdPotentialUsersParams,
    options?: {
        query?: UseQueryOptions<
            Awaited<
                ReturnType<
                    ReturnType<typeof useGetV1FolderFolderIdPotentialUsersHook>
                >
            >,
            TError,
            TData
        >;
    }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
    const queryOptions = useGetV1FolderFolderIdPotentialUsersQueryOptions(
        folderId,
        params,
        options
    );

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
        queryKey: QueryKey;
    };

    query.queryKey = queryOptions.queryKey;

    return query;
};

export const useGetV1FolderFolderIdGetFolderDetailsHook = () => {
    const getV1FolderFolderIdGetFolderDetails =
        useCustomAxios<FolderHierarchyResponse>();

    return useCallback(
        (folderId: number) => {
            return getV1FolderFolderIdGetFolderDetails({
                url: `/v1/Folder/${folderId}/GetFolderDetails`,
                method: 'GET',
            });
        },
        [getV1FolderFolderIdGetFolderDetails]
    );
};

export const getGetV1FolderFolderIdGetFolderDetailsQueryKey = (
    folderId: number
) => {
    return [`/v1/Folder/${folderId}/GetFolderDetails`] as const;
};

export const useGetV1FolderFolderIdGetFolderDetailsQueryOptions = <
    TData = Awaited<
        ReturnType<
            ReturnType<typeof useGetV1FolderFolderIdGetFolderDetailsHook>
        >
    >,
    TError = ErrorType<void>
>(
    folderId: number,
    options?: {
        query?: UseQueryOptions<
            Awaited<
                ReturnType<
                    ReturnType<
                        typeof useGetV1FolderFolderIdGetFolderDetailsHook
                    >
                >
            >,
            TError,
            TData
        >;
    }
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getGetV1FolderFolderIdGetFolderDetailsQueryKey(folderId);

    const getV1FolderFolderIdGetFolderDetails =
        useGetV1FolderFolderIdGetFolderDetailsHook();

    const queryFn: QueryFunction<
        Awaited<
            ReturnType<
                ReturnType<typeof useGetV1FolderFolderIdGetFolderDetailsHook>
            >
        >
    > = () => getV1FolderFolderIdGetFolderDetails(folderId);

    return {
        queryKey,
        queryFn,
        enabled: !!folderId,
        ...queryOptions,
    } as UseQueryOptions<
        Awaited<
            ReturnType<
                ReturnType<typeof useGetV1FolderFolderIdGetFolderDetailsHook>
            >
        >,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetV1FolderFolderIdGetFolderDetailsQueryResult = NonNullable<
    Awaited<
        ReturnType<
            ReturnType<typeof useGetV1FolderFolderIdGetFolderDetailsHook>
        >
    >
>;
export type GetV1FolderFolderIdGetFolderDetailsQueryError = ErrorType<void>;

export const useGetV1FolderFolderIdGetFolderDetails = <
    TData = Awaited<
        ReturnType<
            ReturnType<typeof useGetV1FolderFolderIdGetFolderDetailsHook>
        >
    >,
    TError = ErrorType<void>
>(
    folderId: number,
    options?: {
        query?: UseQueryOptions<
            Awaited<
                ReturnType<
                    ReturnType<
                        typeof useGetV1FolderFolderIdGetFolderDetailsHook
                    >
                >
            >,
            TError,
            TData
        >;
    }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
    const queryOptions = useGetV1FolderFolderIdGetFolderDetailsQueryOptions(
        folderId,
        options
    );

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
        queryKey: QueryKey;
    };

    query.queryKey = queryOptions.queryKey;

    return query;
};

/**
 * @summary Returns list of the claims for default authentication schema
 */
export const useGetV1IdentityUserInfoHook = () => {
    const getV1IdentityUserInfo = useCustomAxios<UserInfoResponse>();

    return useCallback(() => {
        return getV1IdentityUserInfo({
            url: `/v1/Identity/UserInfo`,
            method: 'GET',
        });
    }, [getV1IdentityUserInfo]);
};

export const getGetV1IdentityUserInfoQueryKey = () => {
    return [`/v1/Identity/UserInfo`] as const;
};

export const useGetV1IdentityUserInfoQueryOptions = <
    TData = Awaited<
        ReturnType<ReturnType<typeof useGetV1IdentityUserInfoHook>>
    >,
    TError = ErrorType<void>
>(options?: {
    query?: UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetV1IdentityUserInfoHook>>>,
        TError,
        TData
    >;
}) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ?? getGetV1IdentityUserInfoQueryKey();

    const getV1IdentityUserInfo = useGetV1IdentityUserInfoHook();

    const queryFn: QueryFunction<
        Awaited<ReturnType<ReturnType<typeof useGetV1IdentityUserInfoHook>>>
    > = () => getV1IdentityUserInfo();

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetV1IdentityUserInfoHook>>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetV1IdentityUserInfoQueryResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useGetV1IdentityUserInfoHook>>>
>;
export type GetV1IdentityUserInfoQueryError = ErrorType<void>;

/**
 * @summary Returns list of the claims for default authentication schema
 */
export const useGetV1IdentityUserInfo = <
    TData = Awaited<
        ReturnType<ReturnType<typeof useGetV1IdentityUserInfoHook>>
    >,
    TError = ErrorType<void>
>(options?: {
    query?: UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetV1IdentityUserInfoHook>>>,
        TError,
        TData
    >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
    const queryOptions = useGetV1IdentityUserInfoQueryOptions(options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
        queryKey: QueryKey;
    };

    query.queryKey = queryOptions.queryKey;

    return query;
};

export const useGetV1PolicyPrivacyHook = () => {
    const getV1PolicyPrivacy = useCustomAxios<PolicyResponse>();

    return useCallback(() => {
        return getV1PolicyPrivacy({ url: `/v1/Policy/Privacy`, method: 'GET' });
    }, [getV1PolicyPrivacy]);
};

export const getGetV1PolicyPrivacyQueryKey = () => {
    return [`/v1/Policy/Privacy`] as const;
};

export const useGetV1PolicyPrivacyQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetV1PolicyPrivacyHook>>>,
    TError = ErrorType<void>
>(options?: {
    query?: UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetV1PolicyPrivacyHook>>>,
        TError,
        TData
    >;
}) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetV1PolicyPrivacyQueryKey();

    const getV1PolicyPrivacy = useGetV1PolicyPrivacyHook();

    const queryFn: QueryFunction<
        Awaited<ReturnType<ReturnType<typeof useGetV1PolicyPrivacyHook>>>
    > = () => getV1PolicyPrivacy();

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetV1PolicyPrivacyHook>>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetV1PolicyPrivacyQueryResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useGetV1PolicyPrivacyHook>>>
>;
export type GetV1PolicyPrivacyQueryError = ErrorType<void>;

export const useGetV1PolicyPrivacy = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetV1PolicyPrivacyHook>>>,
    TError = ErrorType<void>
>(options?: {
    query?: UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetV1PolicyPrivacyHook>>>,
        TError,
        TData
    >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
    const queryOptions = useGetV1PolicyPrivacyQueryOptions(options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
        queryKey: QueryKey;
    };

    query.queryKey = queryOptions.queryKey;

    return query;
};

export const useGetV1PolicyCookiesHook = () => {
    const getV1PolicyCookies = useCustomAxios<PolicyResponse>();

    return useCallback(() => {
        return getV1PolicyCookies({ url: `/v1/Policy/Cookies`, method: 'GET' });
    }, [getV1PolicyCookies]);
};

export const getGetV1PolicyCookiesQueryKey = () => {
    return [`/v1/Policy/Cookies`] as const;
};

export const useGetV1PolicyCookiesQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetV1PolicyCookiesHook>>>,
    TError = ErrorType<void>
>(options?: {
    query?: UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetV1PolicyCookiesHook>>>,
        TError,
        TData
    >;
}) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetV1PolicyCookiesQueryKey();

    const getV1PolicyCookies = useGetV1PolicyCookiesHook();

    const queryFn: QueryFunction<
        Awaited<ReturnType<ReturnType<typeof useGetV1PolicyCookiesHook>>>
    > = () => getV1PolicyCookies();

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetV1PolicyCookiesHook>>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetV1PolicyCookiesQueryResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useGetV1PolicyCookiesHook>>>
>;
export type GetV1PolicyCookiesQueryError = ErrorType<void>;

export const useGetV1PolicyCookies = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetV1PolicyCookiesHook>>>,
    TError = ErrorType<void>
>(options?: {
    query?: UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetV1PolicyCookiesHook>>>,
        TError,
        TData
    >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
    const queryOptions = useGetV1PolicyCookiesQueryOptions(options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
        queryKey: QueryKey;
    };

    query.queryKey = queryOptions.queryKey;

    return query;
};

export const useGetV1PolicyTermsHook = () => {
    const getV1PolicyTerms = useCustomAxios<PolicyResponse>();

    return useCallback(() => {
        return getV1PolicyTerms({ url: `/v1/Policy/Terms`, method: 'GET' });
    }, [getV1PolicyTerms]);
};

export const getGetV1PolicyTermsQueryKey = () => {
    return [`/v1/Policy/Terms`] as const;
};

export const useGetV1PolicyTermsQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetV1PolicyTermsHook>>>,
    TError = ErrorType<void>
>(options?: {
    query?: UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetV1PolicyTermsHook>>>,
        TError,
        TData
    >;
}) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetV1PolicyTermsQueryKey();

    const getV1PolicyTerms = useGetV1PolicyTermsHook();

    const queryFn: QueryFunction<
        Awaited<ReturnType<ReturnType<typeof useGetV1PolicyTermsHook>>>
    > = () => getV1PolicyTerms();

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetV1PolicyTermsHook>>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetV1PolicyTermsQueryResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useGetV1PolicyTermsHook>>>
>;
export type GetV1PolicyTermsQueryError = ErrorType<void>;

export const useGetV1PolicyTerms = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetV1PolicyTermsHook>>>,
    TError = ErrorType<void>
>(options?: {
    query?: UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetV1PolicyTermsHook>>>,
        TError,
        TData
    >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
    const queryOptions = useGetV1PolicyTermsQueryOptions(options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
        queryKey: QueryKey;
    };

    query.queryKey = queryOptions.queryKey;

    return query;
};

export const useGetV1PolicyTermsVersionHook = () => {
    const getV1PolicyTermsVersion = useCustomAxios<PolicyVersionResponse>();

    return useCallback(() => {
        return getV1PolicyTermsVersion({
            url: `/v1/Policy/terms/version`,
            method: 'GET',
        });
    }, [getV1PolicyTermsVersion]);
};

export const getGetV1PolicyTermsVersionQueryKey = () => {
    return [`/v1/Policy/terms/version`] as const;
};

export const useGetV1PolicyTermsVersionQueryOptions = <
    TData = Awaited<
        ReturnType<ReturnType<typeof useGetV1PolicyTermsVersionHook>>
    >,
    TError = ErrorType<void>
>(options?: {
    query?: UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetV1PolicyTermsVersionHook>>>,
        TError,
        TData
    >;
}) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ?? getGetV1PolicyTermsVersionQueryKey();

    const getV1PolicyTermsVersion = useGetV1PolicyTermsVersionHook();

    const queryFn: QueryFunction<
        Awaited<ReturnType<ReturnType<typeof useGetV1PolicyTermsVersionHook>>>
    > = () => getV1PolicyTermsVersion();

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetV1PolicyTermsVersionHook>>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetV1PolicyTermsVersionQueryResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useGetV1PolicyTermsVersionHook>>>
>;
export type GetV1PolicyTermsVersionQueryError = ErrorType<void>;

export const useGetV1PolicyTermsVersion = <
    TData = Awaited<
        ReturnType<ReturnType<typeof useGetV1PolicyTermsVersionHook>>
    >,
    TError = ErrorType<void>
>(options?: {
    query?: UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetV1PolicyTermsVersionHook>>>,
        TError,
        TData
    >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
    const queryOptions = useGetV1PolicyTermsVersionQueryOptions(options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
        queryKey: QueryKey;
    };

    query.queryKey = queryOptions.queryKey;

    return query;
};

export const useGetV1PolicyCookiesVersionHook = () => {
    const getV1PolicyCookiesVersion = useCustomAxios<PolicyVersionResponse>();

    return useCallback(() => {
        return getV1PolicyCookiesVersion({
            url: `/v1/Policy/cookies/version`,
            method: 'GET',
        });
    }, [getV1PolicyCookiesVersion]);
};

export const getGetV1PolicyCookiesVersionQueryKey = () => {
    return [`/v1/Policy/cookies/version`] as const;
};

export const useGetV1PolicyCookiesVersionQueryOptions = <
    TData = Awaited<
        ReturnType<ReturnType<typeof useGetV1PolicyCookiesVersionHook>>
    >,
    TError = ErrorType<void>
>(options?: {
    query?: UseQueryOptions<
        Awaited<
            ReturnType<ReturnType<typeof useGetV1PolicyCookiesVersionHook>>
        >,
        TError,
        TData
    >;
}) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ?? getGetV1PolicyCookiesVersionQueryKey();

    const getV1PolicyCookiesVersion = useGetV1PolicyCookiesVersionHook();

    const queryFn: QueryFunction<
        Awaited<ReturnType<ReturnType<typeof useGetV1PolicyCookiesVersionHook>>>
    > = () => getV1PolicyCookiesVersion();

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<
            ReturnType<ReturnType<typeof useGetV1PolicyCookiesVersionHook>>
        >,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetV1PolicyCookiesVersionQueryResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useGetV1PolicyCookiesVersionHook>>>
>;
export type GetV1PolicyCookiesVersionQueryError = ErrorType<void>;

export const useGetV1PolicyCookiesVersion = <
    TData = Awaited<
        ReturnType<ReturnType<typeof useGetV1PolicyCookiesVersionHook>>
    >,
    TError = ErrorType<void>
>(options?: {
    query?: UseQueryOptions<
        Awaited<
            ReturnType<ReturnType<typeof useGetV1PolicyCookiesVersionHook>>
        >,
        TError,
        TData
    >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
    const queryOptions = useGetV1PolicyCookiesVersionQueryOptions(options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
        queryKey: QueryKey;
    };

    query.queryKey = queryOptions.queryKey;

    return query;
};

/**
 * @summary Add new process in a given folder.
 */
export const usePostV1ProcessAddProcessHook = () => {
    const postV1ProcessAddProcess = useCustomAxios<ProcessResponse>();

    return useCallback(
        (addProcessRequest: AddProcessRequest) => {
            return postV1ProcessAddProcess({
                url: `/v1/Process/AddProcess`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: addProcessRequest,
            });
        },
        [postV1ProcessAddProcess]
    );
};

export const usePostV1ProcessAddProcessMutationOptions = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof usePostV1ProcessAddProcessHook>>>,
        TError,
        { data: AddProcessRequest },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof usePostV1ProcessAddProcessHook>>>,
    TError,
    { data: AddProcessRequest },
    TContext
> => {
    const { mutation: mutationOptions } = options ?? {};

    const postV1ProcessAddProcess = usePostV1ProcessAddProcessHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof usePostV1ProcessAddProcessHook>>>,
        { data: AddProcessRequest }
    > = (props) => {
        const { data } = props ?? {};

        return postV1ProcessAddProcess(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type PostV1ProcessAddProcessMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof usePostV1ProcessAddProcessHook>>>
>;
export type PostV1ProcessAddProcessMutationBody = AddProcessRequest;
export type PostV1ProcessAddProcessMutationError = ErrorType<void>;

/**
 * @summary Add new process in a given folder.
 */
export const usePostV1ProcessAddProcess = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof usePostV1ProcessAddProcessHook>>>,
        TError,
        { data: AddProcessRequest },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof usePostV1ProcessAddProcessHook>>>,
    TError,
    { data: AddProcessRequest },
    TContext
> => {
    const mutationOptions = usePostV1ProcessAddProcessMutationOptions(options);

    return useMutation(mutationOptions);
};

/**
 * @summary Edit process name.
 */
export const usePutV1ProcessEditProcessHook = () => {
    const putV1ProcessEditProcess = useCustomAxios<ProcessResponse>();

    return useCallback(
        (editProcessRequest: EditProcessRequest) => {
            return putV1ProcessEditProcess({
                url: `/v1/Process/EditProcess`,
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                data: editProcessRequest,
            });
        },
        [putV1ProcessEditProcess]
    );
};

export const usePutV1ProcessEditProcessMutationOptions = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof usePutV1ProcessEditProcessHook>>>,
        TError,
        { data: EditProcessRequest },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof usePutV1ProcessEditProcessHook>>>,
    TError,
    { data: EditProcessRequest },
    TContext
> => {
    const { mutation: mutationOptions } = options ?? {};

    const putV1ProcessEditProcess = usePutV1ProcessEditProcessHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof usePutV1ProcessEditProcessHook>>>,
        { data: EditProcessRequest }
    > = (props) => {
        const { data } = props ?? {};

        return putV1ProcessEditProcess(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type PutV1ProcessEditProcessMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof usePutV1ProcessEditProcessHook>>>
>;
export type PutV1ProcessEditProcessMutationBody = EditProcessRequest;
export type PutV1ProcessEditProcessMutationError = ErrorType<void>;

/**
 * @summary Edit process name.
 */
export const usePutV1ProcessEditProcess = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof usePutV1ProcessEditProcessHook>>>,
        TError,
        { data: EditProcessRequest },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof usePutV1ProcessEditProcessHook>>>,
    TError,
    { data: EditProcessRequest },
    TContext
> => {
    const mutationOptions = usePutV1ProcessEditProcessMutationOptions(options);

    return useMutation(mutationOptions);
};

/**
 * @summary Delete (deactivate) a process.
 */
export const useDeleteV1ProcessDeleteProcessProcessIdHook = () => {
    const deleteV1ProcessDeleteProcessProcessId = useCustomAxios<void>();

    return useCallback(
        (processId: number) => {
            return deleteV1ProcessDeleteProcessProcessId({
                url: `/v1/Process/DeleteProcess/${processId}`,
                method: 'DELETE',
            });
        },
        [deleteV1ProcessDeleteProcessProcessId]
    );
};

export const useDeleteV1ProcessDeleteProcessProcessIdMutationOptions = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<
            ReturnType<
                ReturnType<typeof useDeleteV1ProcessDeleteProcessProcessIdHook>
            >
        >,
        TError,
        { processId: number },
        TContext
    >;
}): UseMutationOptions<
    Awaited<
        ReturnType<
            ReturnType<typeof useDeleteV1ProcessDeleteProcessProcessIdHook>
        >
    >,
    TError,
    { processId: number },
    TContext
> => {
    const { mutation: mutationOptions } = options ?? {};

    const deleteV1ProcessDeleteProcessProcessId =
        useDeleteV1ProcessDeleteProcessProcessIdHook();

    const mutationFn: MutationFunction<
        Awaited<
            ReturnType<
                ReturnType<typeof useDeleteV1ProcessDeleteProcessProcessIdHook>
            >
        >,
        { processId: number }
    > = (props) => {
        const { processId } = props ?? {};

        return deleteV1ProcessDeleteProcessProcessId(processId);
    };

    return { mutationFn, ...mutationOptions };
};

export type DeleteV1ProcessDeleteProcessProcessIdMutationResult = NonNullable<
    Awaited<
        ReturnType<
            ReturnType<typeof useDeleteV1ProcessDeleteProcessProcessIdHook>
        >
    >
>;

export type DeleteV1ProcessDeleteProcessProcessIdMutationError =
    ErrorType<void>;

/**
 * @summary Delete (deactivate) a process.
 */
export const useDeleteV1ProcessDeleteProcessProcessId = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<
            ReturnType<
                ReturnType<typeof useDeleteV1ProcessDeleteProcessProcessIdHook>
            >
        >,
        TError,
        { processId: number },
        TContext
    >;
}): UseMutationResult<
    Awaited<
        ReturnType<
            ReturnType<typeof useDeleteV1ProcessDeleteProcessProcessIdHook>
        >
    >,
    TError,
    { processId: number },
    TContext
> => {
    const mutationOptions =
        useDeleteV1ProcessDeleteProcessProcessIdMutationOptions(options);

    return useMutation(mutationOptions);
};

/**
 * @summary Get active processes in a folder with pagination, optional search, and sort.
 */
export const useGetV1ProcessGetProcessesInFolderFolderIdHook = () => {
    const getV1ProcessGetProcessesInFolderFolderId =
        useCustomAxios<PaginatedProcessResponse>();

    return useCallback(
        (
            folderId: number,
            params?: GetV1ProcessGetProcessesInFolderFolderIdParams
        ) => {
            return getV1ProcessGetProcessesInFolderFolderId({
                url: `/v1/Process/GetProcessesInFolder/${folderId}`,
                method: 'GET',
                params,
            });
        },
        [getV1ProcessGetProcessesInFolderFolderId]
    );
};

export const getGetV1ProcessGetProcessesInFolderFolderIdQueryKey = (
    folderId: number,
    params?: GetV1ProcessGetProcessesInFolderFolderIdParams
) => {
    return [
        `/v1/Process/GetProcessesInFolder/${folderId}`,
        ...(params ? [params] : []),
    ] as const;
};

export const useGetV1ProcessGetProcessesInFolderFolderIdQueryOptions = <
    TData = Awaited<
        ReturnType<
            ReturnType<typeof useGetV1ProcessGetProcessesInFolderFolderIdHook>
        >
    >,
    TError = ErrorType<void>
>(
    folderId: number,
    params?: GetV1ProcessGetProcessesInFolderFolderIdParams,
    options?: {
        query?: UseQueryOptions<
            Awaited<
                ReturnType<
                    ReturnType<
                        typeof useGetV1ProcessGetProcessesInFolderFolderIdHook
                    >
                >
            >,
            TError,
            TData
        >;
    }
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getGetV1ProcessGetProcessesInFolderFolderIdQueryKey(folderId, params);

    const getV1ProcessGetProcessesInFolderFolderId =
        useGetV1ProcessGetProcessesInFolderFolderIdHook();

    const queryFn: QueryFunction<
        Awaited<
            ReturnType<
                ReturnType<
                    typeof useGetV1ProcessGetProcessesInFolderFolderIdHook
                >
            >
        >
    > = () => getV1ProcessGetProcessesInFolderFolderId(folderId, params);

    return {
        queryKey,
        queryFn,
        enabled: !!folderId,
        ...queryOptions,
    } as UseQueryOptions<
        Awaited<
            ReturnType<
                ReturnType<
                    typeof useGetV1ProcessGetProcessesInFolderFolderIdHook
                >
            >
        >,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetV1ProcessGetProcessesInFolderFolderIdQueryResult = NonNullable<
    Awaited<
        ReturnType<
            ReturnType<typeof useGetV1ProcessGetProcessesInFolderFolderIdHook>
        >
    >
>;
export type GetV1ProcessGetProcessesInFolderFolderIdQueryError =
    ErrorType<void>;

/**
 * @summary Get active processes in a folder with pagination, optional search, and sort.
 */
export const useGetV1ProcessGetProcessesInFolderFolderId = <
    TData = Awaited<
        ReturnType<
            ReturnType<typeof useGetV1ProcessGetProcessesInFolderFolderIdHook>
        >
    >,
    TError = ErrorType<void>
>(
    folderId: number,
    params?: GetV1ProcessGetProcessesInFolderFolderIdParams,
    options?: {
        query?: UseQueryOptions<
            Awaited<
                ReturnType<
                    ReturnType<
                        typeof useGetV1ProcessGetProcessesInFolderFolderIdHook
                    >
                >
            >,
            TError,
            TData
        >;
    }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
    const queryOptions =
        useGetV1ProcessGetProcessesInFolderFolderIdQueryOptions(
            folderId,
            params,
            options
        );

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
        queryKey: QueryKey;
    };

    query.queryKey = queryOptions.queryKey;

    return query;
};

/**
 * @summary Get uploded documents in a process with pagination, optional search, and sort.
 */
export const useGetV1ProcessGetUploadedDocumentsInProcessProcessIdHook = () => {
    const getV1ProcessGetUploadedDocumentsInProcessProcessId =
        useCustomAxios<PaginatedProcessUploadedDocumentsResponse>();

    return useCallback(
        (
            processId: number,
            params?: GetV1ProcessGetUploadedDocumentsInProcessProcessIdParams
        ) => {
            return getV1ProcessGetUploadedDocumentsInProcessProcessId({
                url: `/v1/Process/GetUploadedDocumentsInProcess/${processId}`,
                method: 'GET',
                params,
            });
        },
        [getV1ProcessGetUploadedDocumentsInProcessProcessId]
    );
};

export const getGetV1ProcessGetUploadedDocumentsInProcessProcessIdQueryKey = (
    processId: number,
    params?: GetV1ProcessGetUploadedDocumentsInProcessProcessIdParams
) => {
    return [
        `/v1/Process/GetUploadedDocumentsInProcess/${processId}`,
        ...(params ? [params] : []),
    ] as const;
};

export const useGetV1ProcessGetUploadedDocumentsInProcessProcessIdQueryOptions =
    <
        TData = Awaited<
            ReturnType<
                ReturnType<
                    typeof useGetV1ProcessGetUploadedDocumentsInProcessProcessIdHook
                >
            >
        >,
        TError = ErrorType<void>
    >(
        processId: number,
        params?: GetV1ProcessGetUploadedDocumentsInProcessProcessIdParams,
        options?: {
            query?: UseQueryOptions<
                Awaited<
                    ReturnType<
                        ReturnType<
                            typeof useGetV1ProcessGetUploadedDocumentsInProcessProcessIdHook
                        >
                    >
                >,
                TError,
                TData
            >;
        }
    ) => {
        const { query: queryOptions } = options ?? {};

        const queryKey =
            queryOptions?.queryKey ??
            getGetV1ProcessGetUploadedDocumentsInProcessProcessIdQueryKey(
                processId,
                params
            );

        const getV1ProcessGetUploadedDocumentsInProcessProcessId =
            useGetV1ProcessGetUploadedDocumentsInProcessProcessIdHook();

        const queryFn: QueryFunction<
            Awaited<
                ReturnType<
                    ReturnType<
                        typeof useGetV1ProcessGetUploadedDocumentsInProcessProcessIdHook
                    >
                >
            >
        > = () =>
            getV1ProcessGetUploadedDocumentsInProcessProcessId(
                processId,
                params
            );

        return {
            queryKey,
            queryFn,
            enabled: !!processId,
            ...queryOptions,
        } as UseQueryOptions<
            Awaited<
                ReturnType<
                    ReturnType<
                        typeof useGetV1ProcessGetUploadedDocumentsInProcessProcessIdHook
                    >
                >
            >,
            TError,
            TData
        > & { queryKey: QueryKey };
    };

export type GetV1ProcessGetUploadedDocumentsInProcessProcessIdQueryResult =
    NonNullable<
        Awaited<
            ReturnType<
                ReturnType<
                    typeof useGetV1ProcessGetUploadedDocumentsInProcessProcessIdHook
                >
            >
        >
    >;
export type GetV1ProcessGetUploadedDocumentsInProcessProcessIdQueryError =
    ErrorType<void>;

/**
 * @summary Get uploded documents in a process with pagination, optional search, and sort.
 */
export const useGetV1ProcessGetUploadedDocumentsInProcessProcessId = <
    TData = Awaited<
        ReturnType<
            ReturnType<
                typeof useGetV1ProcessGetUploadedDocumentsInProcessProcessIdHook
            >
        >
    >,
    TError = ErrorType<void>
>(
    processId: number,
    params?: GetV1ProcessGetUploadedDocumentsInProcessProcessIdParams,
    options?: {
        query?: UseQueryOptions<
            Awaited<
                ReturnType<
                    ReturnType<
                        typeof useGetV1ProcessGetUploadedDocumentsInProcessProcessIdHook
                    >
                >
            >,
            TError,
            TData
        >;
    }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
    const queryOptions =
        useGetV1ProcessGetUploadedDocumentsInProcessProcessIdQueryOptions(
            processId,
            params,
            options
        );

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
        queryKey: QueryKey;
    };

    query.queryKey = queryOptions.queryKey;

    return query;
};

/**
 * @summary Get processing documents in a process with pagination, optional search, and sort.
 */
export const useGetV1ProcessGetDocumentsProcessingInProcessProcessIdHook =
    () => {
        const getV1ProcessGetDocumentsProcessingInProcessProcessId =
            useCustomAxios<PaginatedProcessingDocumentsResponse>();

        return useCallback(
            (
                processId: number,
                params?: GetV1ProcessGetDocumentsProcessingInProcessProcessIdParams
            ) => {
                return getV1ProcessGetDocumentsProcessingInProcessProcessId({
                    url: `/v1/Process/GetDocumentsProcessingInProcess/${processId}`,
                    method: 'GET',
                    params,
                });
            },
            [getV1ProcessGetDocumentsProcessingInProcessProcessId]
        );
    };

export const getGetV1ProcessGetDocumentsProcessingInProcessProcessIdQueryKey = (
    processId: number,
    params?: GetV1ProcessGetDocumentsProcessingInProcessProcessIdParams
) => {
    return [
        `/v1/Process/GetDocumentsProcessingInProcess/${processId}`,
        ...(params ? [params] : []),
    ] as const;
};

export const useGetV1ProcessGetDocumentsProcessingInProcessProcessIdQueryOptions =
    <
        TData = Awaited<
            ReturnType<
                ReturnType<
                    typeof useGetV1ProcessGetDocumentsProcessingInProcessProcessIdHook
                >
            >
        >,
        TError = ErrorType<void>
    >(
        processId: number,
        params?: GetV1ProcessGetDocumentsProcessingInProcessProcessIdParams,
        options?: {
            query?: UseQueryOptions<
                Awaited<
                    ReturnType<
                        ReturnType<
                            typeof useGetV1ProcessGetDocumentsProcessingInProcessProcessIdHook
                        >
                    >
                >,
                TError,
                TData
            >;
        }
    ) => {
        const { query: queryOptions } = options ?? {};

        const queryKey =
            queryOptions?.queryKey ??
            getGetV1ProcessGetDocumentsProcessingInProcessProcessIdQueryKey(
                processId,
                params
            );

        const getV1ProcessGetDocumentsProcessingInProcessProcessId =
            useGetV1ProcessGetDocumentsProcessingInProcessProcessIdHook();

        const queryFn: QueryFunction<
            Awaited<
                ReturnType<
                    ReturnType<
                        typeof useGetV1ProcessGetDocumentsProcessingInProcessProcessIdHook
                    >
                >
            >
        > = () =>
            getV1ProcessGetDocumentsProcessingInProcessProcessId(
                processId,
                params
            );

        return {
            queryKey,
            queryFn,
            enabled: !!processId,
            ...queryOptions,
        } as UseQueryOptions<
            Awaited<
                ReturnType<
                    ReturnType<
                        typeof useGetV1ProcessGetDocumentsProcessingInProcessProcessIdHook
                    >
                >
            >,
            TError,
            TData
        > & { queryKey: QueryKey };
    };

export type GetV1ProcessGetDocumentsProcessingInProcessProcessIdQueryResult =
    NonNullable<
        Awaited<
            ReturnType<
                ReturnType<
                    typeof useGetV1ProcessGetDocumentsProcessingInProcessProcessIdHook
                >
            >
        >
    >;
export type GetV1ProcessGetDocumentsProcessingInProcessProcessIdQueryError =
    ErrorType<void>;

/**
 * @summary Get processing documents in a process with pagination, optional search, and sort.
 */
export const useGetV1ProcessGetDocumentsProcessingInProcessProcessId = <
    TData = Awaited<
        ReturnType<
            ReturnType<
                typeof useGetV1ProcessGetDocumentsProcessingInProcessProcessIdHook
            >
        >
    >,
    TError = ErrorType<void>
>(
    processId: number,
    params?: GetV1ProcessGetDocumentsProcessingInProcessProcessIdParams,
    options?: {
        query?: UseQueryOptions<
            Awaited<
                ReturnType<
                    ReturnType<
                        typeof useGetV1ProcessGetDocumentsProcessingInProcessProcessIdHook
                    >
                >
            >,
            TError,
            TData
        >;
    }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
    const queryOptions =
        useGetV1ProcessGetDocumentsProcessingInProcessProcessIdQueryOptions(
            processId,
            params,
            options
        );

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
        queryKey: QueryKey;
    };

    query.queryKey = queryOptions.queryKey;

    return query;
};

/**
 * Returns a list of active parent documents (ID and Name) associated with the specified Process for the caller's tenant.
 * @summary Retrieve active parent documents for a given process.
 */
export const useGetV1ProcessParentDocumentsProcessIdHook = () => {
    const getV1ProcessParentDocumentsProcessId =
        useCustomAxios<DocumentTypeResponse[]>();

    return useCallback(
        (processId: number) => {
            return getV1ProcessParentDocumentsProcessId({
                url: `/v1/Process/ParentDocuments/${processId}`,
                method: 'GET',
            });
        },
        [getV1ProcessParentDocumentsProcessId]
    );
};

export const getGetV1ProcessParentDocumentsProcessIdQueryKey = (
    processId: number
) => {
    return [`/v1/Process/ParentDocuments/${processId}`] as const;
};

export const useGetV1ProcessParentDocumentsProcessIdQueryOptions = <
    TData = Awaited<
        ReturnType<
            ReturnType<typeof useGetV1ProcessParentDocumentsProcessIdHook>
        >
    >,
    TError = ErrorType<void>
>(
    processId: number,
    options?: {
        query?: UseQueryOptions<
            Awaited<
                ReturnType<
                    ReturnType<
                        typeof useGetV1ProcessParentDocumentsProcessIdHook
                    >
                >
            >,
            TError,
            TData
        >;
    }
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getGetV1ProcessParentDocumentsProcessIdQueryKey(processId);

    const getV1ProcessParentDocumentsProcessId =
        useGetV1ProcessParentDocumentsProcessIdHook();

    const queryFn: QueryFunction<
        Awaited<
            ReturnType<
                ReturnType<typeof useGetV1ProcessParentDocumentsProcessIdHook>
            >
        >
    > = () => getV1ProcessParentDocumentsProcessId(processId);

    return {
        queryKey,
        queryFn,
        enabled: !!processId,
        ...queryOptions,
    } as UseQueryOptions<
        Awaited<
            ReturnType<
                ReturnType<typeof useGetV1ProcessParentDocumentsProcessIdHook>
            >
        >,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetV1ProcessParentDocumentsProcessIdQueryResult = NonNullable<
    Awaited<
        ReturnType<
            ReturnType<typeof useGetV1ProcessParentDocumentsProcessIdHook>
        >
    >
>;
export type GetV1ProcessParentDocumentsProcessIdQueryError = ErrorType<void>;

/**
 * @summary Retrieve active parent documents for a given process.
 */
export const useGetV1ProcessParentDocumentsProcessId = <
    TData = Awaited<
        ReturnType<
            ReturnType<typeof useGetV1ProcessParentDocumentsProcessIdHook>
        >
    >,
    TError = ErrorType<void>
>(
    processId: number,
    options?: {
        query?: UseQueryOptions<
            Awaited<
                ReturnType<
                    ReturnType<
                        typeof useGetV1ProcessParentDocumentsProcessIdHook
                    >
                >
            >,
            TError,
            TData
        >;
    }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
    const queryOptions = useGetV1ProcessParentDocumentsProcessIdQueryOptions(
        processId,
        options
    );

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
        queryKey: QueryKey;
    };

    query.queryKey = queryOptions.queryKey;

    return query;
};

/**
 * @summary Get online forms in a process with pagination, optional search, and sort.
 */
export const useGetV1ProcessGetOnlineFormsInProcessProcessIdHook = () => {
    const getV1ProcessGetOnlineFormsInProcessProcessId =
        useCustomAxios<PaginatedOnlineFormsResponse>();

    return useCallback(
        (
            processId: number,
            params?: GetV1ProcessGetOnlineFormsInProcessProcessIdParams
        ) => {
            return getV1ProcessGetOnlineFormsInProcessProcessId({
                url: `/v1/Process/GetOnlineFormsInProcess/${processId}`,
                method: 'GET',
                params,
            });
        },
        [getV1ProcessGetOnlineFormsInProcessProcessId]
    );
};

export const getGetV1ProcessGetOnlineFormsInProcessProcessIdQueryKey = (
    processId: number,
    params?: GetV1ProcessGetOnlineFormsInProcessProcessIdParams
) => {
    return [
        `/v1/Process/GetOnlineFormsInProcess/${processId}`,
        ...(params ? [params] : []),
    ] as const;
};

export const useGetV1ProcessGetOnlineFormsInProcessProcessIdQueryOptions = <
    TData = Awaited<
        ReturnType<
            ReturnType<
                typeof useGetV1ProcessGetOnlineFormsInProcessProcessIdHook
            >
        >
    >,
    TError = ErrorType<void>
>(
    processId: number,
    params?: GetV1ProcessGetOnlineFormsInProcessProcessIdParams,
    options?: {
        query?: UseQueryOptions<
            Awaited<
                ReturnType<
                    ReturnType<
                        typeof useGetV1ProcessGetOnlineFormsInProcessProcessIdHook
                    >
                >
            >,
            TError,
            TData
        >;
    }
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getGetV1ProcessGetOnlineFormsInProcessProcessIdQueryKey(
            processId,
            params
        );

    const getV1ProcessGetOnlineFormsInProcessProcessId =
        useGetV1ProcessGetOnlineFormsInProcessProcessIdHook();

    const queryFn: QueryFunction<
        Awaited<
            ReturnType<
                ReturnType<
                    typeof useGetV1ProcessGetOnlineFormsInProcessProcessIdHook
                >
            >
        >
    > = () => getV1ProcessGetOnlineFormsInProcessProcessId(processId, params);

    return {
        queryKey,
        queryFn,
        enabled: !!processId,
        ...queryOptions,
    } as UseQueryOptions<
        Awaited<
            ReturnType<
                ReturnType<
                    typeof useGetV1ProcessGetOnlineFormsInProcessProcessIdHook
                >
            >
        >,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetV1ProcessGetOnlineFormsInProcessProcessIdQueryResult =
    NonNullable<
        Awaited<
            ReturnType<
                ReturnType<
                    typeof useGetV1ProcessGetOnlineFormsInProcessProcessIdHook
                >
            >
        >
    >;
export type GetV1ProcessGetOnlineFormsInProcessProcessIdQueryError =
    ErrorType<void>;

/**
 * @summary Get online forms in a process with pagination, optional search, and sort.
 */
export const useGetV1ProcessGetOnlineFormsInProcessProcessId = <
    TData = Awaited<
        ReturnType<
            ReturnType<
                typeof useGetV1ProcessGetOnlineFormsInProcessProcessIdHook
            >
        >
    >,
    TError = ErrorType<void>
>(
    processId: number,
    params?: GetV1ProcessGetOnlineFormsInProcessProcessIdParams,
    options?: {
        query?: UseQueryOptions<
            Awaited<
                ReturnType<
                    ReturnType<
                        typeof useGetV1ProcessGetOnlineFormsInProcessProcessIdHook
                    >
                >
            >,
            TError,
            TData
        >;
    }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
    const queryOptions =
        useGetV1ProcessGetOnlineFormsInProcessProcessIdQueryOptions(
            processId,
            params,
            options
        );

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
        queryKey: QueryKey;
    };

    query.queryKey = queryOptions.queryKey;

    return query;
};

/**
 * Returns a list of process types available for the caller's tenant.
 * @summary Retrieve process types for the tenant.
 */
export const useGetV1ProcessGetProcessTypesForTenantHook = () => {
    const getV1ProcessGetProcessTypesForTenant =
        useCustomAxios<ProcessTypeResponse[]>();

    return useCallback(() => {
        return getV1ProcessGetProcessTypesForTenant({
            url: `/v1/Process/GetProcessTypesForTenant`,
            method: 'GET',
        });
    }, [getV1ProcessGetProcessTypesForTenant]);
};

export const getGetV1ProcessGetProcessTypesForTenantQueryKey = () => {
    return [`/v1/Process/GetProcessTypesForTenant`] as const;
};

export const useGetV1ProcessGetProcessTypesForTenantQueryOptions = <
    TData = Awaited<
        ReturnType<
            ReturnType<typeof useGetV1ProcessGetProcessTypesForTenantHook>
        >
    >,
    TError = ErrorType<void>
>(options?: {
    query?: UseQueryOptions<
        Awaited<
            ReturnType<
                ReturnType<typeof useGetV1ProcessGetProcessTypesForTenantHook>
            >
        >,
        TError,
        TData
    >;
}) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getGetV1ProcessGetProcessTypesForTenantQueryKey();

    const getV1ProcessGetProcessTypesForTenant =
        useGetV1ProcessGetProcessTypesForTenantHook();

    const queryFn: QueryFunction<
        Awaited<
            ReturnType<
                ReturnType<typeof useGetV1ProcessGetProcessTypesForTenantHook>
            >
        >
    > = () => getV1ProcessGetProcessTypesForTenant();

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<
            ReturnType<
                ReturnType<typeof useGetV1ProcessGetProcessTypesForTenantHook>
            >
        >,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetV1ProcessGetProcessTypesForTenantQueryResult = NonNullable<
    Awaited<
        ReturnType<
            ReturnType<typeof useGetV1ProcessGetProcessTypesForTenantHook>
        >
    >
>;
export type GetV1ProcessGetProcessTypesForTenantQueryError = ErrorType<void>;

/**
 * @summary Retrieve process types for the tenant.
 */
export const useGetV1ProcessGetProcessTypesForTenant = <
    TData = Awaited<
        ReturnType<
            ReturnType<typeof useGetV1ProcessGetProcessTypesForTenantHook>
        >
    >,
    TError = ErrorType<void>
>(options?: {
    query?: UseQueryOptions<
        Awaited<
            ReturnType<
                ReturnType<typeof useGetV1ProcessGetProcessTypesForTenantHook>
            >
        >,
        TError,
        TData
    >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
    const queryOptions =
        useGetV1ProcessGetProcessTypesForTenantQueryOptions(options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
        queryKey: QueryKey;
    };

    query.queryKey = queryOptions.queryKey;

    return query;
};

export const useGetV1ProcessProcessIdGetProcessDetailsHook = () => {
    const getV1ProcessProcessIdGetProcessDetails =
        useCustomAxios<ProcessHierarchyResponse>();

    return useCallback(
        (processId: number) => {
            return getV1ProcessProcessIdGetProcessDetails({
                url: `/v1/Process/${processId}/GetProcessDetails`,
                method: 'GET',
            });
        },
        [getV1ProcessProcessIdGetProcessDetails]
    );
};

export const getGetV1ProcessProcessIdGetProcessDetailsQueryKey = (
    processId: number
) => {
    return [`/v1/Process/${processId}/GetProcessDetails`] as const;
};

export const useGetV1ProcessProcessIdGetProcessDetailsQueryOptions = <
    TData = Awaited<
        ReturnType<
            ReturnType<typeof useGetV1ProcessProcessIdGetProcessDetailsHook>
        >
    >,
    TError = ErrorType<void>
>(
    processId: number,
    options?: {
        query?: UseQueryOptions<
            Awaited<
                ReturnType<
                    ReturnType<
                        typeof useGetV1ProcessProcessIdGetProcessDetailsHook
                    >
                >
            >,
            TError,
            TData
        >;
    }
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getGetV1ProcessProcessIdGetProcessDetailsQueryKey(processId);

    const getV1ProcessProcessIdGetProcessDetails =
        useGetV1ProcessProcessIdGetProcessDetailsHook();

    const queryFn: QueryFunction<
        Awaited<
            ReturnType<
                ReturnType<typeof useGetV1ProcessProcessIdGetProcessDetailsHook>
            >
        >
    > = () => getV1ProcessProcessIdGetProcessDetails(processId);

    return {
        queryKey,
        queryFn,
        enabled: !!processId,
        ...queryOptions,
    } as UseQueryOptions<
        Awaited<
            ReturnType<
                ReturnType<typeof useGetV1ProcessProcessIdGetProcessDetailsHook>
            >
        >,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetV1ProcessProcessIdGetProcessDetailsQueryResult = NonNullable<
    Awaited<
        ReturnType<
            ReturnType<typeof useGetV1ProcessProcessIdGetProcessDetailsHook>
        >
    >
>;
export type GetV1ProcessProcessIdGetProcessDetailsQueryError = ErrorType<void>;

export const useGetV1ProcessProcessIdGetProcessDetails = <
    TData = Awaited<
        ReturnType<
            ReturnType<typeof useGetV1ProcessProcessIdGetProcessDetailsHook>
        >
    >,
    TError = ErrorType<void>
>(
    processId: number,
    options?: {
        query?: UseQueryOptions<
            Awaited<
                ReturnType<
                    ReturnType<
                        typeof useGetV1ProcessProcessIdGetProcessDetailsHook
                    >
                >
            >,
            TError,
            TData
        >;
    }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
    const queryOptions = useGetV1ProcessProcessIdGetProcessDetailsQueryOptions(
        processId,
        options
    );

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
        queryKey: QueryKey;
    };

    query.queryKey = queryOptions.queryKey;

    return query;
};

/**
 * @summary Get recently accessed processes by a user.
 */
export const useGetV1ProcessGetRecentlyAccessedProcessesHook = () => {
    const getV1ProcessGetRecentlyAccessedProcesses =
        useCustomAxios<PaginatedRecentProcessAccessResponse>();

    return useCallback(
        (params?: GetV1ProcessGetRecentlyAccessedProcessesParams) => {
            return getV1ProcessGetRecentlyAccessedProcesses({
                url: `/v1/Process/GetRecentlyAccessedProcesses`,
                method: 'GET',
                params,
            });
        },
        [getV1ProcessGetRecentlyAccessedProcesses]
    );
};

export const getGetV1ProcessGetRecentlyAccessedProcessesQueryKey = (
    params?: GetV1ProcessGetRecentlyAccessedProcessesParams
) => {
    return [
        `/v1/Process/GetRecentlyAccessedProcesses`,
        ...(params ? [params] : []),
    ] as const;
};

export const useGetV1ProcessGetRecentlyAccessedProcessesQueryOptions = <
    TData = Awaited<
        ReturnType<
            ReturnType<typeof useGetV1ProcessGetRecentlyAccessedProcessesHook>
        >
    >,
    TError = ErrorType<void>
>(
    params?: GetV1ProcessGetRecentlyAccessedProcessesParams,
    options?: {
        query?: UseQueryOptions<
            Awaited<
                ReturnType<
                    ReturnType<
                        typeof useGetV1ProcessGetRecentlyAccessedProcessesHook
                    >
                >
            >,
            TError,
            TData
        >;
    }
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getGetV1ProcessGetRecentlyAccessedProcessesQueryKey(params);

    const getV1ProcessGetRecentlyAccessedProcesses =
        useGetV1ProcessGetRecentlyAccessedProcessesHook();

    const queryFn: QueryFunction<
        Awaited<
            ReturnType<
                ReturnType<
                    typeof useGetV1ProcessGetRecentlyAccessedProcessesHook
                >
            >
        >
    > = () => getV1ProcessGetRecentlyAccessedProcesses(params);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<
            ReturnType<
                ReturnType<
                    typeof useGetV1ProcessGetRecentlyAccessedProcessesHook
                >
            >
        >,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetV1ProcessGetRecentlyAccessedProcessesQueryResult = NonNullable<
    Awaited<
        ReturnType<
            ReturnType<typeof useGetV1ProcessGetRecentlyAccessedProcessesHook>
        >
    >
>;
export type GetV1ProcessGetRecentlyAccessedProcessesQueryError =
    ErrorType<void>;

/**
 * @summary Get recently accessed processes by a user.
 */
export const useGetV1ProcessGetRecentlyAccessedProcesses = <
    TData = Awaited<
        ReturnType<
            ReturnType<typeof useGetV1ProcessGetRecentlyAccessedProcessesHook>
        >
    >,
    TError = ErrorType<void>
>(
    params?: GetV1ProcessGetRecentlyAccessedProcessesParams,
    options?: {
        query?: UseQueryOptions<
            Awaited<
                ReturnType<
                    ReturnType<
                        typeof useGetV1ProcessGetRecentlyAccessedProcessesHook
                    >
                >
            >,
            TError,
            TData
        >;
    }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
    const queryOptions =
        useGetV1ProcessGetRecentlyAccessedProcessesQueryOptions(
            params,
            options
        );

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
        queryKey: QueryKey;
    };

    query.queryKey = queryOptions.queryKey;

    return query;
};

/**
 * @summary Get the current user's export history (Running or Completed exports that haven't been marked as complete)
 */
export const useGetV1ProcessExportHistoryHook = () => {
    const getV1ProcessExportHistory =
        useCustomAxios<GetProcessExportHistoryResponse[]>();

    return useCallback(() => {
        return getV1ProcessExportHistory({
            url: `/v1/ProcessExport/History`,
            method: 'GET',
        });
    }, [getV1ProcessExportHistory]);
};

export const getGetV1ProcessExportHistoryQueryKey = () => {
    return [`/v1/ProcessExport/History`] as const;
};

export const useGetV1ProcessExportHistoryQueryOptions = <
    TData = Awaited<
        ReturnType<ReturnType<typeof useGetV1ProcessExportHistoryHook>>
    >,
    TError = ErrorType<void>
>(options?: {
    query?: UseQueryOptions<
        Awaited<
            ReturnType<ReturnType<typeof useGetV1ProcessExportHistoryHook>>
        >,
        TError,
        TData
    >;
}) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ?? getGetV1ProcessExportHistoryQueryKey();

    const getV1ProcessExportHistory = useGetV1ProcessExportHistoryHook();

    const queryFn: QueryFunction<
        Awaited<ReturnType<ReturnType<typeof useGetV1ProcessExportHistoryHook>>>
    > = () => getV1ProcessExportHistory();

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<
            ReturnType<ReturnType<typeof useGetV1ProcessExportHistoryHook>>
        >,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetV1ProcessExportHistoryQueryResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useGetV1ProcessExportHistoryHook>>>
>;
export type GetV1ProcessExportHistoryQueryError = ErrorType<void>;

/**
 * @summary Get the current user's export history (Running or Completed exports that haven't been marked as complete)
 */
export const useGetV1ProcessExportHistory = <
    TData = Awaited<
        ReturnType<ReturnType<typeof useGetV1ProcessExportHistoryHook>>
    >,
    TError = ErrorType<void>
>(options?: {
    query?: UseQueryOptions<
        Awaited<
            ReturnType<ReturnType<typeof useGetV1ProcessExportHistoryHook>>
        >,
        TError,
        TData
    >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
    const queryOptions = useGetV1ProcessExportHistoryQueryOptions(options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
        queryKey: QueryKey;
    };

    query.queryKey = queryOptions.queryKey;

    return query;
};

/**
 * @summary Mark an export as complete and get the download link
 */
export const usePostV1ProcessExportCompleteHook = () => {
    const postV1ProcessExportComplete =
        useCustomAxios<CompleteProcessExportResponse>();

    return useCallback(
        (completeProcessExportRequest: CompleteProcessExportRequest) => {
            return postV1ProcessExportComplete({
                url: `/v1/ProcessExport/Complete`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: completeProcessExportRequest,
            });
        },
        [postV1ProcessExportComplete]
    );
};

export const usePostV1ProcessExportCompleteMutationOptions = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<
            ReturnType<ReturnType<typeof usePostV1ProcessExportCompleteHook>>
        >,
        TError,
        { data: CompleteProcessExportRequest },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof usePostV1ProcessExportCompleteHook>>>,
    TError,
    { data: CompleteProcessExportRequest },
    TContext
> => {
    const { mutation: mutationOptions } = options ?? {};

    const postV1ProcessExportComplete = usePostV1ProcessExportCompleteHook();

    const mutationFn: MutationFunction<
        Awaited<
            ReturnType<ReturnType<typeof usePostV1ProcessExportCompleteHook>>
        >,
        { data: CompleteProcessExportRequest }
    > = (props) => {
        const { data } = props ?? {};

        return postV1ProcessExportComplete(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type PostV1ProcessExportCompleteMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof usePostV1ProcessExportCompleteHook>>>
>;
export type PostV1ProcessExportCompleteMutationBody =
    CompleteProcessExportRequest;
export type PostV1ProcessExportCompleteMutationError = ErrorType<void>;

/**
 * @summary Mark an export as complete and get the download link
 */
export const usePostV1ProcessExportComplete = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<
            ReturnType<ReturnType<typeof usePostV1ProcessExportCompleteHook>>
        >,
        TError,
        { data: CompleteProcessExportRequest },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof usePostV1ProcessExportCompleteHook>>>,
    TError,
    { data: CompleteProcessExportRequest },
    TContext
> => {
    const mutationOptions =
        usePostV1ProcessExportCompleteMutationOptions(options);

    return useMutation(mutationOptions);
};

export const useGetV1RoleAdminAllHook = () => {
    const getV1RoleAdminAll = useCustomAxios<RoleResponse[]>();

    return useCallback(() => {
        return getV1RoleAdminAll({ url: `/v1/Role/Admin/All`, method: 'GET' });
    }, [getV1RoleAdminAll]);
};

export const getGetV1RoleAdminAllQueryKey = () => {
    return [`/v1/Role/Admin/All`] as const;
};

export const useGetV1RoleAdminAllQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetV1RoleAdminAllHook>>>,
    TError = ErrorType<unknown>
>(options?: {
    query?: UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetV1RoleAdminAllHook>>>,
        TError,
        TData
    >;
}) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetV1RoleAdminAllQueryKey();

    const getV1RoleAdminAll = useGetV1RoleAdminAllHook();

    const queryFn: QueryFunction<
        Awaited<ReturnType<ReturnType<typeof useGetV1RoleAdminAllHook>>>
    > = () => getV1RoleAdminAll();

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetV1RoleAdminAllHook>>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetV1RoleAdminAllQueryResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useGetV1RoleAdminAllHook>>>
>;
export type GetV1RoleAdminAllQueryError = ErrorType<unknown>;

export const useGetV1RoleAdminAll = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetV1RoleAdminAllHook>>>,
    TError = ErrorType<unknown>
>(options?: {
    query?: UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetV1RoleAdminAllHook>>>,
        TError,
        TData
    >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
    const queryOptions = useGetV1RoleAdminAllQueryOptions(options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
        queryKey: QueryKey;
    };

    query.queryKey = queryOptions.queryKey;

    return query;
};

/**
 * @summary Get active Sightline filters for the specified process.
 */
export const useGetV1SightlineProcessIdFiltersHook = () => {
    const getV1SightlineProcessIdFilters =
        useCustomAxios<SightlineFilterResponse>();

    return useCallback(
        (processId: number) => {
            return getV1SightlineProcessIdFilters({
                url: `/v1/Sightline/${processId}/filters`,
                method: 'GET',
            });
        },
        [getV1SightlineProcessIdFilters]
    );
};

export const getGetV1SightlineProcessIdFiltersQueryKey = (
    processId: number
) => {
    return [`/v1/Sightline/${processId}/filters`] as const;
};

export const useGetV1SightlineProcessIdFiltersQueryOptions = <
    TData = Awaited<
        ReturnType<ReturnType<typeof useGetV1SightlineProcessIdFiltersHook>>
    >,
    TError = ErrorType<unknown>
>(
    processId: number,
    options?: {
        query?: UseQueryOptions<
            Awaited<
                ReturnType<
                    ReturnType<typeof useGetV1SightlineProcessIdFiltersHook>
                >
            >,
            TError,
            TData
        >;
    }
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getGetV1SightlineProcessIdFiltersQueryKey(processId);

    const getV1SightlineProcessIdFilters =
        useGetV1SightlineProcessIdFiltersHook();

    const queryFn: QueryFunction<
        Awaited<
            ReturnType<ReturnType<typeof useGetV1SightlineProcessIdFiltersHook>>
        >
    > = () => getV1SightlineProcessIdFilters(processId);

    return {
        queryKey,
        queryFn,
        enabled: !!processId,
        ...queryOptions,
    } as UseQueryOptions<
        Awaited<
            ReturnType<ReturnType<typeof useGetV1SightlineProcessIdFiltersHook>>
        >,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetV1SightlineProcessIdFiltersQueryResult = NonNullable<
    Awaited<
        ReturnType<ReturnType<typeof useGetV1SightlineProcessIdFiltersHook>>
    >
>;
export type GetV1SightlineProcessIdFiltersQueryError = ErrorType<unknown>;

/**
 * @summary Get active Sightline filters for the specified process.
 */
export const useGetV1SightlineProcessIdFilters = <
    TData = Awaited<
        ReturnType<ReturnType<typeof useGetV1SightlineProcessIdFiltersHook>>
    >,
    TError = ErrorType<unknown>
>(
    processId: number,
    options?: {
        query?: UseQueryOptions<
            Awaited<
                ReturnType<
                    ReturnType<typeof useGetV1SightlineProcessIdFiltersHook>
                >
            >,
            TError,
            TData
        >;
    }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
    const queryOptions = useGetV1SightlineProcessIdFiltersQueryOptions(
        processId,
        options
    );

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
        queryKey: QueryKey;
    };

    query.queryKey = queryOptions.queryKey;

    return query;
};

/**
 * @summary Replace all Sightline filters for the specified process.
 */
export const usePostV1SightlineProcessIdFiltersHook = () => {
    const postV1SightlineProcessIdFilters = useCustomAxios<void>();

    return useCallback(
        (processId: number, sightlineFilterRequest: SightlineFilterRequest) => {
            return postV1SightlineProcessIdFilters({
                url: `/v1/Sightline/${processId}/filters`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: sightlineFilterRequest,
            });
        },
        [postV1SightlineProcessIdFilters]
    );
};

export const usePostV1SightlineProcessIdFiltersMutationOptions = <
    TError = ErrorType<unknown>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<
            ReturnType<
                ReturnType<typeof usePostV1SightlineProcessIdFiltersHook>
            >
        >,
        TError,
        { processId: number; data: SightlineFilterRequest },
        TContext
    >;
}): UseMutationOptions<
    Awaited<
        ReturnType<ReturnType<typeof usePostV1SightlineProcessIdFiltersHook>>
    >,
    TError,
    { processId: number; data: SightlineFilterRequest },
    TContext
> => {
    const { mutation: mutationOptions } = options ?? {};

    const postV1SightlineProcessIdFilters =
        usePostV1SightlineProcessIdFiltersHook();

    const mutationFn: MutationFunction<
        Awaited<
            ReturnType<
                ReturnType<typeof usePostV1SightlineProcessIdFiltersHook>
            >
        >,
        { processId: number; data: SightlineFilterRequest }
    > = (props) => {
        const { processId, data } = props ?? {};

        return postV1SightlineProcessIdFilters(processId, data);
    };

    return { mutationFn, ...mutationOptions };
};

export type PostV1SightlineProcessIdFiltersMutationResult = NonNullable<
    Awaited<
        ReturnType<ReturnType<typeof usePostV1SightlineProcessIdFiltersHook>>
    >
>;
export type PostV1SightlineProcessIdFiltersMutationBody =
    SightlineFilterRequest;
export type PostV1SightlineProcessIdFiltersMutationError = ErrorType<unknown>;

/**
 * @summary Replace all Sightline filters for the specified process.
 */
export const usePostV1SightlineProcessIdFilters = <
    TError = ErrorType<unknown>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<
            ReturnType<
                ReturnType<typeof usePostV1SightlineProcessIdFiltersHook>
            >
        >,
        TError,
        { processId: number; data: SightlineFilterRequest },
        TContext
    >;
}): UseMutationResult<
    Awaited<
        ReturnType<ReturnType<typeof usePostV1SightlineProcessIdFiltersHook>>
    >,
    TError,
    { processId: number; data: SightlineFilterRequest },
    TContext
> => {
    const mutationOptions =
        usePostV1SightlineProcessIdFiltersMutationOptions(options);

    return useMutation(mutationOptions);
};

/**
 * @summary Returns the list of total login count and most recent login for a user.
 */
export const useGetV1BusinessMetricsSuperAdminUserLoginsHook = () => {
    const getV1BusinessMetricsSuperAdminUserLogins =
        useCustomAxios<PaginatedUserLoginsResponse>();

    return useCallback(
        (params?: GetV1BusinessMetricsSuperAdminUserLoginsParams) => {
            return getV1BusinessMetricsSuperAdminUserLogins({
                url: `/v1/BusinessMetrics/SuperAdmin/UserLogins`,
                method: 'GET',
                params,
            });
        },
        [getV1BusinessMetricsSuperAdminUserLogins]
    );
};

export const getGetV1BusinessMetricsSuperAdminUserLoginsQueryKey = (
    params?: GetV1BusinessMetricsSuperAdminUserLoginsParams
) => {
    return [
        `/v1/BusinessMetrics/SuperAdmin/UserLogins`,
        ...(params ? [params] : []),
    ] as const;
};

export const useGetV1BusinessMetricsSuperAdminUserLoginsQueryOptions = <
    TData = Awaited<
        ReturnType<
            ReturnType<typeof useGetV1BusinessMetricsSuperAdminUserLoginsHook>
        >
    >,
    TError = ErrorType<unknown>
>(
    params?: GetV1BusinessMetricsSuperAdminUserLoginsParams,
    options?: {
        query?: UseQueryOptions<
            Awaited<
                ReturnType<
                    ReturnType<
                        typeof useGetV1BusinessMetricsSuperAdminUserLoginsHook
                    >
                >
            >,
            TError,
            TData
        >;
    }
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getGetV1BusinessMetricsSuperAdminUserLoginsQueryKey(params);

    const getV1BusinessMetricsSuperAdminUserLogins =
        useGetV1BusinessMetricsSuperAdminUserLoginsHook();

    const queryFn: QueryFunction<
        Awaited<
            ReturnType<
                ReturnType<
                    typeof useGetV1BusinessMetricsSuperAdminUserLoginsHook
                >
            >
        >
    > = () => getV1BusinessMetricsSuperAdminUserLogins(params);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<
            ReturnType<
                ReturnType<
                    typeof useGetV1BusinessMetricsSuperAdminUserLoginsHook
                >
            >
        >,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetV1BusinessMetricsSuperAdminUserLoginsQueryResult = NonNullable<
    Awaited<
        ReturnType<
            ReturnType<typeof useGetV1BusinessMetricsSuperAdminUserLoginsHook>
        >
    >
>;
export type GetV1BusinessMetricsSuperAdminUserLoginsQueryError =
    ErrorType<unknown>;

/**
 * @summary Returns the list of total login count and most recent login for a user.
 */
export const useGetV1BusinessMetricsSuperAdminUserLogins = <
    TData = Awaited<
        ReturnType<
            ReturnType<typeof useGetV1BusinessMetricsSuperAdminUserLoginsHook>
        >
    >,
    TError = ErrorType<unknown>
>(
    params?: GetV1BusinessMetricsSuperAdminUserLoginsParams,
    options?: {
        query?: UseQueryOptions<
            Awaited<
                ReturnType<
                    ReturnType<
                        typeof useGetV1BusinessMetricsSuperAdminUserLoginsHook
                    >
                >
            >,
            TError,
            TData
        >;
    }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
    const queryOptions =
        useGetV1BusinessMetricsSuperAdminUserLoginsQueryOptions(
            params,
            options
        );

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
        queryKey: QueryKey;
    };

    query.queryKey = queryOptions.queryKey;

    return query;
};

/**
 * @summary Returns the summary of user logins
 */
export const useGetV1BusinessMetricsSuperAdminUserLoginsSummaryContextHook =
    () => {
        const getV1BusinessMetricsSuperAdminUserLoginsSummaryContext =
            useCustomAxios<UserLoginsSummaryResponse>();

        return useCallback(
            (context: string) => {
                return getV1BusinessMetricsSuperAdminUserLoginsSummaryContext({
                    url: `/v1/BusinessMetrics/SuperAdmin/UserLoginsSummary/${context}`,
                    method: 'GET',
                });
            },
            [getV1BusinessMetricsSuperAdminUserLoginsSummaryContext]
        );
    };

export const getGetV1BusinessMetricsSuperAdminUserLoginsSummaryContextQueryKey =
    (context: string) => {
        return [
            `/v1/BusinessMetrics/SuperAdmin/UserLoginsSummary/${context}`,
        ] as const;
    };

export const useGetV1BusinessMetricsSuperAdminUserLoginsSummaryContextQueryOptions =
    <
        TData = Awaited<
            ReturnType<
                ReturnType<
                    typeof useGetV1BusinessMetricsSuperAdminUserLoginsSummaryContextHook
                >
            >
        >,
        TError = ErrorType<void>
    >(
        context: string,
        options?: {
            query?: UseQueryOptions<
                Awaited<
                    ReturnType<
                        ReturnType<
                            typeof useGetV1BusinessMetricsSuperAdminUserLoginsSummaryContextHook
                        >
                    >
                >,
                TError,
                TData
            >;
        }
    ) => {
        const { query: queryOptions } = options ?? {};

        const queryKey =
            queryOptions?.queryKey ??
            getGetV1BusinessMetricsSuperAdminUserLoginsSummaryContextQueryKey(
                context
            );

        const getV1BusinessMetricsSuperAdminUserLoginsSummaryContext =
            useGetV1BusinessMetricsSuperAdminUserLoginsSummaryContextHook();

        const queryFn: QueryFunction<
            Awaited<
                ReturnType<
                    ReturnType<
                        typeof useGetV1BusinessMetricsSuperAdminUserLoginsSummaryContextHook
                    >
                >
            >
        > = () =>
            getV1BusinessMetricsSuperAdminUserLoginsSummaryContext(context);

        return {
            queryKey,
            queryFn,
            enabled: !!context,
            ...queryOptions,
        } as UseQueryOptions<
            Awaited<
                ReturnType<
                    ReturnType<
                        typeof useGetV1BusinessMetricsSuperAdminUserLoginsSummaryContextHook
                    >
                >
            >,
            TError,
            TData
        > & { queryKey: QueryKey };
    };

export type GetV1BusinessMetricsSuperAdminUserLoginsSummaryContextQueryResult =
    NonNullable<
        Awaited<
            ReturnType<
                ReturnType<
                    typeof useGetV1BusinessMetricsSuperAdminUserLoginsSummaryContextHook
                >
            >
        >
    >;
export type GetV1BusinessMetricsSuperAdminUserLoginsSummaryContextQueryError =
    ErrorType<void>;

/**
 * @summary Returns the summary of user logins
 */
export const useGetV1BusinessMetricsSuperAdminUserLoginsSummaryContext = <
    TData = Awaited<
        ReturnType<
            ReturnType<
                typeof useGetV1BusinessMetricsSuperAdminUserLoginsSummaryContextHook
            >
        >
    >,
    TError = ErrorType<void>
>(
    context: string,
    options?: {
        query?: UseQueryOptions<
            Awaited<
                ReturnType<
                    ReturnType<
                        typeof useGetV1BusinessMetricsSuperAdminUserLoginsSummaryContextHook
                    >
                >
            >,
            TError,
            TData
        >;
    }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
    const queryOptions =
        useGetV1BusinessMetricsSuperAdminUserLoginsSummaryContextQueryOptions(
            context,
            options
        );

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
        queryKey: QueryKey;
    };

    query.queryKey = queryOptions.queryKey;

    return query;
};

/**
 * @summary Create a new application contact
 */
export const usePostV1ContactPersonSuperAdminApplicationHook = () => {
    const postV1ContactPersonSuperAdminApplication =
        useCustomAxios<ContactPersonResponse>();

    return useCallback(
        (createApplicationContactRequest: CreateApplicationContactRequest) => {
            return postV1ContactPersonSuperAdminApplication({
                url: `/v1/ContactPerson/SuperAdmin/Application`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: createApplicationContactRequest,
            });
        },
        [postV1ContactPersonSuperAdminApplication]
    );
};

export const usePostV1ContactPersonSuperAdminApplicationMutationOptions = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<
            ReturnType<
                ReturnType<
                    typeof usePostV1ContactPersonSuperAdminApplicationHook
                >
            >
        >,
        TError,
        { data: CreateApplicationContactRequest },
        TContext
    >;
}): UseMutationOptions<
    Awaited<
        ReturnType<
            ReturnType<typeof usePostV1ContactPersonSuperAdminApplicationHook>
        >
    >,
    TError,
    { data: CreateApplicationContactRequest },
    TContext
> => {
    const { mutation: mutationOptions } = options ?? {};

    const postV1ContactPersonSuperAdminApplication =
        usePostV1ContactPersonSuperAdminApplicationHook();

    const mutationFn: MutationFunction<
        Awaited<
            ReturnType<
                ReturnType<
                    typeof usePostV1ContactPersonSuperAdminApplicationHook
                >
            >
        >,
        { data: CreateApplicationContactRequest }
    > = (props) => {
        const { data } = props ?? {};

        return postV1ContactPersonSuperAdminApplication(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type PostV1ContactPersonSuperAdminApplicationMutationResult =
    NonNullable<
        Awaited<
            ReturnType<
                ReturnType<
                    typeof usePostV1ContactPersonSuperAdminApplicationHook
                >
            >
        >
    >;
export type PostV1ContactPersonSuperAdminApplicationMutationBody =
    CreateApplicationContactRequest;
export type PostV1ContactPersonSuperAdminApplicationMutationError =
    ErrorType<void>;

/**
 * @summary Create a new application contact
 */
export const usePostV1ContactPersonSuperAdminApplication = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<
            ReturnType<
                ReturnType<
                    typeof usePostV1ContactPersonSuperAdminApplicationHook
                >
            >
        >,
        TError,
        { data: CreateApplicationContactRequest },
        TContext
    >;
}): UseMutationResult<
    Awaited<
        ReturnType<
            ReturnType<typeof usePostV1ContactPersonSuperAdminApplicationHook>
        >
    >,
    TError,
    { data: CreateApplicationContactRequest },
    TContext
> => {
    const mutationOptions =
        usePostV1ContactPersonSuperAdminApplicationMutationOptions(options);

    return useMutation(mutationOptions);
};

export const usePutV1PolicySuperAdminPolicyIdHook = () => {
    const putV1PolicySuperAdminPolicyId = useCustomAxios<PolicyResponse>();

    return useCallback(
        (policyId: number, editPolicyRequest: EditPolicyRequest) => {
            return putV1PolicySuperAdminPolicyId({
                url: `/v1/Policy/SuperAdmin/${policyId}`,
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                data: editPolicyRequest,
            });
        },
        [putV1PolicySuperAdminPolicyId]
    );
};

export const usePutV1PolicySuperAdminPolicyIdMutationOptions = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<
            ReturnType<ReturnType<typeof usePutV1PolicySuperAdminPolicyIdHook>>
        >,
        TError,
        { policyId: number; data: EditPolicyRequest },
        TContext
    >;
}): UseMutationOptions<
    Awaited<
        ReturnType<ReturnType<typeof usePutV1PolicySuperAdminPolicyIdHook>>
    >,
    TError,
    { policyId: number; data: EditPolicyRequest },
    TContext
> => {
    const { mutation: mutationOptions } = options ?? {};

    const putV1PolicySuperAdminPolicyId =
        usePutV1PolicySuperAdminPolicyIdHook();

    const mutationFn: MutationFunction<
        Awaited<
            ReturnType<ReturnType<typeof usePutV1PolicySuperAdminPolicyIdHook>>
        >,
        { policyId: number; data: EditPolicyRequest }
    > = (props) => {
        const { policyId, data } = props ?? {};

        return putV1PolicySuperAdminPolicyId(policyId, data);
    };

    return { mutationFn, ...mutationOptions };
};

export type PutV1PolicySuperAdminPolicyIdMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof usePutV1PolicySuperAdminPolicyIdHook>>>
>;
export type PutV1PolicySuperAdminPolicyIdMutationBody = EditPolicyRequest;
export type PutV1PolicySuperAdminPolicyIdMutationError = ErrorType<void>;

export const usePutV1PolicySuperAdminPolicyId = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<
            ReturnType<ReturnType<typeof usePutV1PolicySuperAdminPolicyIdHook>>
        >,
        TError,
        { policyId: number; data: EditPolicyRequest },
        TContext
    >;
}): UseMutationResult<
    Awaited<
        ReturnType<ReturnType<typeof usePutV1PolicySuperAdminPolicyIdHook>>
    >,
    TError,
    { policyId: number; data: EditPolicyRequest },
    TContext
> => {
    const mutationOptions =
        usePutV1PolicySuperAdminPolicyIdMutationOptions(options);

    return useMutation(mutationOptions);
};

export const useGetV1TenantSuperAdminTenantIdHook = () => {
    const getV1TenantSuperAdminTenantId = useCustomAxios<TenantResponse>();

    return useCallback(
        (tenantId: number) => {
            return getV1TenantSuperAdminTenantId({
                url: `/v1/Tenant/SuperAdmin/${tenantId}`,
                method: 'GET',
            });
        },
        [getV1TenantSuperAdminTenantId]
    );
};

export const getGetV1TenantSuperAdminTenantIdQueryKey = (tenantId: number) => {
    return [`/v1/Tenant/SuperAdmin/${tenantId}`] as const;
};

export const useGetV1TenantSuperAdminTenantIdQueryOptions = <
    TData = Awaited<
        ReturnType<ReturnType<typeof useGetV1TenantSuperAdminTenantIdHook>>
    >,
    TError = ErrorType<void>
>(
    tenantId: number,
    options?: {
        query?: UseQueryOptions<
            Awaited<
                ReturnType<
                    ReturnType<typeof useGetV1TenantSuperAdminTenantIdHook>
                >
            >,
            TError,
            TData
        >;
    }
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getGetV1TenantSuperAdminTenantIdQueryKey(tenantId);

    const getV1TenantSuperAdminTenantId =
        useGetV1TenantSuperAdminTenantIdHook();

    const queryFn: QueryFunction<
        Awaited<
            ReturnType<ReturnType<typeof useGetV1TenantSuperAdminTenantIdHook>>
        >
    > = () => getV1TenantSuperAdminTenantId(tenantId);

    return {
        queryKey,
        queryFn,
        enabled: !!tenantId,
        ...queryOptions,
    } as UseQueryOptions<
        Awaited<
            ReturnType<ReturnType<typeof useGetV1TenantSuperAdminTenantIdHook>>
        >,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetV1TenantSuperAdminTenantIdQueryResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useGetV1TenantSuperAdminTenantIdHook>>>
>;
export type GetV1TenantSuperAdminTenantIdQueryError = ErrorType<void>;

export const useGetV1TenantSuperAdminTenantId = <
    TData = Awaited<
        ReturnType<ReturnType<typeof useGetV1TenantSuperAdminTenantIdHook>>
    >,
    TError = ErrorType<void>
>(
    tenantId: number,
    options?: {
        query?: UseQueryOptions<
            Awaited<
                ReturnType<
                    ReturnType<typeof useGetV1TenantSuperAdminTenantIdHook>
                >
            >,
            TError,
            TData
        >;
    }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
    const queryOptions = useGetV1TenantSuperAdminTenantIdQueryOptions(
        tenantId,
        options
    );

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
        queryKey: QueryKey;
    };

    query.queryKey = queryOptions.queryKey;

    return query;
};

export const usePutV1TenantSuperAdminTenantIdHook = () => {
    const putV1TenantSuperAdminTenantId = useCustomAxios<TenantResponse>();

    return useCallback(
        (tenantId: number, editTenantRequest: EditTenantRequest) => {
            return putV1TenantSuperAdminTenantId({
                url: `/v1/Tenant/SuperAdmin/${tenantId}`,
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                data: editTenantRequest,
            });
        },
        [putV1TenantSuperAdminTenantId]
    );
};

export const usePutV1TenantSuperAdminTenantIdMutationOptions = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<
            ReturnType<ReturnType<typeof usePutV1TenantSuperAdminTenantIdHook>>
        >,
        TError,
        { tenantId: number; data: EditTenantRequest },
        TContext
    >;
}): UseMutationOptions<
    Awaited<
        ReturnType<ReturnType<typeof usePutV1TenantSuperAdminTenantIdHook>>
    >,
    TError,
    { tenantId: number; data: EditTenantRequest },
    TContext
> => {
    const { mutation: mutationOptions } = options ?? {};

    const putV1TenantSuperAdminTenantId =
        usePutV1TenantSuperAdminTenantIdHook();

    const mutationFn: MutationFunction<
        Awaited<
            ReturnType<ReturnType<typeof usePutV1TenantSuperAdminTenantIdHook>>
        >,
        { tenantId: number; data: EditTenantRequest }
    > = (props) => {
        const { tenantId, data } = props ?? {};

        return putV1TenantSuperAdminTenantId(tenantId, data);
    };

    return { mutationFn, ...mutationOptions };
};

export type PutV1TenantSuperAdminTenantIdMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof usePutV1TenantSuperAdminTenantIdHook>>>
>;
export type PutV1TenantSuperAdminTenantIdMutationBody = EditTenantRequest;
export type PutV1TenantSuperAdminTenantIdMutationError = ErrorType<void>;

export const usePutV1TenantSuperAdminTenantId = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<
            ReturnType<ReturnType<typeof usePutV1TenantSuperAdminTenantIdHook>>
        >,
        TError,
        { tenantId: number; data: EditTenantRequest },
        TContext
    >;
}): UseMutationResult<
    Awaited<
        ReturnType<ReturnType<typeof usePutV1TenantSuperAdminTenantIdHook>>
    >,
    TError,
    { tenantId: number; data: EditTenantRequest },
    TContext
> => {
    const mutationOptions =
        usePutV1TenantSuperAdminTenantIdMutationOptions(options);

    return useMutation(mutationOptions);
};

export const useDeleteV1TenantSuperAdminTenantIdHook = () => {
    const deleteV1TenantSuperAdminTenantId = useCustomAxios<void>();

    return useCallback(
        (tenantId: number) => {
            return deleteV1TenantSuperAdminTenantId({
                url: `/v1/Tenant/SuperAdmin/${tenantId}`,
                method: 'DELETE',
            });
        },
        [deleteV1TenantSuperAdminTenantId]
    );
};

export const useDeleteV1TenantSuperAdminTenantIdMutationOptions = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<
            ReturnType<
                ReturnType<typeof useDeleteV1TenantSuperAdminTenantIdHook>
            >
        >,
        TError,
        { tenantId: number },
        TContext
    >;
}): UseMutationOptions<
    Awaited<
        ReturnType<ReturnType<typeof useDeleteV1TenantSuperAdminTenantIdHook>>
    >,
    TError,
    { tenantId: number },
    TContext
> => {
    const { mutation: mutationOptions } = options ?? {};

    const deleteV1TenantSuperAdminTenantId =
        useDeleteV1TenantSuperAdminTenantIdHook();

    const mutationFn: MutationFunction<
        Awaited<
            ReturnType<
                ReturnType<typeof useDeleteV1TenantSuperAdminTenantIdHook>
            >
        >,
        { tenantId: number }
    > = (props) => {
        const { tenantId } = props ?? {};

        return deleteV1TenantSuperAdminTenantId(tenantId);
    };

    return { mutationFn, ...mutationOptions };
};

export type DeleteV1TenantSuperAdminTenantIdMutationResult = NonNullable<
    Awaited<
        ReturnType<ReturnType<typeof useDeleteV1TenantSuperAdminTenantIdHook>>
    >
>;

export type DeleteV1TenantSuperAdminTenantIdMutationError = ErrorType<void>;

export const useDeleteV1TenantSuperAdminTenantId = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<
            ReturnType<
                ReturnType<typeof useDeleteV1TenantSuperAdminTenantIdHook>
            >
        >,
        TError,
        { tenantId: number },
        TContext
    >;
}): UseMutationResult<
    Awaited<
        ReturnType<ReturnType<typeof useDeleteV1TenantSuperAdminTenantIdHook>>
    >,
    TError,
    { tenantId: number },
    TContext
> => {
    const mutationOptions =
        useDeleteV1TenantSuperAdminTenantIdMutationOptions(options);

    return useMutation(mutationOptions);
};

export const useGetV1TenantSuperAdminHook = () => {
    const getV1TenantSuperAdmin = useCustomAxios<PaginatedTenantResponse>();

    return useCallback(
        (params?: GetV1TenantSuperAdminParams) => {
            return getV1TenantSuperAdmin({
                url: `/v1/Tenant/SuperAdmin`,
                method: 'GET',
                params,
            });
        },
        [getV1TenantSuperAdmin]
    );
};

export const getGetV1TenantSuperAdminQueryKey = (
    params?: GetV1TenantSuperAdminParams
) => {
    return [`/v1/Tenant/SuperAdmin`, ...(params ? [params] : [])] as const;
};

export const useGetV1TenantSuperAdminQueryOptions = <
    TData = Awaited<
        ReturnType<ReturnType<typeof useGetV1TenantSuperAdminHook>>
    >,
    TError = ErrorType<void>
>(
    params?: GetV1TenantSuperAdminParams,
    options?: {
        query?: UseQueryOptions<
            Awaited<
                ReturnType<ReturnType<typeof useGetV1TenantSuperAdminHook>>
            >,
            TError,
            TData
        >;
    }
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ?? getGetV1TenantSuperAdminQueryKey(params);

    const getV1TenantSuperAdmin = useGetV1TenantSuperAdminHook();

    const queryFn: QueryFunction<
        Awaited<ReturnType<ReturnType<typeof useGetV1TenantSuperAdminHook>>>
    > = () => getV1TenantSuperAdmin(params);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetV1TenantSuperAdminHook>>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetV1TenantSuperAdminQueryResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useGetV1TenantSuperAdminHook>>>
>;
export type GetV1TenantSuperAdminQueryError = ErrorType<void>;

export const useGetV1TenantSuperAdmin = <
    TData = Awaited<
        ReturnType<ReturnType<typeof useGetV1TenantSuperAdminHook>>
    >,
    TError = ErrorType<void>
>(
    params?: GetV1TenantSuperAdminParams,
    options?: {
        query?: UseQueryOptions<
            Awaited<
                ReturnType<ReturnType<typeof useGetV1TenantSuperAdminHook>>
            >,
            TError,
            TData
        >;
    }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
    const queryOptions = useGetV1TenantSuperAdminQueryOptions(params, options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
        queryKey: QueryKey;
    };

    query.queryKey = queryOptions.queryKey;

    return query;
};

export const usePostV1TenantSuperAdminHook = () => {
    const postV1TenantSuperAdmin = useCustomAxios<TenantResponse>();

    return useCallback(
        (createTenantRequest: CreateTenantRequest) => {
            return postV1TenantSuperAdmin({
                url: `/v1/Tenant/SuperAdmin`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: createTenantRequest,
            });
        },
        [postV1TenantSuperAdmin]
    );
};

export const usePostV1TenantSuperAdminMutationOptions = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof usePostV1TenantSuperAdminHook>>>,
        TError,
        { data: CreateTenantRequest },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof usePostV1TenantSuperAdminHook>>>,
    TError,
    { data: CreateTenantRequest },
    TContext
> => {
    const { mutation: mutationOptions } = options ?? {};

    const postV1TenantSuperAdmin = usePostV1TenantSuperAdminHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof usePostV1TenantSuperAdminHook>>>,
        { data: CreateTenantRequest }
    > = (props) => {
        const { data } = props ?? {};

        return postV1TenantSuperAdmin(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type PostV1TenantSuperAdminMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof usePostV1TenantSuperAdminHook>>>
>;
export type PostV1TenantSuperAdminMutationBody = CreateTenantRequest;
export type PostV1TenantSuperAdminMutationError = ErrorType<void>;

export const usePostV1TenantSuperAdmin = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof usePostV1TenantSuperAdminHook>>>,
        TError,
        { data: CreateTenantRequest },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof usePostV1TenantSuperAdminHook>>>,
    TError,
    { data: CreateTenantRequest },
    TContext
> => {
    const mutationOptions = usePostV1TenantSuperAdminMutationOptions(options);

    return useMutation(mutationOptions);
};

export const usePutV1TenantSuperAdminRestoreTenantIdHook = () => {
    const putV1TenantSuperAdminRestoreTenantId = useCustomAxios<void>();

    return useCallback(
        (
            tenantId: number,
            params?: PutV1TenantSuperAdminRestoreTenantIdParams
        ) => {
            return putV1TenantSuperAdminRestoreTenantId({
                url: `/v1/Tenant/SuperAdmin/restore/${tenantId}`,
                method: 'PUT',
                params,
            });
        },
        [putV1TenantSuperAdminRestoreTenantId]
    );
};

export const usePutV1TenantSuperAdminRestoreTenantIdMutationOptions = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<
            ReturnType<
                ReturnType<typeof usePutV1TenantSuperAdminRestoreTenantIdHook>
            >
        >,
        TError,
        {
            tenantId: number;
            params?: PutV1TenantSuperAdminRestoreTenantIdParams;
        },
        TContext
    >;
}): UseMutationOptions<
    Awaited<
        ReturnType<
            ReturnType<typeof usePutV1TenantSuperAdminRestoreTenantIdHook>
        >
    >,
    TError,
    { tenantId: number; params?: PutV1TenantSuperAdminRestoreTenantIdParams },
    TContext
> => {
    const { mutation: mutationOptions } = options ?? {};

    const putV1TenantSuperAdminRestoreTenantId =
        usePutV1TenantSuperAdminRestoreTenantIdHook();

    const mutationFn: MutationFunction<
        Awaited<
            ReturnType<
                ReturnType<typeof usePutV1TenantSuperAdminRestoreTenantIdHook>
            >
        >,
        {
            tenantId: number;
            params?: PutV1TenantSuperAdminRestoreTenantIdParams;
        }
    > = (props) => {
        const { tenantId, params } = props ?? {};

        return putV1TenantSuperAdminRestoreTenantId(tenantId, params);
    };

    return { mutationFn, ...mutationOptions };
};

export type PutV1TenantSuperAdminRestoreTenantIdMutationResult = NonNullable<
    Awaited<
        ReturnType<
            ReturnType<typeof usePutV1TenantSuperAdminRestoreTenantIdHook>
        >
    >
>;

export type PutV1TenantSuperAdminRestoreTenantIdMutationError = ErrorType<void>;

export const usePutV1TenantSuperAdminRestoreTenantId = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<
            ReturnType<
                ReturnType<typeof usePutV1TenantSuperAdminRestoreTenantIdHook>
            >
        >,
        TError,
        {
            tenantId: number;
            params?: PutV1TenantSuperAdminRestoreTenantIdParams;
        },
        TContext
    >;
}): UseMutationResult<
    Awaited<
        ReturnType<
            ReturnType<typeof usePutV1TenantSuperAdminRestoreTenantIdHook>
        >
    >,
    TError,
    { tenantId: number; params?: PutV1TenantSuperAdminRestoreTenantIdParams },
    TContext
> => {
    const mutationOptions =
        usePutV1TenantSuperAdminRestoreTenantIdMutationOptions(options);

    return useMutation(mutationOptions);
};

/**
 * @summary Upload a new Excel export template and map it to one or more document types.
 */
export const usePostV1TemplatesUploadExportTemplateHook = () => {
    const postV1TemplatesUploadExportTemplate = useCustomAxios<void>();

    return useCallback(
        (
            postV1TemplatesUploadExportTemplateBody: PostV1TemplatesUploadExportTemplateBody
        ) => {
            const formData = new FormData();
            formData.append(
                'TemplateName',
                postV1TemplatesUploadExportTemplateBody.TemplateName
            );
            if (
                postV1TemplatesUploadExportTemplateBody.DocumentTypeIds !==
                undefined
            ) {
                postV1TemplatesUploadExportTemplateBody.DocumentTypeIds.forEach(
                    (value) => formData.append('DocumentTypeIds', value)
                );
            }
            formData.append(
                'ExcelFile',
                postV1TemplatesUploadExportTemplateBody.ExcelFile
            );

            return postV1TemplatesUploadExportTemplate({
                url: `/v1/Templates/UploadExportTemplate`,
                method: 'POST',
                headers: { 'Content-Type': 'multipart/form-data' },
                data: formData,
            });
        },
        [postV1TemplatesUploadExportTemplate]
    );
};

export const usePostV1TemplatesUploadExportTemplateMutationOptions = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<
            ReturnType<
                ReturnType<typeof usePostV1TemplatesUploadExportTemplateHook>
            >
        >,
        TError,
        { data: PostV1TemplatesUploadExportTemplateBody },
        TContext
    >;
}): UseMutationOptions<
    Awaited<
        ReturnType<
            ReturnType<typeof usePostV1TemplatesUploadExportTemplateHook>
        >
    >,
    TError,
    { data: PostV1TemplatesUploadExportTemplateBody },
    TContext
> => {
    const { mutation: mutationOptions } = options ?? {};

    const postV1TemplatesUploadExportTemplate =
        usePostV1TemplatesUploadExportTemplateHook();

    const mutationFn: MutationFunction<
        Awaited<
            ReturnType<
                ReturnType<typeof usePostV1TemplatesUploadExportTemplateHook>
            >
        >,
        { data: PostV1TemplatesUploadExportTemplateBody }
    > = (props) => {
        const { data } = props ?? {};

        return postV1TemplatesUploadExportTemplate(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type PostV1TemplatesUploadExportTemplateMutationResult = NonNullable<
    Awaited<
        ReturnType<
            ReturnType<typeof usePostV1TemplatesUploadExportTemplateHook>
        >
    >
>;
export type PostV1TemplatesUploadExportTemplateMutationBody =
    PostV1TemplatesUploadExportTemplateBody;
export type PostV1TemplatesUploadExportTemplateMutationError = ErrorType<void>;

/**
 * @summary Upload a new Excel export template and map it to one or more document types.
 */
export const usePostV1TemplatesUploadExportTemplate = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<
            ReturnType<
                ReturnType<typeof usePostV1TemplatesUploadExportTemplateHook>
            >
        >,
        TError,
        { data: PostV1TemplatesUploadExportTemplateBody },
        TContext
    >;
}): UseMutationResult<
    Awaited<
        ReturnType<
            ReturnType<typeof usePostV1TemplatesUploadExportTemplateHook>
        >
    >,
    TError,
    { data: PostV1TemplatesUploadExportTemplateBody },
    TContext
> => {
    const mutationOptions =
        usePostV1TemplatesUploadExportTemplateMutationOptions(options);

    return useMutation(mutationOptions);
};

export const usePostV1TemplatesGetTemplatesHook = () => {
    const postV1TemplatesGetTemplates =
        useCustomAxios<GetExtractionTemplatesResponse[]>();

    return useCallback(
        (getExtractionTemplatesRequest: GetExtractionTemplatesRequest) => {
            return postV1TemplatesGetTemplates({
                url: `/v1/Templates/GetTemplates`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: getExtractionTemplatesRequest,
            });
        },
        [postV1TemplatesGetTemplates]
    );
};

export const usePostV1TemplatesGetTemplatesMutationOptions = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<
            ReturnType<ReturnType<typeof usePostV1TemplatesGetTemplatesHook>>
        >,
        TError,
        { data: GetExtractionTemplatesRequest },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof usePostV1TemplatesGetTemplatesHook>>>,
    TError,
    { data: GetExtractionTemplatesRequest },
    TContext
> => {
    const { mutation: mutationOptions } = options ?? {};

    const postV1TemplatesGetTemplates = usePostV1TemplatesGetTemplatesHook();

    const mutationFn: MutationFunction<
        Awaited<
            ReturnType<ReturnType<typeof usePostV1TemplatesGetTemplatesHook>>
        >,
        { data: GetExtractionTemplatesRequest }
    > = (props) => {
        const { data } = props ?? {};

        return postV1TemplatesGetTemplates(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type PostV1TemplatesGetTemplatesMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof usePostV1TemplatesGetTemplatesHook>>>
>;
export type PostV1TemplatesGetTemplatesMutationBody =
    GetExtractionTemplatesRequest;
export type PostV1TemplatesGetTemplatesMutationError = ErrorType<void>;

export const usePostV1TemplatesGetTemplates = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<
            ReturnType<ReturnType<typeof usePostV1TemplatesGetTemplatesHook>>
        >,
        TError,
        { data: GetExtractionTemplatesRequest },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof usePostV1TemplatesGetTemplatesHook>>>,
    TError,
    { data: GetExtractionTemplatesRequest },
    TContext
> => {
    const mutationOptions =
        usePostV1TemplatesGetTemplatesMutationOptions(options);

    return useMutation(mutationOptions);
};

export const usePostV1TemplatesDeactivateTemplateHook = () => {
    const postV1TemplatesDeactivateTemplate = useCustomAxios<void>();

    return useCallback(
        (
            deactivateExtractionTemplateRequest: DeactivateExtractionTemplateRequest
        ) => {
            return postV1TemplatesDeactivateTemplate({
                url: `/v1/Templates/DeactivateTemplate`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: deactivateExtractionTemplateRequest,
            });
        },
        [postV1TemplatesDeactivateTemplate]
    );
};

export const usePostV1TemplatesDeactivateTemplateMutationOptions = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<
            ReturnType<
                ReturnType<typeof usePostV1TemplatesDeactivateTemplateHook>
            >
        >,
        TError,
        { data: DeactivateExtractionTemplateRequest },
        TContext
    >;
}): UseMutationOptions<
    Awaited<
        ReturnType<ReturnType<typeof usePostV1TemplatesDeactivateTemplateHook>>
    >,
    TError,
    { data: DeactivateExtractionTemplateRequest },
    TContext
> => {
    const { mutation: mutationOptions } = options ?? {};

    const postV1TemplatesDeactivateTemplate =
        usePostV1TemplatesDeactivateTemplateHook();

    const mutationFn: MutationFunction<
        Awaited<
            ReturnType<
                ReturnType<typeof usePostV1TemplatesDeactivateTemplateHook>
            >
        >,
        { data: DeactivateExtractionTemplateRequest }
    > = (props) => {
        const { data } = props ?? {};

        return postV1TemplatesDeactivateTemplate(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type PostV1TemplatesDeactivateTemplateMutationResult = NonNullable<
    Awaited<
        ReturnType<ReturnType<typeof usePostV1TemplatesDeactivateTemplateHook>>
    >
>;
export type PostV1TemplatesDeactivateTemplateMutationBody =
    DeactivateExtractionTemplateRequest;
export type PostV1TemplatesDeactivateTemplateMutationError = ErrorType<void>;

export const usePostV1TemplatesDeactivateTemplate = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<
            ReturnType<
                ReturnType<typeof usePostV1TemplatesDeactivateTemplateHook>
            >
        >,
        TError,
        { data: DeactivateExtractionTemplateRequest },
        TContext
    >;
}): UseMutationResult<
    Awaited<
        ReturnType<ReturnType<typeof usePostV1TemplatesDeactivateTemplateHook>>
    >,
    TError,
    { data: DeactivateExtractionTemplateRequest },
    TContext
> => {
    const mutationOptions =
        usePostV1TemplatesDeactivateTemplateMutationOptions(options);

    return useMutation(mutationOptions);
};

export const usePostV1TemplatesExtractionExportHook = () => {
    const postV1TemplatesExtractionExport =
        useCustomAxios<ExtractionExportResponse>();

    return useCallback(
        (extractionExportRequest: ExtractionExportRequest) => {
            return postV1TemplatesExtractionExport({
                url: `/v1/Templates/ExtractionExport`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: extractionExportRequest,
            });
        },
        [postV1TemplatesExtractionExport]
    );
};

export const usePostV1TemplatesExtractionExportMutationOptions = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<
            ReturnType<
                ReturnType<typeof usePostV1TemplatesExtractionExportHook>
            >
        >,
        TError,
        { data: ExtractionExportRequest },
        TContext
    >;
}): UseMutationOptions<
    Awaited<
        ReturnType<ReturnType<typeof usePostV1TemplatesExtractionExportHook>>
    >,
    TError,
    { data: ExtractionExportRequest },
    TContext
> => {
    const { mutation: mutationOptions } = options ?? {};

    const postV1TemplatesExtractionExport =
        usePostV1TemplatesExtractionExportHook();

    const mutationFn: MutationFunction<
        Awaited<
            ReturnType<
                ReturnType<typeof usePostV1TemplatesExtractionExportHook>
            >
        >,
        { data: ExtractionExportRequest }
    > = (props) => {
        const { data } = props ?? {};

        return postV1TemplatesExtractionExport(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type PostV1TemplatesExtractionExportMutationResult = NonNullable<
    Awaited<
        ReturnType<ReturnType<typeof usePostV1TemplatesExtractionExportHook>>
    >
>;
export type PostV1TemplatesExtractionExportMutationBody =
    ExtractionExportRequest;
export type PostV1TemplatesExtractionExportMutationError = ErrorType<void>;

export const usePostV1TemplatesExtractionExport = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<
            ReturnType<
                ReturnType<typeof usePostV1TemplatesExtractionExportHook>
            >
        >,
        TError,
        { data: ExtractionExportRequest },
        TContext
    >;
}): UseMutationResult<
    Awaited<
        ReturnType<ReturnType<typeof usePostV1TemplatesExtractionExportHook>>
    >,
    TError,
    { data: ExtractionExportRequest },
    TContext
> => {
    const mutationOptions =
        usePostV1TemplatesExtractionExportMutationOptions(options);

    return useMutation(mutationOptions);
};

export const usePostV1TemplatesChatWithExtractionHook = () => {
    const postV1TemplatesChatWithExtraction =
        useCustomAxios<ChatWithExtractionResponse>();

    return useCallback(
        (chatWithExtractionRequest: ChatWithExtractionRequest) => {
            return postV1TemplatesChatWithExtraction({
                url: `/v1/Templates/ChatWithExtraction`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: chatWithExtractionRequest,
            });
        },
        [postV1TemplatesChatWithExtraction]
    );
};

export const usePostV1TemplatesChatWithExtractionMutationOptions = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<
            ReturnType<
                ReturnType<typeof usePostV1TemplatesChatWithExtractionHook>
            >
        >,
        TError,
        { data: ChatWithExtractionRequest },
        TContext
    >;
}): UseMutationOptions<
    Awaited<
        ReturnType<ReturnType<typeof usePostV1TemplatesChatWithExtractionHook>>
    >,
    TError,
    { data: ChatWithExtractionRequest },
    TContext
> => {
    const { mutation: mutationOptions } = options ?? {};

    const postV1TemplatesChatWithExtraction =
        usePostV1TemplatesChatWithExtractionHook();

    const mutationFn: MutationFunction<
        Awaited<
            ReturnType<
                ReturnType<typeof usePostV1TemplatesChatWithExtractionHook>
            >
        >,
        { data: ChatWithExtractionRequest }
    > = (props) => {
        const { data } = props ?? {};

        return postV1TemplatesChatWithExtraction(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type PostV1TemplatesChatWithExtractionMutationResult = NonNullable<
    Awaited<
        ReturnType<ReturnType<typeof usePostV1TemplatesChatWithExtractionHook>>
    >
>;
export type PostV1TemplatesChatWithExtractionMutationBody =
    ChatWithExtractionRequest;
export type PostV1TemplatesChatWithExtractionMutationError = ErrorType<void>;

export const usePostV1TemplatesChatWithExtraction = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<
            ReturnType<
                ReturnType<typeof usePostV1TemplatesChatWithExtractionHook>
            >
        >,
        TError,
        { data: ChatWithExtractionRequest },
        TContext
    >;
}): UseMutationResult<
    Awaited<
        ReturnType<ReturnType<typeof usePostV1TemplatesChatWithExtractionHook>>
    >,
    TError,
    { data: ChatWithExtractionRequest },
    TContext
> => {
    const mutationOptions =
        usePostV1TemplatesChatWithExtractionMutationOptions(options);

    return useMutation(mutationOptions);
};

export const useGetV1TemplatesDownloadExportTemplateHook = () => {
    const getV1TemplatesDownloadExportTemplate =
        useCustomAxios<DownloadExportTemplateResponse>();

    return useCallback(
        (params?: GetV1TemplatesDownloadExportTemplateParams) => {
            return getV1TemplatesDownloadExportTemplate({
                url: `/v1/Templates/DownloadExportTemplate`,
                method: 'GET',
                params,
            });
        },
        [getV1TemplatesDownloadExportTemplate]
    );
};

export const getGetV1TemplatesDownloadExportTemplateQueryKey = (
    params?: GetV1TemplatesDownloadExportTemplateParams
) => {
    return [
        `/v1/Templates/DownloadExportTemplate`,
        ...(params ? [params] : []),
    ] as const;
};

export const useGetV1TemplatesDownloadExportTemplateQueryOptions = <
    TData = Awaited<
        ReturnType<
            ReturnType<typeof useGetV1TemplatesDownloadExportTemplateHook>
        >
    >,
    TError = ErrorType<void>
>(
    params?: GetV1TemplatesDownloadExportTemplateParams,
    options?: {
        query?: UseQueryOptions<
            Awaited<
                ReturnType<
                    ReturnType<
                        typeof useGetV1TemplatesDownloadExportTemplateHook
                    >
                >
            >,
            TError,
            TData
        >;
    }
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getGetV1TemplatesDownloadExportTemplateQueryKey(params);

    const getV1TemplatesDownloadExportTemplate =
        useGetV1TemplatesDownloadExportTemplateHook();

    const queryFn: QueryFunction<
        Awaited<
            ReturnType<
                ReturnType<typeof useGetV1TemplatesDownloadExportTemplateHook>
            >
        >
    > = () => getV1TemplatesDownloadExportTemplate(params);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<
            ReturnType<
                ReturnType<typeof useGetV1TemplatesDownloadExportTemplateHook>
            >
        >,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetV1TemplatesDownloadExportTemplateQueryResult = NonNullable<
    Awaited<
        ReturnType<
            ReturnType<typeof useGetV1TemplatesDownloadExportTemplateHook>
        >
    >
>;
export type GetV1TemplatesDownloadExportTemplateQueryError = ErrorType<void>;

export const useGetV1TemplatesDownloadExportTemplate = <
    TData = Awaited<
        ReturnType<
            ReturnType<typeof useGetV1TemplatesDownloadExportTemplateHook>
        >
    >,
    TError = ErrorType<void>
>(
    params?: GetV1TemplatesDownloadExportTemplateParams,
    options?: {
        query?: UseQueryOptions<
            Awaited<
                ReturnType<
                    ReturnType<
                        typeof useGetV1TemplatesDownloadExportTemplateHook
                    >
                >
            >,
            TError,
            TData
        >;
    }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
    const queryOptions = useGetV1TemplatesDownloadExportTemplateQueryOptions(
        params,
        options
    );

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
        queryKey: QueryKey;
    };

    query.queryKey = queryOptions.queryKey;

    return query;
};

export const usePostV1TemplatesDownloadExampleExportTemplateHook = () => {
    const postV1TemplatesDownloadExampleExportTemplate =
        useCustomAxios<DownloadExampleExportTemplateResponse>();

    return useCallback(
        (
            downloadExampleExportTemplateRequest: DownloadExampleExportTemplateRequest
        ) => {
            return postV1TemplatesDownloadExampleExportTemplate({
                url: `/v1/Templates/DownloadExampleExportTemplate`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: downloadExampleExportTemplateRequest,
            });
        },
        [postV1TemplatesDownloadExampleExportTemplate]
    );
};

export const usePostV1TemplatesDownloadExampleExportTemplateMutationOptions = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<
            ReturnType<
                ReturnType<
                    typeof usePostV1TemplatesDownloadExampleExportTemplateHook
                >
            >
        >,
        TError,
        { data: DownloadExampleExportTemplateRequest },
        TContext
    >;
}): UseMutationOptions<
    Awaited<
        ReturnType<
            ReturnType<
                typeof usePostV1TemplatesDownloadExampleExportTemplateHook
            >
        >
    >,
    TError,
    { data: DownloadExampleExportTemplateRequest },
    TContext
> => {
    const { mutation: mutationOptions } = options ?? {};

    const postV1TemplatesDownloadExampleExportTemplate =
        usePostV1TemplatesDownloadExampleExportTemplateHook();

    const mutationFn: MutationFunction<
        Awaited<
            ReturnType<
                ReturnType<
                    typeof usePostV1TemplatesDownloadExampleExportTemplateHook
                >
            >
        >,
        { data: DownloadExampleExportTemplateRequest }
    > = (props) => {
        const { data } = props ?? {};

        return postV1TemplatesDownloadExampleExportTemplate(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type PostV1TemplatesDownloadExampleExportTemplateMutationResult =
    NonNullable<
        Awaited<
            ReturnType<
                ReturnType<
                    typeof usePostV1TemplatesDownloadExampleExportTemplateHook
                >
            >
        >
    >;
export type PostV1TemplatesDownloadExampleExportTemplateMutationBody =
    DownloadExampleExportTemplateRequest;
export type PostV1TemplatesDownloadExampleExportTemplateMutationError =
    ErrorType<void>;

export const usePostV1TemplatesDownloadExampleExportTemplate = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<
            ReturnType<
                ReturnType<
                    typeof usePostV1TemplatesDownloadExampleExportTemplateHook
                >
            >
        >,
        TError,
        { data: DownloadExampleExportTemplateRequest },
        TContext
    >;
}): UseMutationResult<
    Awaited<
        ReturnType<
            ReturnType<
                typeof usePostV1TemplatesDownloadExampleExportTemplateHook
            >
        >
    >,
    TError,
    { data: DownloadExampleExportTemplateRequest },
    TContext
> => {
    const mutationOptions =
        usePostV1TemplatesDownloadExampleExportTemplateMutationOptions(options);

    return useMutation(mutationOptions);
};

export const useGetV1TenantHook = () => {
    const getV1Tenant = useCustomAxios<TenantResponse>();

    return useCallback(() => {
        return getV1Tenant({ url: `/v1/Tenant`, method: 'GET' });
    }, [getV1Tenant]);
};

export const getGetV1TenantQueryKey = () => {
    return [`/v1/Tenant`] as const;
};

export const useGetV1TenantQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetV1TenantHook>>>,
    TError = ErrorType<void>
>(options?: {
    query?: UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetV1TenantHook>>>,
        TError,
        TData
    >;
}) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetV1TenantQueryKey();

    const getV1Tenant = useGetV1TenantHook();

    const queryFn: QueryFunction<
        Awaited<ReturnType<ReturnType<typeof useGetV1TenantHook>>>
    > = () => getV1Tenant();

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetV1TenantHook>>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetV1TenantQueryResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useGetV1TenantHook>>>
>;
export type GetV1TenantQueryError = ErrorType<void>;

export const useGetV1Tenant = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetV1TenantHook>>>,
    TError = ErrorType<void>
>(options?: {
    query?: UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetV1TenantHook>>>,
        TError,
        TData
    >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
    const queryOptions = useGetV1TenantQueryOptions(options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
        queryKey: QueryKey;
    };

    query.queryKey = queryOptions.queryKey;

    return query;
};

export const usePostV1UploadUploadDocumentsRequestHook = () => {
    const postV1UploadUploadDocumentsRequest =
        useCustomAxios<UploadDocumentsResponseModel>();

    return useCallback(
        (uploadDocumentsRequestModel: UploadDocumentsRequestModel) => {
            return postV1UploadUploadDocumentsRequest({
                url: `/v1/Upload/UploadDocumentsRequest`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: uploadDocumentsRequestModel,
            });
        },
        [postV1UploadUploadDocumentsRequest]
    );
};

export const usePostV1UploadUploadDocumentsRequestMutationOptions = <
    TError = ErrorType<unknown>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<
            ReturnType<
                ReturnType<typeof usePostV1UploadUploadDocumentsRequestHook>
            >
        >,
        TError,
        { data: UploadDocumentsRequestModel },
        TContext
    >;
}): UseMutationOptions<
    Awaited<
        ReturnType<ReturnType<typeof usePostV1UploadUploadDocumentsRequestHook>>
    >,
    TError,
    { data: UploadDocumentsRequestModel },
    TContext
> => {
    const { mutation: mutationOptions } = options ?? {};

    const postV1UploadUploadDocumentsRequest =
        usePostV1UploadUploadDocumentsRequestHook();

    const mutationFn: MutationFunction<
        Awaited<
            ReturnType<
                ReturnType<typeof usePostV1UploadUploadDocumentsRequestHook>
            >
        >,
        { data: UploadDocumentsRequestModel }
    > = (props) => {
        const { data } = props ?? {};

        return postV1UploadUploadDocumentsRequest(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type PostV1UploadUploadDocumentsRequestMutationResult = NonNullable<
    Awaited<
        ReturnType<ReturnType<typeof usePostV1UploadUploadDocumentsRequestHook>>
    >
>;
export type PostV1UploadUploadDocumentsRequestMutationBody =
    UploadDocumentsRequestModel;
export type PostV1UploadUploadDocumentsRequestMutationError =
    ErrorType<unknown>;

export const usePostV1UploadUploadDocumentsRequest = <
    TError = ErrorType<unknown>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<
            ReturnType<
                ReturnType<typeof usePostV1UploadUploadDocumentsRequestHook>
            >
        >,
        TError,
        { data: UploadDocumentsRequestModel },
        TContext
    >;
}): UseMutationResult<
    Awaited<
        ReturnType<ReturnType<typeof usePostV1UploadUploadDocumentsRequestHook>>
    >,
    TError,
    { data: UploadDocumentsRequestModel },
    TContext
> => {
    const mutationOptions =
        usePostV1UploadUploadDocumentsRequestMutationOptions(options);

    return useMutation(mutationOptions);
};

export const usePostV1UploadUploadRequestCompleteHook = () => {
    const postV1UploadUploadRequestComplete = useCustomAxios<void>();

    return useCallback(
        (uploadRequestCompleteModel: UploadRequestCompleteModel) => {
            return postV1UploadUploadRequestComplete({
                url: `/v1/Upload/UploadRequestComplete`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: uploadRequestCompleteModel,
            });
        },
        [postV1UploadUploadRequestComplete]
    );
};

export const usePostV1UploadUploadRequestCompleteMutationOptions = <
    TError = ErrorType<unknown>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<
            ReturnType<
                ReturnType<typeof usePostV1UploadUploadRequestCompleteHook>
            >
        >,
        TError,
        { data: UploadRequestCompleteModel },
        TContext
    >;
}): UseMutationOptions<
    Awaited<
        ReturnType<ReturnType<typeof usePostV1UploadUploadRequestCompleteHook>>
    >,
    TError,
    { data: UploadRequestCompleteModel },
    TContext
> => {
    const { mutation: mutationOptions } = options ?? {};

    const postV1UploadUploadRequestComplete =
        usePostV1UploadUploadRequestCompleteHook();

    const mutationFn: MutationFunction<
        Awaited<
            ReturnType<
                ReturnType<typeof usePostV1UploadUploadRequestCompleteHook>
            >
        >,
        { data: UploadRequestCompleteModel }
    > = (props) => {
        const { data } = props ?? {};

        return postV1UploadUploadRequestComplete(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type PostV1UploadUploadRequestCompleteMutationResult = NonNullable<
    Awaited<
        ReturnType<ReturnType<typeof usePostV1UploadUploadRequestCompleteHook>>
    >
>;
export type PostV1UploadUploadRequestCompleteMutationBody =
    UploadRequestCompleteModel;
export type PostV1UploadUploadRequestCompleteMutationError = ErrorType<unknown>;

export const usePostV1UploadUploadRequestComplete = <
    TError = ErrorType<unknown>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<
            ReturnType<
                ReturnType<typeof usePostV1UploadUploadRequestCompleteHook>
            >
        >,
        TError,
        { data: UploadRequestCompleteModel },
        TContext
    >;
}): UseMutationResult<
    Awaited<
        ReturnType<ReturnType<typeof usePostV1UploadUploadRequestCompleteHook>>
    >,
    TError,
    { data: UploadRequestCompleteModel },
    TContext
> => {
    const mutationOptions =
        usePostV1UploadUploadRequestCompleteMutationOptions(options);

    return useMutation(mutationOptions);
};

export const usePostV1UploadDeleteUploadedDocumentHook = () => {
    const postV1UploadDeleteUploadedDocument = useCustomAxios<void>();

    return useCallback(
        (
            deleteUploadedDocumentRequestModel: DeleteUploadedDocumentRequestModel
        ) => {
            return postV1UploadDeleteUploadedDocument({
                url: `/v1/Upload/DeleteUploadedDocument`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: deleteUploadedDocumentRequestModel,
            });
        },
        [postV1UploadDeleteUploadedDocument]
    );
};

export const usePostV1UploadDeleteUploadedDocumentMutationOptions = <
    TError = ErrorType<unknown>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<
            ReturnType<
                ReturnType<typeof usePostV1UploadDeleteUploadedDocumentHook>
            >
        >,
        TError,
        { data: DeleteUploadedDocumentRequestModel },
        TContext
    >;
}): UseMutationOptions<
    Awaited<
        ReturnType<ReturnType<typeof usePostV1UploadDeleteUploadedDocumentHook>>
    >,
    TError,
    { data: DeleteUploadedDocumentRequestModel },
    TContext
> => {
    const { mutation: mutationOptions } = options ?? {};

    const postV1UploadDeleteUploadedDocument =
        usePostV1UploadDeleteUploadedDocumentHook();

    const mutationFn: MutationFunction<
        Awaited<
            ReturnType<
                ReturnType<typeof usePostV1UploadDeleteUploadedDocumentHook>
            >
        >,
        { data: DeleteUploadedDocumentRequestModel }
    > = (props) => {
        const { data } = props ?? {};

        return postV1UploadDeleteUploadedDocument(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type PostV1UploadDeleteUploadedDocumentMutationResult = NonNullable<
    Awaited<
        ReturnType<ReturnType<typeof usePostV1UploadDeleteUploadedDocumentHook>>
    >
>;
export type PostV1UploadDeleteUploadedDocumentMutationBody =
    DeleteUploadedDocumentRequestModel;
export type PostV1UploadDeleteUploadedDocumentMutationError =
    ErrorType<unknown>;

export const usePostV1UploadDeleteUploadedDocument = <
    TError = ErrorType<unknown>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<
            ReturnType<
                ReturnType<typeof usePostV1UploadDeleteUploadedDocumentHook>
            >
        >,
        TError,
        { data: DeleteUploadedDocumentRequestModel },
        TContext
    >;
}): UseMutationResult<
    Awaited<
        ReturnType<ReturnType<typeof usePostV1UploadDeleteUploadedDocumentHook>>
    >,
    TError,
    { data: DeleteUploadedDocumentRequestModel },
    TContext
> => {
    const mutationOptions =
        usePostV1UploadDeleteUploadedDocumentMutationOptions(options);

    return useMutation(mutationOptions);
};

/**
 * @summary Returns a list of all users for the requesting user's tenant
Super Admins are able to specify a TenantId from which the users are retrieved
 */
export const useGetV1UserAdminHook = () => {
    const getV1UserAdmin = useCustomAxios<PaginatedUserResponse>();

    return useCallback(
        (params?: GetV1UserAdminParams) => {
            return getV1UserAdmin({
                url: `/v1/User/Admin`,
                method: 'GET',
                params,
            });
        },
        [getV1UserAdmin]
    );
};

export const getGetV1UserAdminQueryKey = (params?: GetV1UserAdminParams) => {
    return [`/v1/User/Admin`, ...(params ? [params] : [])] as const;
};

export const useGetV1UserAdminQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetV1UserAdminHook>>>,
    TError = ErrorType<void>
>(
    params?: GetV1UserAdminParams,
    options?: {
        query?: UseQueryOptions<
            Awaited<ReturnType<ReturnType<typeof useGetV1UserAdminHook>>>,
            TError,
            TData
        >;
    }
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ?? getGetV1UserAdminQueryKey(params);

    const getV1UserAdmin = useGetV1UserAdminHook();

    const queryFn: QueryFunction<
        Awaited<ReturnType<ReturnType<typeof useGetV1UserAdminHook>>>
    > = () => getV1UserAdmin(params);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetV1UserAdminHook>>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetV1UserAdminQueryResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useGetV1UserAdminHook>>>
>;
export type GetV1UserAdminQueryError = ErrorType<void>;

/**
 * @summary Returns a list of all users for the requesting user's tenant
Super Admins are able to specify a TenantId from which the users are retrieved
 */
export const useGetV1UserAdmin = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetV1UserAdminHook>>>,
    TError = ErrorType<void>
>(
    params?: GetV1UserAdminParams,
    options?: {
        query?: UseQueryOptions<
            Awaited<ReturnType<ReturnType<typeof useGetV1UserAdminHook>>>,
            TError,
            TData
        >;
    }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
    const queryOptions = useGetV1UserAdminQueryOptions(params, options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
        queryKey: QueryKey;
    };

    query.queryKey = queryOptions.queryKey;

    return query;
};

/**
 * @summary Create a new user
 */
export const usePostV1UserAdminHook = () => {
    const postV1UserAdmin = useCustomAxios<UserResponse>();

    return useCallback(
        (createUserRequest: CreateUserRequest) => {
            return postV1UserAdmin({
                url: `/v1/User/Admin`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: createUserRequest,
            });
        },
        [postV1UserAdmin]
    );
};

export const usePostV1UserAdminMutationOptions = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof usePostV1UserAdminHook>>>,
        TError,
        { data: CreateUserRequest },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof usePostV1UserAdminHook>>>,
    TError,
    { data: CreateUserRequest },
    TContext
> => {
    const { mutation: mutationOptions } = options ?? {};

    const postV1UserAdmin = usePostV1UserAdminHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof usePostV1UserAdminHook>>>,
        { data: CreateUserRequest }
    > = (props) => {
        const { data } = props ?? {};

        return postV1UserAdmin(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type PostV1UserAdminMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof usePostV1UserAdminHook>>>
>;
export type PostV1UserAdminMutationBody = CreateUserRequest;
export type PostV1UserAdminMutationError = ErrorType<void>;

/**
 * @summary Create a new user
 */
export const usePostV1UserAdmin = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof usePostV1UserAdminHook>>>,
        TError,
        { data: CreateUserRequest },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof usePostV1UserAdminHook>>>,
    TError,
    { data: CreateUserRequest },
    TContext
> => {
    const mutationOptions = usePostV1UserAdminMutationOptions(options);

    return useMutation(mutationOptions);
};

/**
 * @summary Edit an existing user
 */
export const usePutV1UserAdminUserIdHook = () => {
    const putV1UserAdminUserId = useCustomAxios<UserResponse>();

    return useCallback(
        (userId: number, editUserRequest: EditUserRequest) => {
            return putV1UserAdminUserId({
                url: `/v1/User/Admin/${userId}`,
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                data: editUserRequest,
            });
        },
        [putV1UserAdminUserId]
    );
};

export const usePutV1UserAdminUserIdMutationOptions = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof usePutV1UserAdminUserIdHook>>>,
        TError,
        { userId: number; data: EditUserRequest },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof usePutV1UserAdminUserIdHook>>>,
    TError,
    { userId: number; data: EditUserRequest },
    TContext
> => {
    const { mutation: mutationOptions } = options ?? {};

    const putV1UserAdminUserId = usePutV1UserAdminUserIdHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof usePutV1UserAdminUserIdHook>>>,
        { userId: number; data: EditUserRequest }
    > = (props) => {
        const { userId, data } = props ?? {};

        return putV1UserAdminUserId(userId, data);
    };

    return { mutationFn, ...mutationOptions };
};

export type PutV1UserAdminUserIdMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof usePutV1UserAdminUserIdHook>>>
>;
export type PutV1UserAdminUserIdMutationBody = EditUserRequest;
export type PutV1UserAdminUserIdMutationError = ErrorType<void>;

/**
 * @summary Edit an existing user
 */
export const usePutV1UserAdminUserId = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof usePutV1UserAdminUserIdHook>>>,
        TError,
        { userId: number; data: EditUserRequest },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof usePutV1UserAdminUserIdHook>>>,
    TError,
    { userId: number; data: EditUserRequest },
    TContext
> => {
    const mutationOptions = usePutV1UserAdminUserIdMutationOptions(options);

    return useMutation(mutationOptions);
};

/**
 * @summary Soft delete an existing user
 */
export const useDeleteV1UserAdminUserIdHook = () => {
    const deleteV1UserAdminUserId = useCustomAxios<void>();

    return useCallback(
        (userId: number) => {
            return deleteV1UserAdminUserId({
                url: `/v1/User/Admin/${userId}`,
                method: 'DELETE',
            });
        },
        [deleteV1UserAdminUserId]
    );
};

export const useDeleteV1UserAdminUserIdMutationOptions = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useDeleteV1UserAdminUserIdHook>>>,
        TError,
        { userId: number },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useDeleteV1UserAdminUserIdHook>>>,
    TError,
    { userId: number },
    TContext
> => {
    const { mutation: mutationOptions } = options ?? {};

    const deleteV1UserAdminUserId = useDeleteV1UserAdminUserIdHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useDeleteV1UserAdminUserIdHook>>>,
        { userId: number }
    > = (props) => {
        const { userId } = props ?? {};

        return deleteV1UserAdminUserId(userId);
    };

    return { mutationFn, ...mutationOptions };
};

export type DeleteV1UserAdminUserIdMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useDeleteV1UserAdminUserIdHook>>>
>;

export type DeleteV1UserAdminUserIdMutationError = ErrorType<void>;

/**
 * @summary Soft delete an existing user
 */
export const useDeleteV1UserAdminUserId = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useDeleteV1UserAdminUserIdHook>>>,
        TError,
        { userId: number },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useDeleteV1UserAdminUserIdHook>>>,
    TError,
    { userId: number },
    TContext
> => {
    const mutationOptions = useDeleteV1UserAdminUserIdMutationOptions(options);

    return useMutation(mutationOptions);
};

/**
 * @summary Restore deleted user
 */
export const usePutV1UserAdminRestoreUserIdHook = () => {
    const putV1UserAdminRestoreUserId = useCustomAxios<void>();

    return useCallback(
        (userId: number) => {
            return putV1UserAdminRestoreUserId({
                url: `/v1/User/Admin/restore/${userId}`,
                method: 'PUT',
            });
        },
        [putV1UserAdminRestoreUserId]
    );
};

export const usePutV1UserAdminRestoreUserIdMutationOptions = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<
            ReturnType<ReturnType<typeof usePutV1UserAdminRestoreUserIdHook>>
        >,
        TError,
        { userId: number },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof usePutV1UserAdminRestoreUserIdHook>>>,
    TError,
    { userId: number },
    TContext
> => {
    const { mutation: mutationOptions } = options ?? {};

    const putV1UserAdminRestoreUserId = usePutV1UserAdminRestoreUserIdHook();

    const mutationFn: MutationFunction<
        Awaited<
            ReturnType<ReturnType<typeof usePutV1UserAdminRestoreUserIdHook>>
        >,
        { userId: number }
    > = (props) => {
        const { userId } = props ?? {};

        return putV1UserAdminRestoreUserId(userId);
    };

    return { mutationFn, ...mutationOptions };
};

export type PutV1UserAdminRestoreUserIdMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof usePutV1UserAdminRestoreUserIdHook>>>
>;

export type PutV1UserAdminRestoreUserIdMutationError = ErrorType<void>;

/**
 * @summary Restore deleted user
 */
export const usePutV1UserAdminRestoreUserId = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<
            ReturnType<ReturnType<typeof usePutV1UserAdminRestoreUserIdHook>>
        >,
        TError,
        { userId: number },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof usePutV1UserAdminRestoreUserIdHook>>>,
    TError,
    { userId: number },
    TContext
> => {
    const mutationOptions =
        usePutV1UserAdminRestoreUserIdMutationOptions(options);

    return useMutation(mutationOptions);
};

export const useGetV1UserPreferencesHook = () => {
    const getV1UserPreferences = useCustomAxios<UserPreferencesResponse>();

    return useCallback(() => {
        return getV1UserPreferences({
            url: `/v1/User/Preferences`,
            method: 'GET',
        });
    }, [getV1UserPreferences]);
};

export const getGetV1UserPreferencesQueryKey = () => {
    return [`/v1/User/Preferences`] as const;
};

export const useGetV1UserPreferencesQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetV1UserPreferencesHook>>>,
    TError = ErrorType<void>
>(options?: {
    query?: UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetV1UserPreferencesHook>>>,
        TError,
        TData
    >;
}) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ?? getGetV1UserPreferencesQueryKey();

    const getV1UserPreferences = useGetV1UserPreferencesHook();

    const queryFn: QueryFunction<
        Awaited<ReturnType<ReturnType<typeof useGetV1UserPreferencesHook>>>
    > = () => getV1UserPreferences();

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetV1UserPreferencesHook>>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetV1UserPreferencesQueryResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useGetV1UserPreferencesHook>>>
>;
export type GetV1UserPreferencesQueryError = ErrorType<void>;

export const useGetV1UserPreferences = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetV1UserPreferencesHook>>>,
    TError = ErrorType<void>
>(options?: {
    query?: UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetV1UserPreferencesHook>>>,
        TError,
        TData
    >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
    const queryOptions = useGetV1UserPreferencesQueryOptions(options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
        queryKey: QueryKey;
    };

    query.queryKey = queryOptions.queryKey;

    return query;
};

export const usePutV1UserPreferencesHook = () => {
    const putV1UserPreferences = useCustomAxios<UserPreferencesResponse>();

    return useCallback(
        (userPreferencesRequest: UserPreferencesRequest) => {
            return putV1UserPreferences({
                url: `/v1/User/Preferences`,
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                data: userPreferencesRequest,
            });
        },
        [putV1UserPreferences]
    );
};

export const usePutV1UserPreferencesMutationOptions = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof usePutV1UserPreferencesHook>>>,
        TError,
        { data: UserPreferencesRequest },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof usePutV1UserPreferencesHook>>>,
    TError,
    { data: UserPreferencesRequest },
    TContext
> => {
    const { mutation: mutationOptions } = options ?? {};

    const putV1UserPreferences = usePutV1UserPreferencesHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof usePutV1UserPreferencesHook>>>,
        { data: UserPreferencesRequest }
    > = (props) => {
        const { data } = props ?? {};

        return putV1UserPreferences(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type PutV1UserPreferencesMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof usePutV1UserPreferencesHook>>>
>;
export type PutV1UserPreferencesMutationBody = UserPreferencesRequest;
export type PutV1UserPreferencesMutationError = ErrorType<void>;

export const usePutV1UserPreferences = <
    TError = ErrorType<void>,
    TContext = unknown
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof usePutV1UserPreferencesHook>>>,
        TError,
        { data: UserPreferencesRequest },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof usePutV1UserPreferencesHook>>>,
    TError,
    { data: UserPreferencesRequest },
    TContext
> => {
    const mutationOptions = usePutV1UserPreferencesMutationOptions(options);

    return useMutation(mutationOptions);
};

export const useGetV1VersionHook = () => {
    const getV1Version = useCustomAxios<ApplicationVersionResponse>();

    return useCallback(() => {
        return getV1Version({ url: `/v1/Version`, method: 'GET' });
    }, [getV1Version]);
};

export const getGetV1VersionQueryKey = () => {
    return [`/v1/Version`] as const;
};

export const useGetV1VersionQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetV1VersionHook>>>,
    TError = ErrorType<unknown>
>(options?: {
    query?: UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetV1VersionHook>>>,
        TError,
        TData
    >;
}) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetV1VersionQueryKey();

    const getV1Version = useGetV1VersionHook();

    const queryFn: QueryFunction<
        Awaited<ReturnType<ReturnType<typeof useGetV1VersionHook>>>
    > = () => getV1Version();

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetV1VersionHook>>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetV1VersionQueryResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useGetV1VersionHook>>>
>;
export type GetV1VersionQueryError = ErrorType<unknown>;

export const useGetV1Version = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetV1VersionHook>>>,
    TError = ErrorType<unknown>
>(options?: {
    query?: UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetV1VersionHook>>>,
        TError,
        TData
    >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
    const queryOptions = useGetV1VersionQueryOptions(options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
        queryKey: QueryKey;
    };

    query.queryKey = queryOptions.queryKey;

    return query;
};
